import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  TemplateRef,
  ElementRef,
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { CommonService } from "../../common.service";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { DatePipe } from "@angular/common";
import { ValidationService } from "src/app/validation.service";
import { Subject } from "rxjs";
import * as XLSX from "xlsx";
import { ExcelServiceService } from "../../excel-service.service";
import * as moment from "moment";
import { CommonVariablesService } from "../../common-variables.service";

const Moment = require("moment");

@Component({
  selector: "app-certificate",
  templateUrl: "./certificate.component.html",
  styleUrls: ["./certificate.component.css"],
})
export class CertificateComponent implements OnInit, OnDestroy {
  @ViewChild("uwCase") uwCase: TemplateRef<any>;
  @ViewChild("draftDelete") draftDelete: TemplateRef<any>;
  //
  @ViewChild("excelTbl") excelTbl: TemplateRef<any>;
  @ViewChild("fileUpload") fileUpload: ElementRef;
  //
  @Input("gcPolicyNo") gcPolicyNo: string;
  @Input("policyRenewalCounter") policyRenewalCounter: string;
  @Input("masterPolicyId") masterPolicyId: string;
  @Input("getUserType") getUserType: string;
  // @Input('isMasterPolicyInactived') isMasterPolicyInactived: boolean;
  @Output() Outputfn: EventEmitter<any> = new EventEmitter<any>();
  dtTrigger: Subject<any> = new Subject();
  dtTrigger1: Subject<any> = new Subject();
  dtOptions: any = {};
  policyUrl = `${this.commonVariablesService.baseURL}api/v1/policy`;
  quoteUrl = `${this.commonVariablesService.baseURL}api/v1/quote`;
  isReadonly = true;
  isNotReadonly = false;
  isRefToUw = false;
  selectedDeclarationDetail: any;
  pageContent: any;
  declarationForm: FormGroup;
  header: any;
  isNewClient = false;
  totalBrokerDetails = [];
  totalRoeDetails = [];
  totalModeOfShipmentDetails = [];
  totalCurrencyDetails = [];
  totalInvoiceCurrency = [];
  totalCountryDetails = [];
  selectedRoeDetails = [];
  settlingAgentDetails = [];
  // roe changes
  selectedValue;
  isOriginalDownladed: boolean = false;
  availableBalc: any;
  isDraftMode: boolean = false;
  isRequired: boolean = false;
  certPageSubscription: any;
  deletionBeyondDaysMsg =
    "Deletion beyond 7 days is not allowed, this case has been referred to Underwriter";
  isDeletionBeyondDays: boolean = false;
  delConfirmationMsg = "Are you sure you want to delete a draft ?";
  quoteDelMsg = "Draft is deleted successfully";
  submitted: boolean = false;
  isUpdateCertFailed =
    "Update Certificate is not allowed. It will be refer to underwriter";
  isDuplicate: boolean = false;
  isCancelMode: boolean = false;
  isNstpEnabled: boolean = false;
  //Ticket No -154865
  //approve/reject duplication
  isApproveOrReject: boolean = false;
  cancelCert = "Certificate number to be cancelled";
  configCenter: any = {
    class: "theme-modal center modal-sm",
    backdrop: "static",
  };
  modalRef: BsModalRef;
  isReferral = "";
  minIssueDate: any;
  maxIssueDate: any;
  userEmail: string;
  billofLading_minDate: Date;
  uwRefferralReasons: any = [];
  pslMsg = "Declared value exceeds Policy Per Sending Limit";
  backDationMsg =
    "No of Days to backdate has exceeded allowable days. please refer to underwriter by submitting request";
  isReferred: boolean = false;
  calcPremiumData: any = [];
  isViewMode: boolean = false;
  countryRefMsg = "Country selected is flagged as Referral";
  fieldError: any = [];
  // Ticket no - 161061 upload excel changes
  shipmentDate: Date;
  minBillDate: any;
  isCloneMode: boolean = false; //Added by Gomathi
  cloneMasterPolicyDetails: any = {};
  lockDateMsg = "Expected date of shipment is beyond the expiry date of policy";
  isCertificateAllowed: boolean = true;
  isViewCertificate: boolean = false; //Added by Gomathi
  refToUW = "Raised for Underwriter referral";
  prdEndorsementDetails: any;
  selectedEndorsementData: any = {};
  selectedEndorsementDetails: any;
  totalFieldsToChange = [];
  editableFields: any = {};
  isPremiumEndorsement: boolean;
  isEndorsement: boolean;
  errorMsg = "Problem occured while saving data";
  updateCertReferral = "Update Certificate";
  isPolicyCancelled: boolean = false;
  fromCountryDetails = [];
  toCountryDetails = [];
  totalNewPincodeDetails = [];
  selected: string;
  noResult = false;
  fromCityVal: string;
  toCityVal: string;
  impersonateFlag: boolean = false; // added by obulakshmi
  isEditableCertificate: boolean = true;
  //Ticket No 154865
  isShowSubmitButton: boolean = false;
  //Ticket No 154865
  isShowCancelButton: boolean = false;
  allowCert: string = ""; // added by obulakshmi
  isNewClientApplicable: boolean = true;
  //added by Priyadharshini
  policyNumber: any;
  referralRemarksVal: any;
  voyageName: any;
  //excel issue
	isEndorsementValue:boolean = false;
  policyType: any;
  subVoyageName: any;
  policyCurrencyType: any;
  addClientInCertificate: any;
  defaultPolicyInsuredName: any;
  //const { getJsDateFromExcel } = `require("excel-date-to-js")`;
  isShowGenerateCertificate = true;
  modeOfConveyance: any;
  allowedExt =
    ".xls,.xlsb,.xlsm,.xlsx,.rtf,.docx,.doc,.pdf,.jpg,.jpeg,.png,.zip,.7z";
  uploadCertificate: FormGroup;
  excelData: any = [
    {
      statusmsg: "",
      statusreason: "",
      insured_Name: "",
      address1: "",
      address2: "",
      address3: "",
      pincode: "",
      mode_of_shipment: "",
      from_Country: "",
      to_Country: "",
      from_City: "",
      to_City: "",
      invoice_Currency_Type: "",
      cargo_Value: "",
      roe: "",
      duty_Sum_Insured: "",
      date_Of_Shipment: "",
      billng_No: "",
      billing_Date: "",
      credit_Number: "",
      credit_Description: "",
      place_Of_Issuance: "",
      invoice_No: "",
      invoice_Date: "",
      subject_Matter_Insured: "",
      marks_Numbers: "",
      vessel_Name: "",
      consignee_Name: "",
      consignee_Address: "",
      financier_Name: "",
    },
  ];
  sampleData = [];
  sampleExcelData = [];
  excelData1 = [
    { statusmsg: "", isMandatory: false, dataType: "Numeric" },
    { statusreason: "", isMandatory: false, dataType: "Numeric" },
    { insured_Name: "", isMandatory: false, dataType: "Varchar" },
    { address1: "", isMandatory: false, dataType: "Varchar" },
    { address2: "", isMandatory: false, dataType: "Varchar" },
    { address3: "", isMandatory: false, dataType: "Varchar" },
    { pincode: "", isMandatory: false, dataType: "" },
    { mode_of_shipment: "", isMandatory: true, dataType: "Varchar" },
    { from_Country: "", isMandatory: false, dataType: "Varchar" },
    { to_Country: "", isMandatory: false, dataType: "Varchar" },
    { from_City: "", isMandatory: true, dataType: "Varchar" },
    { to_City: "", isMandatory: true, dataType: "Varchar" },
    { invoice_Currency_Type: "", isMandatory: true, dataType: "Varchar" },
    { cargo_Value: "", isMandatory: true, dataType: "Numeric" },
    { roe: "", isMandatory: false, dataType: "numeric" },
    { duty_Sum_Insured: "", isMandatory: false, dataType: "Numeric" },
    { date_Of_Shipment: "", isMandatory: true, dataType: "Date" },
    { billng_No: "", isMandatory: false, dataType: "Alphanumeric" },
    { billing_Date: "", isMandatory: false, dataType: "" },
    { credit_Number: "", isMandatory: false, dataType: "Alphanumeric" },
    { credit_Description: "", isMandatory: false, dataType: "Varchar" },
    { place_Of_Issuance: "", isMandatory: false, dataType: "Alphanumeric" },
    { invoice_No: "", isMandatory: true, dataType: "Alphanumeric" },
    { invoice_Date: "", isMandatory: true, dataType: "Date" },
    { subject_Matter_Insured: "", isMandatory: true, dataType: "Alphanumeric" },
    { marks_Numbers: "", isMandatory: false, dataType: "Alphanumeric" },
    { vessel_Name: "", isMandatory: false, dataType: "Alphanumeric" },
    { consignee_Name: "", isMandatory: false, dataType: "Alphanumeric" },
    { consignee_Address: "", isMandatory: false, dataType: "Alphanumeric" },
    { financier_Name: "", isMandatory: false, dataType: "Alphanumeric" },
  ];
  excelHeaders = [
    "statusmsg",
    "statusreason",
    "Insured Name",
    "Address1",
    "Address2",
    "Address3",
    "Pincode",
    "Mode of Shipment",
    "From Country",
    "To Country",
    "From-City",
    "To-City",
    "Invoice currency Type",
    "Cargo value as per Invoice currency",
    "ROE (Rate of exchange)",
    "Duty Sum Insured in INR",
    "Expected date of shipment (tooltip)",
    "Bill of Lading No./Airway Bill No.",
    "Bill of Lading Date/Airway Bill Date",
    "Letter of Credit No.",
    "Letter of Credit Description/Special Terms",
    "Place of Issuance",
    "Invoice Number",
    "Invoice Date",
    "Subject Matter Insured",
    "Marks & Numbers",
    "Vessel Name or Flight No/Airline",
    "Consignee Name",
    "Consignee Add",
    "Financier Name",
  ];
  excelHeadersKey = [
    "statusmsg",
    "statusreason",
    "insured_Name",
    "address1",
    "address2",
    "address3",
    "pincode",
    "mode_of_shipment",
    "from_Country",
    "to_Country",
    "from_City",
    "to_City",
    "invoice_Currency_Type",
    "cargo_Value",
    "roe",
    "duty_Sum_Insured",
    "date_Of_Shipment",
    "billng_No",
    "billing_Date",
    "credit_Number",
    "credit_Description",
    "place_Of_Issuance",
    "invoice_No",
    "invoice_Date",
    "subject_Matter_Insured",
    "marks_Numbers",
    "vessel_Name",
    "consignee_Name",
    "consignee_Address",
    "financier_Name",
  ];
  excelRecordVal = 200;
  recordLength;
  successTxt = "Success";
  failureTxt = "Failure";
  excalValFlag: boolean = false;
  docDetails: any = {};
  allowedFileExt: Array<any> = [
    "xls",
    "xlsb",
    "xlsm",
    "xlsx",
    "rtf",
    "docx",
    "doc",
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "zip",
    "7z",
  ];
  fromCountryList = [];
  toCountryList = [];
  certificateCompletedResult = []; //Added by Vishnuraj
  isShowIssueCert: boolean = false;
  isAlreadyGenerated: boolean = true;
  insuringClause: any = "";
  commonInsuringClause = "";
  prevInvoiceCurrency = "";
  defaultResponse: any = {};
  historyData: any = {
    is_certificate: true,
    policy_id: "",
    contentData: [],
  };
  settlingAgentValue = "";
  claimsRepValue = "";
  gcEndorsementDetails: any = [];
  form: any = {
    lc_details: "lc_details",
    subject_matter_insured: "subject_matter_insured",
    marks_numbers: "marks_numbers",
  };
  certificateStatus: any;
  gcPolicyDetails: any;
  nonStdClause: any;
  referralCountryDetails = [];
  isMasterPolicyInactived: boolean = false;
  premiumErrorMsg = "";
  mfrErrorMsg =
    "Marine final rate cannot be less than the value defined in the Policy setup";
  totalCoverageType: any = [];
  totalEndorseResponseData: any = [];
  ableToIssue: boolean = false;
  isShowButton: boolean = true; //for adminview case

  constructor(
    private modalService: BsModalService,
    public commonService: CommonService,
    public commonVariablesService: CommonVariablesService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public datePipe: DatePipe,
    private el: ElementRef,
    public excelService: ExcelServiceService,
    public validationService: ValidationService
  ) {}

  async ngOnInit() {
    this.uploadCertificate = this.fb.group({
      file: [""],
    });
    /* this.userEmail = this.cookie.get('email'); */
    this.userEmail = window.localStorage.getItem("email");
    this.certPageSubscription = this.activatedRoute.params.subscribe((val) => {
      this.onLoadFunctionality(val);
    });
    if (this.getUserType == "adminview") this.isShowButton = false;
    // remove duplicate lines from two paragraph
    /* var seen = {};
    $('#content>p').each(function () {
      var txt = $(this).text().toLowerCase();
      if (seen[txt])
        $(this).remove();
      else
        seen[txt] = true;
    }); */
  }
  /*
   * Created By : Sharann N
   * Description : get upload certificate form data.
   *********************************************/
  get uploadCertificateForm() {
    return this.uploadCertificate.controls;
  }

  ngOnDestroy() {
    if (this.certPageSubscription) {
      this.certPageSubscription.unsubscribe();
    }
    // this.certPageSubscription ? this.certPageSubscription.unsubscribe() : '';
  }

  /*
   * Created By : Sharann N
   * Description : page onload functionalities.
   *********************************************/
  async onLoadFunctionality(data) {
    /* this.header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    this.pageContent = Number(data.id) || 0;
    this.isAlreadyGenerated =
      (this.getUserType == "underwriter" || this.getUserType == "helpdesk") &&
      !this.impersonateFlag &&
      this.header.nav_to == "appr_rejt"
        ? true
        : false;
    if ([2, 3, 8, 9, 10, 11].includes(this.pageContent)) {
      if (this.pageContent == 2 && this.header.nav_to == "clone") {
        this.isCloneMode = true; //by gomathi
      } else if (this.pageContent == 8) {
        this.isDraftMode = true;
      } else if (this.pageContent == 9) {
        this.isCancelMode = true;
        this.isDraftMode = true;
      }
      if ([2, 8, 9, 10, 11].includes(this.pageContent)) {
        await this.initialiseDeclarationForm();
      }
      this.gcEndorsementDetails = await this.commonService.getMasterEndorsement(
        this.gcPolicyNo,
        this.policyRenewalCounter
      );
    }

    /* this.gcPolicyDetails = await this.getPolicyData(this.header.policy_no, true);
    let mailID = this.cookie.get('email');
    let userType = this.cookie.get('userProfile'); */
    this.gcPolicyDetails = await this.getPolicyData(
      this.header.policy_no,
      true
    );
    let mailID = window.localStorage.getItem("email");
    let userType = window.localStorage.getItem("userProfile");
    userType = this.commonService.decryptData(userType);

    if (
      [2, 3, 8, 9, 10, 11].includes(this.pageContent) &&
      (userType.toLowerCase() == "produceruser" ||
        userType.toLowerCase() == "hub" ||
        userType.toLowerCase() == "admin" ||
        (userType.toLowerCase() == "underwriter" &&
          this.header.nav_to != "appr_rejt"))
    ) {
      const ret = await this.getPolicyData(this.header.policy_no, true);
      if (JSON.stringify(ret) != "{}") {
        const impersonateUser = ret["data"]["client_users"][0] || "";
        this.allowCert = "No";
        for (const obj of ret["data"]["producer_users"]) {
          if (obj.email == mailID) {
            this.allowCert = obj["allow_certificate"];
            break;
          }
        }
        if (impersonateUser) {
          const url = `${this.commonVariablesService.baseURL}api/v1/auth/impersonate/${impersonateUser}`;
          const res = await this.commonService.httpPostMethod(
            url,
            {},
            "application/json",
            true,
            "Declaration"
          );
          if (res.body.status === 0) {
            sessionStorage.setItem("imp_token", res.body.data.token);
            /* window.localStorage.setItem('imp_token', res.body.data.token); */
            /* sessionStorage.setItem('impersonate_user', 'Yes'); */
            window.localStorage.setItem("impersonate_user", "Yes");
            this.impersonateFlag = true;
          } else if (res.body.status != -114) {
            this.commonService.errorsmsg(
              res.body.txt || "Unable to impersonate",
              ""
            );
          }
        } else {
          this.commonService.errorsmsg(
            "Impersonate: Unable to fetch client details",
            ""
          );
        }
      } else {
        this.commonService.errorsmsg(
          "Impersonate: Unable to fetch mater policy details",
          ""
        );
      }
    }

    this.isAlreadyGenerated =
      (this.getUserType == "underwriter" || this.getUserType == "helpdesk") &&
      !this.impersonateFlag
        ? true
        : false;

    if (this.pageContent == 2 || this.pageContent == 11) {
      if (this.header.nav_to == "clone") this.isCloneMode = true; //by gomathi
      await this.initialiseDeclarationForm();
      await this.listenDeclarationForm();
      await this.loadSelectedDeclationData();
      //this.dtTrigger.next();
    } else if (this.pageContent == 3 || this.pageContent == 4) {
      await this.loadEndorsementList();
    } else if (this.pageContent == 6) {
      $("#history_table").DataTable().destroy();
      await this.loadHistoryData();
    } else if (this.pageContent == 8) {
      this.isDraftMode = true;
      await this.initialiseDeclarationForm();
      await this.listenDeclarationForm();
      this.isAlreadyGenerated
        ? await this.loadEndorsementList()
        : await this.loadDraftData();
      /*Added by gomathi to check the assignee*/
      if (this.isAlreadyGenerated) await this.checkAssignee();
    } else if (this.pageContent == 9) {
      this.isCancelMode = true;
      this.isDraftMode = true;
      //this.isReferral = (this.isAlreadyGenerated) ? "Certificate Cancellation" : '';
      await this.initialiseDeclarationForm();
      await this.listenDeclarationForm();
      await this.loadEndorsementList();
      if (this.isAlreadyGenerated) {
        await this.checkAssignee();
        this.isReferral = "Certificate Cancellation";
      }
    } else if (this.pageContent == 10) {
      await this.initialiseDeclarationForm();
      await this.loadEndorsementList();
    }
    this.spinner.hide();
  }

  /*
   * Created By : Sharann N
   * Description : check declaration is asiggned to group or not.
   *********************************************/
  async checkAssignee() {
    //if assigned to is group
    if (
      [
        this.commonVariablesService.uwLOneGrpCode,
        this.commonVariablesService.uwLTwoGrpCode,
        this.commonVariablesService.uwLThreeGrpCode,
        this.commonVariablesService.helpdeskGrpCode,
      ].includes(this.selectedDeclarationDetail["assigned_to"])
    ) {
      await this.takeOverAction(0);
      if (JSON.stringify(this.selectedEndorsementData) != "{}") {
        await this.takeOverAction(1);
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : get declaration form fields data.
   *********************************************/
  get f() {
    return this.declarationForm.controls;
  }

  /*
   * Created By : Sharann N
   * Description : initialise form with disable conditions.
   *********************************************/
  initialiseDeclarationForm() {
    return new Promise(async (resolve) => {
      const isUpdateCert =
        (this.header.nav_to || "") == "endorse-cert" ? true : false;
      const isUpdateDraft =
        (this.header.nav_to || "") == "update_draft" ? true : false;
      const uwDisableCondition = this.isAlreadyGenerated
        ? false
        : isUpdateCert
        ? true
        : isUpdateDraft
        ? false
        : this.isDraftMode;
      const validator = uwDisableCondition ? "" : Validators.required;
      const cancelValidator = this.isCancelMode ? Validators.required : ""; //by gomathi
      const updateCertValidator = isUpdateCert ? Validators.required : "";
      this.declarationForm = this.fb.group({
        tp_policy_no: [{ value: "", disabled: this.isReadonly }],
        voyage_name: [{ value: "", disabled: this.isReadonly }],
        sub_voyage_type: [{ value: "", disabled: this.isReadonly }],
        opening_balance: [{ value: "", disabled: this.isReadonly }],
        balance_premium: [{ value: "", disabled: this.isReadonly }],
        currency_type: [{ value: "", disabled: this.isReadonly }],
        bov_percentage: [{ value: "", disabled: this.isReadonly }],
        uw_ref_type: [{ value: "", disabled: this.isReadonly }],
        client_name: [{ value: "", disabled: this.isReadonly }],
        client_address_1: [{ value: "", disabled: this.isReadonly }],
        client_address_2: [{ value: "", disabled: this.isReadonly }],
        client_address_3: [{ value: "", disabled: this.isReadonly }],
        client_pincode: [{ value: "", disabled: this.isReadonly }],
        insured_city: [{ value: "", disabled: this.isReadonly }],
        insured_district: [{ value: "", disabled: this.isReadonly }],
        insured_state: [{ value: "", disabled: this.isReadonly }],
        insured_country: [{ value: "", disabled: this.isReadonly }],
        client_gstin: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        add_new_client: [{ value: "", disabled: uwDisableCondition }],
        default_new_client: [{ value: "", disabled: uwDisableCondition }],
        add_client_name: [{ value: "", disabled: uwDisableCondition }],
        new_insured_name: [{ value: "", disabled: uwDisableCondition }],
        new_insured_address_1: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        new_insured_address_2: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        new_insured_address_3: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        new_insured_pincode: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        new_insured_city: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        new_insured_district: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        new_insured_state: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        new_insured_country: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        new_insured_gstin: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
        ],
        mode_of_shipment: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        coverage_type: [
          { value: "", disabled: this.getUserType != "underwriter" },
        ],
        packing: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        from_country: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        to_country: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        from_city: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        to_city: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        from_city_country: [{ value: "", disabled: this.isReadonly }], //added by gomathi
        to_city_country: [{ value: "", disabled: this.isReadonly }], //added by gomathi
        invoice_currency: [
          { value: "", disabled: isUpdateDraft ? true : uwDisableCondition },
          validator,
        ], //modified by gomathi
        cargo_value: [
          { value: "", disabled: isUpdateDraft ? true : uwDisableCondition },
          validator,
        ], //modified by gomathi
        roe: [{ value: "", disabled: this.isReadonly }, [Validators.required]],
        cargo_si: [{ value: "", disabled: this.isReadonly }],
        duty_si: [
          { value: "", disabled: isUpdateDraft ? true : uwDisableCondition },
        ], //modified by gomathi
        marine_final_rate_percentage: [
          {
            value: "",
            disabled: this.isAlreadyGenerated ? false : this.isReadonly,
          },
        ],
        cargo_si_policy_currency: [{ value: "", disabled: this.isReadonly }],
        total_si: [{ value: "", disabled: this.isReadonly }],
        cargo_premium: [{ value: "", disabled: this.isReadonly }],
        duty_premium: [{ value: "", disabled: this.isReadonly }],
        total_premium: [{ value: "", disabled: this.isReadonly }],
        gst: [{ value: "", disabled: this.isReadonly }],
        net_premium_final: [{ value: "", disabled: this.isReadonly }],
        non_std_clause: [{ value: "" }],
        expected_date_shipment: [
          { value: "", disabled: uwDisableCondition || this.isDraftMode },
          validator,
        ],
        bill_no: [
          { value: "", disabled: this.isCancelMode },
          [Validators.pattern(this.commonService.freeTextPattern)],
        ],
        bill_date: [{ value: "", disabled: this.isCancelMode }],
        lc_no: [
          { value: "", disabled: this.isCancelMode },
          [Validators.pattern(this.commonService.freeTextPattern)],
        ],
        issuance_place: [
          { value: "", disabled: this.isCancelMode },
          [Validators.required],
        ],
        invoice_no: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [
            Validators.required,
            Validators.pattern(this.commonService.freeTextPattern),
          ],
        ],
        invoice_date: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        vessel_name: [
          { value: "", disabled: this.isCancelMode },
          [Validators.pattern(this.commonService.freeTextPattern)],
        ],
        consignee_name: [
          { value: "", disabled: this.isCancelMode },
          [Validators.pattern(this.commonService.freeTextPattern)],
        ],
        consignee_address: [
          { value: "", disabled: this.isCancelMode },
          [
            Validators.pattern(this.commonService.freeTextPattern),
            Validators.maxLength(300),
          ],
        ],
        financier_name: [
          { value: "", disabled: uwDisableCondition || this.isDraftMode },
          [Validators.pattern(this.commonService.freeTextPattern)],
        ],
        issue_date: [
          { value: "", disabled: uwDisableCondition || this.isDraftMode },
          validator,
        ],
        lc_details: [{ value: "", disabled: this.isCancelMode }],
        subject_matter_insured: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        marks_numbers: [{ value: "", disabled: this.isCancelMode }],
        claims_payable_at: [{ value: "", disabled: this.isReadonly }],
        settling_agent: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        settling_agent_company: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        settling_agent_address: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        settling_agent_phone: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        settling_agent_email: [
          { value: "", disabled: this.isCancelMode || uwDisableCondition },
          [Validators.required],
        ],
        claims_rep: [
          { value: "", disabled: isUpdateDraft ? false : this.isReadonly },
        ],
        reason_cancellation: [
          { value: "", disabled: this.isAlreadyGenerated },
          cancelValidator,
        ],
        cancel_cert: [{ value: "", disabled: this.isAlreadyGenerated }],
        retain_cert: [{ value: "", disabled: this.isAlreadyGenerated }],
        reason_cancel: [{ value: "", disabled: this.isAlreadyGenerated }],
        cert_no: [{ value: "", disabled: this.isAlreadyGenerated }],
        reason_nstp: [{ value: "" }],
        reason_change: [
          {
            value: "",
            disabled:
              (this.getUserType == "underwriter" && !this.impersonateFlag) ||
              this.getUserType == "helpdesk",
          },
        ],
        fields_to_change: [
          {
            value: "",
            disabled:
              (this.getUserType == "underwriter" && !this.impersonateFlag) ||
              this.getUserType == "helpdesk",
          },
        ],
        endorsement_start_date: [{ value: "" }, updateCertValidator],
        si_deductible: [{ value: "" }],
      });
      if (this.pageContent == 9) {
        this.declarationForm.disable();
        const fieldAry =
          (this.getUserType == "underwriter" ||
            this.getUserType == "helpdesk") &&
          !this.impersonateFlag
            ? ["reason_nstp"]
            : [
                "reason_cancellation",
                "cancel_cert",
                "retain_cert",
                "cert_no",
                "reason_cancel",
              ];
        for (const obj of fieldAry) {
          this.declarationForm.controls[obj].enable();
        }
      }
      resolve(true);
    });
  }

  /*
   * Created By : Sharann N
   * Description : emits value when reactive form value changes.
   *********************************************/
  listenDeclarationForm() {
    return new Promise((resolve) => {
      this.declarationForm.valueChanges.subscribe((val) => {
        this.Outputfn.emit(this.declarationForm.getRawValue());
      });
      // to set `place of issuance` when `city` changes.
      this.declarationForm
        .get("new_insured_city")
        .valueChanges.subscribe((val) => {
          this.f.issuance_place.setValue(this.f.new_insured_city.value);
        });
      resolve(true);
    });
  }

  /*
   * Created By : Sharann N
   * Description : load selected declaration data on form fields.
   *********************************************/
  async loadSelectedDeclationData() {
    $("#certificateData").DataTable().destroy();
    let paramData: any = {
      policy_id: this.header.policy_id,
    };
    let response = await this.commonService.httpGetMethod(
      this.policyUrl,
      "application/json",
      true,
      paramData,
      "Declaration",
      this.impersonateFlag
    );
    if (response.status == 0) {
      this.selectedDeclarationDetail = response.data[0];
      this.policyNumber = response.data[0].cust_fld_1;
    } else if (response.status != -114) {
      this.selectedDeclarationDetail = {};
      this.commonService.errorsmsg(response.txt || this.errorMsg, "");
    }
    //Added by gomathi
    paramData = {
      policy_no: this.header.policy_no,
    };
    response = await this.commonService.httpGetMethod(
      this.policyUrl,
      "application/json",
      true,
      paramData,
      "Declaration",
      this.impersonateFlag
    );
    this.cloneMasterPolicyDetails = {};
    if (response.status == 0) {
      this.cloneMasterPolicyDetails = response.data[0] || {};
    } else if (response.status != -114) {
      this.commonService.errorsmsg(
        response.txt || "Unable to get policy details",
        ""
      );
    }
    const dtr = new Date(
      this.selectedDeclarationDetail.quote.data.issue_date || new Date()
    );

    if (this.isCloneMode) {
      await this.reAssignGcData();
    }
    const subVoyageAry = await this.getSubVoyageAry(
      this.isCloneMode
        ? this.cloneMasterPolicyDetails.data.sub_voyage
        : this.selectedDeclarationDetail.data.sub_voyage
    );

    let tempDeclarationDetails = this.isCloneMode
      ? this.selectedDeclarationDetail.quote.data
      : this.selectedDeclarationDetail;

    const clientDetails = await this.getInsuredDetails(tempDeclarationDetails);

    this.voyageName = this.isCloneMode
      ? tempDeclarationDetails.voyage_name ||
        (await this.commonService.getVoyageDesc(tempDeclarationDetails.voyage))
      : await this.commonService.getVoyageDesc(
          tempDeclarationDetails.quote.data.voyage
        );
    this.subVoyageName = subVoyageAry.sub_voyage_name;
    this.addClientInCertificate = subVoyageAry.client_in_certificate;
    this.policyType = this.selectedDeclarationDetail.quote.data.policy_type;
    this.defaultPolicyInsuredName = clientDetails;
    this.policyCurrencyType = this.isCloneMode
      ? tempDeclarationDetails.currency_type ||
        tempDeclarationDetails.policy_currency_type
      : tempDeclarationDetails.quote.data.policy_currency_type;
    this.modeOfConveyance = this.isCloneMode
      ? tempDeclarationDetails.mode_of_shipment
      : subVoyageAry.mode_of_conveyance;
    const modeOfConveyanceAry = (this.modeOfConveyance || "").split(",");

    const new_pincode = tempDeclarationDetails.new_insured_pincode;
    this.isReferral = tempDeclarationDetails.referral_type || "";
    const clientInfo = this.isCloneMode
      ? this.cloneMasterPolicyDetails.quote.data
      : this.selectedDeclarationDetail.quote.data;
    const clientData = this.isCloneMode
      ? this.cloneMasterPolicyDetails
      : this.selectedDeclarationDetail;
    //Ticket no - 186972 Calendar issue
    this.minIssueDate = new Date(clientInfo.gc_policy_start_date);
    this.minIssueDate = new Date(
      this.datePipe.transform(this.minIssueDate, "yyyy-MM-dd") + "T00:00:00Z"
    );
    this.maxIssueDate = new Date(
      clientData.cust_fld_2
        ? clientData.cust_fld_2
        : clientData.quote.data.gc_policy_end_date
    );
    this.maxIssueDate = new Date(
      this.datePipe.transform(this.maxIssueDate, "yyyy-MM-dd") + "T00:00:00Z"
    );
    this.minBillDate = this.minIssueDate;

    this.declarationForm.patchValue({
      tp_policy_no: tempDeclarationDetails.cust_fld_1,
      voyage_name: this.voyageName,
      sub_voyage_type: this.subVoyageName,
      currency_type: this.policyCurrencyType,
      bov_percentage: subVoyageAry.bov_percentage,
      uw_ref_type: this.isReferral,
      /* client_name: clientDetails.clientName,
      client_address_1: clientDetails.clientAdd1,
      client_address_2: clientDetails.clientAdd2,
      client_address_3: clientDetails.clientAdd3,
      client_pincode: clientDetails.pincode, */
      client_name: clientInfo.insured_name,
      client_address_1: clientInfo.insured_add1,
      client_address_2: clientInfo.insured_add2,
      client_address_3: clientInfo.insured_add3,
      client_pincode: clientInfo.insured_zipcode,
      insured_city: clientInfo.insured_city,
      insured_district: await this.getDistrict(clientInfo.insured_zipcode),
      insured_state: clientInfo.insured_state,
      insured_country: clientInfo.insured_country,
      /* insured_city: clientDetails.city,
        insured_district: ((clientDetails.district || '') == '') ? await this.getDistrict(clientDetails.pincode) : clientDetails.district,
        insured_state: clientDetails.state,
        insured_country: clientDetails.country, */
      client_gstin: clientDetails.gstin,
      //add_new_client: tempDeclarationDetails.add_new_client || 'No',
      add_new_client: "No",
      add_client_name: tempDeclarationDetails.add_client_name,
      default_new_client: tempDeclarationDetails.default_new_client || "No",
      new_insured_name: tempDeclarationDetails.new_insured_name,
      new_insured_address_1: tempDeclarationDetails.new_insured_address_1,
      new_insured_address_2: tempDeclarationDetails.new_insured_address_2,
      new_insured_address_3: tempDeclarationDetails.new_insured_address_3,
      new_insured_pincode: new_pincode,
      new_insured_city: tempDeclarationDetails.new_insured_city,
      new_insured_district:
        (tempDeclarationDetails.new_insured_district || "") == ""
          ? await this.getDistrict(new_pincode)
          : tempDeclarationDetails.new_insured_district,
      new_insured_state: tempDeclarationDetails.new_insured_state,
      new_insured_country: tempDeclarationDetails.new_insured_country,
      new_insured_gstin: tempDeclarationDetails.new_insured_gstin,
      mode_of_shipment:
        modeOfConveyanceAry.length == 1 ? modeOfConveyanceAry[0] : "", //modified by sharann
      coverage_type: subVoyageAry.coverage_type,
      packing: tempDeclarationDetails.packing || "In customary packing",
      from_country: tempDeclarationDetails.from_country,
      to_country: tempDeclarationDetails.to_country,
      from_city: tempDeclarationDetails.from_city,
      to_city: tempDeclarationDetails.to_city,
      from_city_country: this.isCloneMode
        ? `${tempDeclarationDetails.from_city}, ${tempDeclarationDetails.from_country}`
        : "",
      to_city_country: this.isCloneMode
        ? `${tempDeclarationDetails.to_city}, ${tempDeclarationDetails.to_country}`
        : "",
      invoice_currency: tempDeclarationDetails.invoice_currency || "",
      cargo_value: this.isCloneMode ? "" : tempDeclarationDetails.cargo_value,
      cargo_si_policy_currency: this.isCloneMode
        ? ""
        : tempDeclarationDetails.cargo_si_policy_currency,
      roe: tempDeclarationDetails.roe,
      cargo_si: this.isCloneMode ? "" : tempDeclarationDetails.cargo_si,
      duty_si: this.isCloneMode ? "" : tempDeclarationDetails.duty_si,
      total_si: this.isCloneMode ? "" : tempDeclarationDetails.total_si,
      cargo_premium: this.isCloneMode
        ? ""
        : tempDeclarationDetails.cargo_premium,
      duty_premium: this.isCloneMode ? "" : tempDeclarationDetails.duty_premium,
      total_premium: this.isCloneMode
        ? ""
        : tempDeclarationDetails.total_premium,
      gst: this.isCloneMode ? "" : tempDeclarationDetails.gst,
      net_premium_final: this.isCloneMode
        ? ""
        : tempDeclarationDetails.net_premium_final,
      non_std_clause: subVoyageAry.non_standard_clauses,
      marine_final_rate_percentage: this.isCloneMode
        ? tempDeclarationDetails.marine_final_rate_percentage
        : subVoyageAry.marine_final_rate_percentage,
      // expected_date_shipment: this.isCloneMode ? '' : tempDeclarationDetails.expected_date_shipment,
      expected_date_shipment: this.isCloneMode
        ? ""
        : tempDeclarationDetails.expected_date_shipment
        ? new Date(tempDeclarationDetails.expected_date_shipment)
        : "",
      issue_date: this.isCloneMode
        ? new Date(tempDeclarationDetails.issue_date)
        : dtr,
      bill_no: this.isCloneMode ? "" : tempDeclarationDetails.bill_no,
      // bill_date: this.isCloneMode ? '' : tempDeclarationDetails.bill_date ?tempDeclarationDetails.bill_date : '',
      bill_date: this.isCloneMode
        ? ""
        : tempDeclarationDetails.bill_date
        ? new Date(tempDeclarationDetails.bill_date)
        : "",
      lc_no: tempDeclarationDetails.lc_no,
      issuance_place: this.selectedDeclarationDetail.quote.data.insured_city,
      // issuance_place: clientDetails.city,
      invoice_no: this.isCloneMode ? "" : tempDeclarationDetails.invoice_no,
      // invoice_date: this.isCloneMode ? '' : tempDeclarationDetails.invoice_date,
      invoice_date: this.isCloneMode
        ? ""
        : tempDeclarationDetails.invoice_date
        ? new Date(tempDeclarationDetails.invoice_date)
        : "",
      vessel_name: tempDeclarationDetails.vessel_name,
      consignee_name: tempDeclarationDetails.consignee_name,
      consignee_address: tempDeclarationDetails.consignee_address,
      financier_name: tempDeclarationDetails.financier_name,
      lc_details: tempDeclarationDetails.lc_details,
      subject_matter_insured: tempDeclarationDetails.subject_matter_insured,
      marks_numbers: tempDeclarationDetails.marks_numbers,
      claims_payable_at: tempDeclarationDetails.claims_payable_at,
      settling_agent: tempDeclarationDetails.settling_agent,
      settling_agent_company: tempDeclarationDetails.settling_agent_company,
      settling_agent_address: tempDeclarationDetails.settling_agent_address,
      settling_agent_phone: tempDeclarationDetails.settling_agent_phone,
      settling_agent_email: tempDeclarationDetails.settling_agent_email,
      claims_rep: tempDeclarationDetails.claims_rep,
      reason_cancellation: "",
      cancel_cert: "",
      retain_cert: "",
      reason_cancel: "",
      cert_no: "",
      reason_nstp: "",
      reason_change: "",
      fields_to_change: "",
      endorsement_start_date: "",
      si_deductible: 0,
    });
    const balance: any = await this.calcPolicyBalance(
      this.isCloneMode
        ? this.selectedDeclarationDetail.quote.data.cust_fld_3 ||
            this.selectedDeclarationDetail.policy_no
        : this.selectedDeclarationDetail.policy_no,
      this.isCloneMode
        ? ""
        : tempDeclarationDetails.expected_date_shipment
        ? new Date(tempDeclarationDetails.expected_date_shipment)
        : ""
    );
    this.declarationForm.patchValue({
      opening_balance: await this.decimalPt(
        balance.without_date.available_opening_balance_certificate || 0,
        true
      ),
      balance_premium: await this.decimalPt(
        balance.without_date.available_premium_balance_certificate || 0,
        true
      ),
    });
    await this.assignValueToForm();
    await this.getInsuringClause();
    await this.loadDropdownValues();
    await this.validateFields();
    this.spinner.hide();
    this.dtTrigger.next();
  }

  /*
   * Created By : Sharann N
   * Description : to vliate the form fields.
   *********************************************/
  async validateFields() {
    const voyageName = this.declarationForm.get("voyage_name").value || "";
    const subVoyageType =
      this.declarationForm.get("sub_voyage_type").value || "";
    if (
      voyageName.toLowerCase() == "export" &&
      subVoyageType.toLowerCase() == "fob/cfr export"
    ) {
      this.declarationForm.controls["from_country"].setValue("INDIA");
      this.declarationForm.controls["from_country"].disable();
      this.declarationForm.controls["to_country"].setValue("INDIA");
      this.declarationForm.controls["to_country"].disable();
    }
    const validatorAry: any = this.isAlreadyGenerated
      ? [Validators.required]
      : [];
    this.declarationForm.get("reason_nstp").setValidators(validatorAry);
    this.declarationForm.get("reason_nstp").updateValueAndValidity();

    if (this.pageContent == 2) {
      const subVoyageAry = await this.getSubVoyageAry(
        this.isCloneMode
          ? this.cloneMasterPolicyDetails.data.sub_voyage
          : this.selectedDeclarationDetail.data.sub_voyage
      );
      this.isNewClientApplicable =
        (subVoyageAry.client_in_certificate || "").toLowerCase() == "yes"
          ? true
          : false;
    }
    this.from_city_countryChange();
    this.claimsPay();
  }

  /*
   * Created By : Sharann N
   * Description : to set value for `cliams payable at` field.
   *********************************************/
  async claimsPay() {
    const toCountry = this.declarationForm.get("to_country").value;
    this.settlingAgentDetails = this.totalCountryDetails.filter(
      (value) =>
        (value.country_name || "").toLowerCase() ==
        (toCountry || "").toLowerCase()
    );
    this.settlingAgentDetails.forEach((obj) => {
      obj["settling_agent"] =
        (obj.city_name || "") == ""
          ? `${toCountry}`
          : `${toCountry} (${obj.city_name})`;
      obj[
        "settling_agent_value"
      ] = `${toCountry} - ${obj.company_name} - ${obj.address} - ${obj.phone_no} - ${obj.email_id}`;
    });

    if (!this.isReferral || this.isCloneMode) {
      if (this.settlingAgentDetails.length) {
        const selectedSettlingAgent = this.settlingAgentDetails.filter(
          (value) =>
            (value.settling_agent_value || "").toLowerCase() ==
            (
              this.declarationForm.get("settling_agent").value || ""
            ).toLowerCase()
        );
        this.declarationForm.controls["settling_agent"].setValue(
          selectedSettlingAgent.length == 0
            ? this.settlingAgentDetails[0].settling_agent_value
            : selectedSettlingAgent[0].settling_agent_value
        );
        await this.settlingAgent();
      }
      this.declarationForm.controls["claims_payable_at"].setValue(toCountry);
    }
    this.to_city_countryChange(); //added by gomathi
  }

  /*
   * Created By : Sharann N
   * Description : trigger when `from country` / `from city` value changes.
   *********************************************/
  from_city_countryChange() {
    let fromCountry = this.declarationForm.get("from_country").value;
    let fromCity = this.declarationForm.get("from_city").value;
    let value;
    if (fromCountry && fromCity) value = fromCity + "," + fromCountry;
    else if (fromCountry) value = fromCountry;
    else if (fromCity) value = fromCity;
    this.fromCityVal = value;
    this.declarationForm.controls["from_city_country"].setValue(value);
  }

  /*
   * Created By : Sharann N
   * Description : trigger when `to country` / `to city` value changes.
   *********************************************/
  to_city_countryChange() {
    let toCountry = this.declarationForm.get("to_country").value;
    let toCity = this.declarationForm.get("to_city").value;
    let value;
    if (toCountry && toCity) value = toCity + "," + toCountry;
    else if (toCountry) value = toCountry;
    else if (toCity) value = toCity;
    this.toCityVal = value;
    this.declarationForm.controls["to_city_country"].setValue(value);
  }

  /*
   * Created By : Sharann N
   * Description : load values to all dropdown.
   *********************************************/
  async loadDropdownValues(isEndorsement = false) {
    const nav_to = this.header.nav_to || "";
    await this.claimsPay();
    /* Get Mode of Shipment */
    let subVoyageAry = this.isCloneMode
      ? await this.getSubVoyageAry(
          this.cloneMasterPolicyDetails.data.sub_voyage
        )
      : this.isDraftMode
      ? {
          mode_of_conveyance:
            this.selectedDeclarationDetail.quote.data.mode_of_conveyance,
          from_country: this.selectedDeclarationDetail.quote.data.from_country,
          to_country: this.selectedDeclarationDetail.quote.data.to_country,
        }
      : nav_to == "endorse-cert"
      ? {
          mode_of_conveyance:
            this.selectedEndorsementDetails.quote.data.mode_of_conveyance,
          from_country: this.selectedEndorsementDetails.quote.data.from_country,
          to_country: this.selectedEndorsementDetails.quote.data.to_country,
        }
      : await this.getSubVoyageAry(
          this.selectedDeclarationDetail.data.sub_voyage
        );
    const mode_of_shipment = this.isDraftMode
      ? this.selectedDeclarationDetail.quote.data.mode_of_conveyance
      : nav_to == "endorse-cert" ||
        nav_to == "canc_cert" ||
        nav_to == "update_draft"
      ? this.selectedEndorsementDetails.quote.data.mode_of_conveyance
      : subVoyageAry.mode_of_conveyance;
    this.totalModeOfShipmentDetails = mode_of_shipment.split(",");
    if (this.totalModeOfShipmentDetails.length == 1) {
      this.declarationForm.controls["mode_of_shipment"].setValue(
        this.totalModeOfShipmentDetails[0]
      );
    }

    /* Get broker list */
    this.spinner.show();
    let brokers = [];
    const brokerUrl = `${this.commonVariablesService.baseURL}api/v1/broker`;
    const brokerResponse = await this.commonService.httpGetMethod(
      brokerUrl,
      " application/x-www-form-urlencoded; charset=UTF-8;",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    brokers = brokerResponse.status == 0 ? brokerResponse.data : [];

    this.defaultResponse.data = this.defaultResponse.data || [];
    for (const newData of this.defaultResponse.data) {
      brokers.push(newData);
    }
    this.totalBrokerDetails = brokers;

    /* Get Coverage type list */
    this.spinner.show();
    const coverageTypeUrl = `${this.commonVariablesService.baseURL}api/v1/master/marine_m_coverage_type`;
    const coverageTypeResponse = await this.commonService.httpGetMethod(
      coverageTypeUrl,
      " application/x-www-form-urlencoded; charset=UTF-8;",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    this.totalCoverageType =
      coverageTypeResponse.status == 0 ? coverageTypeResponse.data : [];

    /* Get roe master */
    this.spinner.show();
    const roeUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/roe`;
    const roeResponse = await this.commonService.httpGetMethod(
      roeUrl,
      "application/x-www-form-urlencoded; charset=UTF-8",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    this.totalRoeDetails = roeResponse.status == 0 ? roeResponse.data : [];

    /* Get Current details */
    this.totalCurrencyDetails = this.totalRoeDetails.length
      ? JSON.parse(JSON.stringify(this.totalRoeDetails))
      : [
          {
            from_currency: "INR",
          },
          {
            from_currency: "USD",
          },
          {
            from_currency: "YEN",
          },
          {
            from_currency: "EUR",
          },
        ];

    this.totalCurrencyDetails = Array.from(
      new Set(this.totalCurrencyDetails.map((a) => a.from_currency))
    ).map((id) => {
      return this.totalCurrencyDetails.find(
        (a) => a.from_currency != "" && a.from_currency === id
      );
    });

    this.totalCurrencyDetails.sort((a, b) =>
      a.from_currency > b.from_currency
        ? 1
        : b.from_currency > a.from_currency
        ? -1
        : 0
    );

    for (const obj of this.totalCurrencyDetails) {
      this.totalInvoiceCurrency.push(obj.from_currency);
    }
    if (this.totalInvoiceCurrency.length == 1) {
      this.declarationForm.controls["invoice_currency"].setValue(
        this.totalInvoiceCurrency[0]
      );
    }

    await this.calculateCertificatePremium();

    /* Get Country Details */
    this.spinner.show();
    subVoyageAry =
      nav_to == "update_draft" || nav_to == "canc_cert" || nav_to == "appr_rejt"
        ? await this.getSubVoyageAry([])
        : subVoyageAry;
    const countryUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/country`;
    const countryResponse = await this.commonService.httpGetMethod(
      countryUrl,
      "application/x-www-form-urlencoded; charset=UTF-8",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    this.totalCountryDetails =
      countryResponse.status == 0 ? countryResponse.data : [];
    let from_country = this.isDraftMode
      ? this.selectedDeclarationDetail.quote.data.from_country
      : nav_to == "endorse-cert"
      ? this.selectedEndorsementDetails.quote.data.from_country
      : subVoyageAry.from_country;
    let to_country = this.isDraftMode
      ? this.selectedDeclarationDetail.quote.data.to_country
      : nav_to == "endorse-cert"
      ? this.selectedEndorsementDetails.quote.data.to_country
      : subVoyageAry.to_country;
    if (this.pageContent == 8 || this.pageContent == 9) {
      from_country = isEndorsement
        ? this.selectedEndorsementData.eproposal.data.from_country
        : this.selectedDeclarationDetail.quote.data.from_country;
      to_country = isEndorsement
        ? this.selectedEndorsementData.eproposal.data.to_country
        : this.selectedDeclarationDetail.quote.data.to_country;
    } else if (this.pageContent == 10) {
      from_country = !isEndorsement
        ? this.selectedEndorsementDetails.quote.data.from_country
        : this.selectedEndorsementData.eproposal.data.from_country;
      to_country = !isEndorsement
        ? this.selectedEndorsementDetails.quote.data.to_country
        : this.selectedEndorsementData.eproposal.data.to_country;
    }
    if (
      nav_to == "update_draft" ||
      nav_to == "canc_cert" ||
      nav_to == "appr_rejt"
    ) {
      from_country = subVoyageAry.from_country;
      to_country = subVoyageAry.to_country;
    }

    this.fromCountryDetails = from_country.split("~");
    this.toCountryDetails = to_country.split("~");
    await this.assignCountryValues();
    await this.claimsPay();

    this.totalCountryDetails.sort((a, b) =>
      a.country_name > b.country_name
        ? 1
        : b.country_name > a.country_name
        ? -1
        : 0
    );

    /* Get Country Details */
    this.spinner.show();
    const refCountryUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/country_master`;
    const refCountryResponse = await this.commonService.httpGetMethod(
      refCountryUrl,
      "application/x-www-form-urlencoded; charset=UTF-8",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    this.referralCountryDetails =
      refCountryResponse.status == 0 ? refCountryResponse.data : [];

    /* if(this.pageContent == 11){
		let url = this.commonVariablesService.baseURL+'api/v1/marine_master/fetchall/subvoyage_country';
		let param;
		const voyageName = await this.commonService.removeVoyageDesc(this.voyageName);
		if(this.policyType == 'MOP' || this.policyType == 'Open Cover'){
			param = new HttpParams().set('policy_type','MOP')
			.set('voyage_name', voyageName);
		}
		else if(this.policyType == 'STOP' || this.policyType == 'Project Policy'){
			param = new HttpParams().set('policy_type','STOP')
			.set('voyage_name', voyageName);
		}
		let response = await this.commonService.httpGetMethod(url,'application/json',true,param,'Policy Configuration')
		if(response.status == 0){
			if(response.data.length>0){
				(response.data).forEach(voyageData => {
					let name = voyageData.voyage+'-'+voyageData.sub_voyage;
						this.fromCountryList[name] ?
						this.fromCountryList[name].push( voyageData.from_country)
					   : (this.fromCountryList[name] = [], this.fromCountryList[name].push( voyageData.from_country))
					   this.toCountryList[name] ?
						this.toCountryList[name].push( voyageData.to_country)
					   : (this.toCountryList[name] = [], this.toCountryList[name].push( voyageData.to_country))
				})
			}
		}
	} */
  }

  /*
   * Created By : Sharann N
   * Description : assign value to country fields.
   *********************************************/
  async assignCountryValues() {
    const details = [
      {
        formName: "from_country",
        valueAry: "fromCountryDetails",
      },
      {
        formName: "to_country",
        valueAry: "toCountryDetails",
      },
    ];
    for (const obj of details) {
      if (this[obj.valueAry].length) {
        if (this[obj.valueAry].length == 1) {
          this.declarationForm.controls[obj.formName].setValue(
            this[obj.valueAry][0]
          );
        } else {
          this[obj.valueAry] = await this.getIdentitySortArray(
            this[obj.valueAry]
          );
        }
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : remove duplicate and get sorted array.
   *********************************************/
  getIdentitySortArray(array) {
    return new Promise((resolve) => {
      const ret = Array.from(new Set(array.map((a) => a))).map((id) => {
        return array.find((a) => a != "" && a === id);
      });

      ret.sort((a, b) => (a > b ? 1 : b > a ? -1 : 0));
      return resolve(ret);
    });
  }

  /*
   * Created By : Sharann N
   * Description : check marine final rate % field.
   *********************************************/
  async checkMFR() {
    const masterSubVoyageAry = await this.getSubVoyageAry(this.gcPolicyDetails);
    let initialMFR = masterSubVoyageAry.marine_final_rate_percentage;
    this.fieldError["marine_final_rate_percentage"] = false;
    const isInvalidMFR =
      Number(this.f.marine_final_rate_percentage.value) < Number(initialMFR);
    if (!!this.f.tp_policy_no.value) {
      if (isInvalidMFR) {
        // this.fieldError['marine_final_rate_percentage'] = true;
        // this.declarationForm.controls.marine_final_rate_percentage.setErrors({ 'isExcceedMFR': true });
        this.declarationForm.controls.marine_final_rate_percentage.setValue(
          initialMFR
        );
        this.commonService.errorsmsg(this.mfrErrorMsg, "");
      } else {
        const len = (
          (
            this.declarationForm.controls.marine_final_rate_percentage.value ||
            "."
          ).indexOf(".") > -1
            ? this.declarationForm.controls.marine_final_rate_percentage
                .value || "."
            : this.declarationForm.controls.marine_final_rate_percentage.value +
              "."
        ).split(".")[1].length;
        initialMFR = String(initialMFR || ".");
        const len1 = (
          initialMFR.indexOf(".") == -1 ? initialMFR + "." : initialMFR
        ).split(".")[1].length;
        let diffLen = len1 - len;
        let mfrValue =
          this.declarationForm.controls.marine_final_rate_percentage.value;
        if (diffLen > 0) {
          while (diffLen) {
            mfrValue = mfrValue + "0";
            diffLen--;
          }
        }
        this.declarationForm.controls.marine_final_rate_percentage.setValue(
          mfrValue
        );
        this.declarationForm
          .get("marine_final_rate_percentage")
          .clearValidators();
        this.declarationForm
          .get("marine_final_rate_percentage")
          .setValidators([Validators.required]);
        this.declarationForm
          .get("marine_final_rate_percentage")
          .updateValueAndValidity();
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : to calculate premium in certificate.
   *********************************************/
  async calculateCertificatePremium(value = "") {
    // roe changes
    this.selectedValue = value;
    if (this.selectedDeclarationDetail) {
      await this.roeValidation();
      await this.checkMFR();
      // this.declarationForm.get('marine_final_rate_percentage').updateValueAndValidity();
      const nav_to = this.header.nav_to || "";
      const premiumCalcUrl = `${this.commonVariablesService.baseURL}api/v1/product/calc`;
      const subVoyageAry = this.isCloneMode
        ? await this.getSubVoyageAry(
            this.cloneMasterPolicyDetails.data.sub_voyage
          )
        : this.isDraftMode
        ? {
            coverage_type:
              this.selectedDeclarationDetail.quote.data.coverage_type,
            certificate_bulk: "certificate",
            bov_percentage:
              this.selectedDeclarationDetail.quote.data.bov_percentage,
            id: this.selectedDeclarationDetail.quote.data.sub_voyage_id,
            min_shipment_premium:
              this.selectedDeclarationDetail.quote.data.min_shipment_premium,
          }
        : nav_to == "endorse-cert"
        ? {
            coverage_type:
              this.selectedEndorsementDetails.quote.data.coverage_type,
            certificate_bulk: "certificate",
            bov_percentage:
              this.selectedEndorsementDetails.quote.data.bov_percentage,
            id: this.selectedEndorsementDetails.quote.data.sub_voyage_id,
            min_shipment_premium:
              this.selectedEndorsementDetails.quote.data.min_shipment_premium,
          }
        : await this.getSubVoyageAry(
            this.selectedDeclarationDetail.data.sub_voyage
          );
      const masterPolicyNo = this.isCloneMode
        ? this.selectedDeclarationDetail.cust_fld_3 == "" ||
          this.selectedDeclarationDetail.cust_fld_3.indexOf("P") == -1
          ? this.selectedDeclarationDetail.master_policy_no
          : this.selectedDeclarationDetail.cust_fld_3
        : nav_to == "endorse-cert"
        ? this.selectedEndorsementDetails.policy_no
        : this.isAlreadyGenerated
        ? this.header.policy_no
        : this.selectedDeclarationDetail.policy_no; //modified by sharann
      // const policyId = (this.pageContent == 8 || this.pageContent == 9 || this.pageContent == 10) ? this.selectedDeclarationDetail ? this.selectedDeclarationDetail.policy_id : this.selectedEndorsementDetails ? this.selectedEndorsementDetails.policy_id : '' : '';

      let policyId = "";
      if (
        this.pageContent == 8 ||
        this.pageContent == 9 ||
        this.pageContent == 10
      ) {
        if (this.selectedDeclarationDetail) {
          policyId = this.selectedDeclarationDetail.policy_id;
        } else if (this.selectedEndorsementDetails) {
          policyId = this.selectedEndorsementDetails.policy_id;
        }
      }

      let shipmentDate =
        this.pageContent == 11
          ? this.declarationForm.controls.expected_date_shipment.value
          : this.datePipe.transform(
              this.declarationForm.controls.expected_date_shipment.value,
              "yyyy-MM-dd"
            );
      const quoteDetails = this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data
        : nav_to == "endorse-cert"
        ? this.selectedEndorsementDetails.quote.data
        : this.selectedDeclarationDetail.quote.data;
      const data = {
        product_id: this.commonVariablesService.declarationProductId,
        master_policy_no: masterPolicyNo,
        policy_id: policyId,
        sub_voyage_id: subVoyageAry.id,
        inputs: {
          expected_date_shipment: shipmentDate ? shipmentDate : "",
          mode_of_shipment:
            this.declarationForm.controls.mode_of_shipment.value,
          coverage_type: subVoyageAry.coverage_type,
          packing: this.declarationForm.controls.packing.value,
          from_country: this.declarationForm.controls.from_country.value,
          to_country: this.declarationForm.controls.to_country.value,
          from_city: this.declarationForm.controls.from_city.value,
          to_city: this.declarationForm.controls.to_city.value,
          invoice_currency:
            this.declarationForm.controls.invoice_currency.value,
          cargo_value: await this.removeSeparator(
            this.declarationForm.controls.cargo_value.value
          ),
          duty_si: await this.removeSeparator(
            this.declarationForm.controls.duty_si.value || 0
          ),
          Certificate_Bulk: "certificate",
          certificate_bulk: "certificate",
          bov_percentage: subVoyageAry.bov_percentage,
          currency_type:
            nav_to == "endorse-cert"
              ? this.selectedEndorsementDetails.quote.data.policy_currency_type
              : this.selectedDeclarationDetail.quote.data
                  .policy_currency_type ||
                this.selectedDeclarationDetail.quote.data.currency_type,
          marine_final_rate_percentage: await this.removeSeparator(
            this.declarationForm.controls.marine_final_rate_percentage.value
          ),
          roe: await this.removeSeparator(
            this.declarationForm.controls.roe.value
          ),
          master_policy_no: masterPolicyNo,
          sub_voyage_id: subVoyageAry.id,
          min_shipment_premium: subVoyageAry.min_shipment_premium,
          tax_applicable: await this.commonService.taxApplicableStatus(
            this.pageContent == 2 && nav_to == ""
              ? quoteDetails.tax_applicable
              : quoteDetails.tax_applicable ||
                  quoteDetails.pol_tax ||
                  quoteDetails.tax_amount ||
                  0
          ),
        },
        outputs: [
          "cargo_si",
          "roe",
          "cargo_si_policy_currency",
          "total_si",
          "cargo_premium",
          "duty_premium",
          "total_premium",
          "gst",
          "net_premium_final",
          "si_deductible",
          "marine_final_rate_percentage",
        ],
      };

      if (
        this.declarationForm.controls.invoice_currency.value &&
        this.declarationForm.controls.cargo_value.value &&
        this.declarationForm.controls.roe.value
      ) {
        const response = await this.commonService.httpPostMethod(
          premiumCalcUrl,
          data,
          "application/json",
          true,
          "Declaration",
          this.impersonateFlag
        );
        this.premiumErrorMsg = "";
        if (response.body.status === 0) {
          const responseData = response.body.data;
          this.calcPremiumData = responseData;
          const roeValue = responseData.cells.roe
            ? responseData.cells.roe
            : this.declarationForm.controls.roe.value;
          this.declarationForm.patchValue({
            roe: roeValue,
            cargo_si:
              (await this.decimalPt(responseData.cells.cargo_si, true)) || "-",
            cargo_si_policy_currency: await this.decimalPt(
              responseData.cells.cargo_si_policy_currency,
              true
            ),
            total_si: await this.decimalPt(responseData.cells.total_si, true),
            cargo_premium: await this.decimalPt(
              responseData.cells.cargo_premium,
              true
            ),
            duty_premium: await this.decimalPt(
              responseData.cells.duty_premium,
              true
            ),
            total_premium: await this.decimalPt(
              responseData.cells.total_premium,
              true
            ),
            gst: await this.decimalPt(responseData.cells.gst, true),
            net_premium_final: await this.decimalPt(
              responseData.cells.net_premium_final,
              true
            ),
          });
          return true;
        } else if (response.body.status != -114) {
          const errorMsg = (response.body.txt || "").split("~");
          this.premiumErrorMsg = errorMsg[1] || "Unable to calculate Premium";
          if (this.pageContent == 11) {
            return this.premiumErrorMsg;
          } else {
            this.declarationForm.patchValue({
              cargo_si: "",
              cargo_si_policy_currency: "",
              total_si: "",
              cargo_premium: "",
              duty_premium: "",
              total_premium: "",
              gst: "",
              net_premium_final: "",
            });
            this.commonService.errorsmsg(this.premiumErrorMsg, "");
          }
        }
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : navigate to child component.
   *********************************************/
  async gotoPageContent(pageId) {
    await this.commonService.navigateToDecl(pageId);
  }

  /*
   * Created By : Sharann N
   * Description : add new client and fill existing broker user list.
   *********************************************/
  async addClientName() {
    const addClientNameVal = this.declarationForm.get("add_client_name").value;
    let newClientDetails: any = this.totalBrokerDetails.filter(
      (value) =>
        (value.insured_name || value.broker_name || "") == addClientNameVal
    );
    if (addClientNameVal == "Add New Client Name") {
      newClientDetails = [
        {
          data: {
            insured_name: "",
            insured_add1: "",
            insured_add2: "",
            insured_add3: "",
            insured_zipcode: "",
            insured_city: "",
            insured_district: "",
            insured_state: "",
            insured_country: "",
            insured_gstin: "",
          },
        },
      ];
    }
    const pincode =
      newClientDetails[0].insured_zipcode ||
      newClientDetails[0].data.zipcode ||
      "";
    const district =
      newClientDetails[0].insured_district ||
      newClientDetails[0].data.district ||
      "";
    this.declarationForm.patchValue({
      new_insured_name:
        newClientDetails[0].insured_name ||
        newClientDetails[0].data.broker_name ||
        "",
      new_insured_address_1:
        newClientDetails[0].insured_add1 ||
        (newClientDetails[0].data || {}).address_1 ||
        "",
      new_insured_address_2:
        newClientDetails[0].insured_add2 ||
        (newClientDetails[0].data || {}).address_2 ||
        "",
      new_insured_address_3:
        newClientDetails[0].insured_add3 ||
        (newClientDetails[0].data || {}).address_3 ||
        "",
      new_insured_pincode: pincode,
      new_insured_city:
        newClientDetails[0].insured_city ||
        (newClientDetails[0].data || {}).city ||
        "",
      new_insured_state:
        newClientDetails[0].insured_state ||
        (newClientDetails[0].data || {}).state ||
        "",
      new_insured_country:
        newClientDetails[0].insured_country ||
        (newClientDetails[0].data || {}).country ||
        "",
      new_insured_district:
        district == "" ? await this.getDistrict(pincode) : district,
      new_insured_gstin:
        newClientDetails[0].insured_gstin ||
        (newClientDetails[0].data || {}).gstin ||
        "",
    });
  }

  /*
   * Created By : Sharann N
   * Description : to add new broker user.
   *********************************************/
  async addNewClient() {
    this.declarationForm.patchValue({
      new_insured_name: this.declarationForm.get("client_name").value,
      new_insured_address_1: this.declarationForm.get("client_address_1").value,
      new_insured_address_2: this.declarationForm.get("client_address_2").value,
      new_insured_address_3: this.declarationForm.get("client_address_3").value,
      new_insured_pincode: this.declarationForm.get("client_pincode").value,
      new_insured_city: this.declarationForm.get("insured_city").value,
      new_insured_district: this.declarationForm.get("insured_district").value,
      new_insured_state: this.declarationForm.get("insured_state").value,
      new_insured_country: this.declarationForm.get("insured_country").value,
      new_insured_gstin: this.declarationForm.get("client_gstin").value,
    });

    const addNewClient = this.declarationForm.get("add_new_client").value;
    if (addNewClient.toLowerCase() === "yes") {
      this.isNewClient = true;
      /* for(const newData of this.defaultResponse.data){
        this.totalBrokerDetails.push(newData);
      } */
    } else {
      this.isNewClient = false;
    }
    const formField =
      this.declarationForm.get("currency_type").value.toLowerCase() == "inr"
        ? ["new_insured_name", "new_insured_address_1", "new_insured_pincode"]
        : [
            "new_insured_name",
            "new_insured_address_1",
            "new_insured_pincode",
            "new_insured_city",
            "new_insured_district",
            "new_insured_state",
            "new_insured_country",
          ];
    const validatorAry = this.isNewClient ? [Validators.required] : [];
    for (const field of formField) {
      this.declarationForm.get(field).setValidators(validatorAry);
      this.declarationForm.get(field).updateValueAndValidity();
    }
    if (
      this.declarationForm.get("currency_type").value.toLowerCase() == "inr"
    ) {
      this.declarationForm.get("new_insured_city").disable();
      this.declarationForm.get("new_insured_district").disable();
      this.declarationForm.get("new_insured_state").disable();
      this.declarationForm.get("new_insured_country").disable();
      this.selected = this.declarationForm.get("new_insured_pincode").value;
    }

    this.declarationForm.patchValue({
      add_client_name: "Add New Client Name",
      // new_insured_name: '',
      // new_insured_address_1: '',
      // new_insured_address_2: '',
      // new_insured_address_3: '',
      // new_insured_pincode: '',
      // new_insured_city: '',
      // new_insured_district: '',
      // new_insured_state: '',
      // new_insured_country: '',
      // new_insured_gstin: ''
    });
  }

  /*
   * Created By : Sharann N
   * Description : to save or update the quote(certificate).
   *********************************************/
  async saveOrUpdateQuote() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    if ((this.f.net_premium_final.value || "") == "") {
      this.commonService.errorsmsg(
        this.premiumErrorMsg || "Premium or Sum Insured value Cannot be zero!",
        ""
      );
      return;
    }
    this.spinner.show();
    this.isShowSubmitButton = true;
    const ret = await this.validateForm();
    if (ret == 1) {
      if (await this.declarationForm.valid) {
        //Ticket No -154865
        this.isShowSubmitButton = true;
        await this.assignValueToForm();
        if ((this.header.nav_to || "") == "endorse-cert") {
          this.saveEndorsement(-1);
        } else {
          const ret1 =
            this.getUserType != "helpdesk" ? await this.checkUwCase() : false;
          ret1 ? this.openModal(this.uwCase) : this.saveQuoteData();
        }
      } else {
        this.spinner.hide();
        await this.focusOnInvalidFormField(this.declarationForm);
      }
    } else if (ret == 0) {
      this.spinner.hide();
      this.isShowSubmitButton = false;
      this.commonService.warningmsg("Please fill Mandatory fields", "Warning");
    }
  }

  /*
   * Created By : Sharann N
   * Description : to set value for settling agent field.
   *********************************************/
  async settlingAgent() {
    const selectedSettlingAgent = this.settlingAgentDetails.filter(
      (value) =>
        (value.settling_agent_value || "").toLowerCase() ==
        (this.declarationForm.get("settling_agent").value || "").toLowerCase()
    );
    this.declarationForm.controls["claims_rep"].setValue(
      selectedSettlingAgent[0].settling_agent
    );
    if (selectedSettlingAgent.length) {
      this.declarationForm.patchValue({
        settling_agent_company: selectedSettlingAgent[0].company_name,
        settling_agent_address: selectedSettlingAgent[0].address,
        settling_agent_phone: selectedSettlingAgent[0].phone_no,
        settling_agent_email: selectedSettlingAgent[0].email_id,
      });
    }
  }

  /*
   * Created By : Sharann N
   * Description : to load saved Certificate data in preview screen.
   *********************************************/
  async loadSavedCertificateData() {
    this.selectedDeclarationDetail = await this.getPolicyData(
      this.header.policy_id
    );
    if (JSON.stringify(this.selectedDeclarationDetail) == "{}") return;

    /* let tmpUserType = this.cookie.get('userProfile'); */
    let tmpUserType = window.localStorage.getItem("userProfile");
    const userType = this.commonService.decryptData(tmpUserType);

    // validating policy status to block the users actions
    this.isPolicyCancelled =
      this.allowCert.toLowerCase() == "no" &&
      userType.toLowerCase() == "produceruser"
        ? true
        : false;
    const cert_status = this.header.certificate_status || "";
    this.certificateStatus = [
      "marineclaims",
      "rm",
      "helpdesk",
      "ops",
      "adminview",
    ].includes((this.getUserType || "").toLowerCase())
      ? ""
      : (cert_status != ""
          ? cert_status
          : await this.commonService.findCertificateStatus(
              this.selectedDeclarationDetail
            )
        ).toLowerCase();
    const balance: any = await this.calcPolicyBalance(
      this.selectedDeclarationDetail.quote.data.cust_fld_3,
      this.isEndorsement
        ? this.isPremiumEndorsement
          ? this.editableFields.expected_date_shipment
          : this.selectedDeclarationDetail.quote.data.expected_date_shipment
        : this.selectedDeclarationDetail.quote.data.expected_date_shipment
    );
    this.selectedDeclarationDetail.opening_balance =
      balance.without_date.available_opening_balance_certificate.toFixed(2);
    this.selectedDeclarationDetail.balance_premium =
      balance.without_date.available_premium_balance_certificate.toFixed(2);
    this.selectedDeclarationDetail.quote.data.cargo_si =
      this.selectedDeclarationDetail.quote.data.cargo_si.toFixed(2);
    this.selectedDeclarationDetail.quote.data.total_si =
      this.selectedDeclarationDetail.quote.data.total_si.toFixed(2);
    this.selectedDeclarationDetail.quote.data.net_premium_final =
      this.selectedDeclarationDetail.quote.data.net_premium_final.toFixed(2);
    this.isReferral = this.selectedDeclarationDetail.quote.data.referral_type;
    await this.setMinMaxDate();
    if (
      this.certificateStatus.toLowerCase() == "cancelled" &&
      this.totalEndorseResponseData.length
    ) {
      const resp =
        this.totalEndorseResponseData[this.totalEndorseResponseData.length - 1];
      /* let header = JSON.parse(sessionStorage.getItem('declaration-header')); */
      let header = JSON.parse(
        window.localStorage.getItem("declaration-header") || "{}"
      );
      header.endores_policy_id =
        this.totalEndorseResponseData.length == 1 ? "" : resp.policy_id || "";
      header.endorsement_id =
        this.totalEndorseResponseData.length == 1
          ? ""
          : resp.endorsement_id || "";
      /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
      window.localStorage.setItem("declaration-header", JSON.stringify(header));
    }
    /* this.header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    this.isViewMode = this.header.nav_to == "view_draft_cert" ? true : false; //by gomathi
    this.isViewCertificate = this.header.nav_to == "view_cert" ? true : false; //by gomathi
    this.isEditableCertificate =
      this.header.nav_to == "acc_del_draft" ? true : false; //by gomathi

    this.selectedEndorsementData =
      (this.header.endorsement_id || "") == ""
        ? {}
        : await this.getEndromentDetails(this.header.endorsement_id);
    if (JSON.stringify(this.selectedEndorsementData) == "{}") {
      this.isEndorsement = false;
      this.editableFields = { ...this.selectedDeclarationDetail.quote.data };
      this.selectedDeclarationDetail[
        "certificate_no"
      ] = `${this.selectedDeclarationDetail.quote.cust_fld_6}_00`;
      this.isOriginalDownladed =
        (
          (this.selectedDeclarationDetail.data || {}).is_original_downloaded ||
          ""
        ).toLowerCase() == "yes"
          ? true
          : false;
    } else {
      this.isEndorsement = true;
      this.editableFields = { ...this.selectedEndorsementData.eproposal.data };
      this.isPremiumEndorsement =
        (this.selectedEndorsementData.eproposal.data.endorsement_name || "")
          .toLowerCase()
          .replace(/\s/g, "") ==
        this.commonService.declarationPremiumEndorsement
          ? true
          : false;
      this.selectedDeclarationDetail["certificate_no"] = `${
        this.selectedDeclarationDetail.quote.cust_fld_6
      }_${("0" + this.selectedEndorsementData.endorsement_index).slice(-2)}`;
      this.isOriginalDownladed =
        (
          (this.selectedDeclarationDetail.data || {})[
            `is_${
              this.selectedEndorsementData.endorsement_id || ""
            }_original_downloaded`
          ] || ""
        ).toLowerCase() == "yes"
          ? true
          : false;
    }
    // check certificate is already issued with zero endorsment & certificate having the endorsement number or not.
    const temp =
      (this.isEndorsement == false && this.certificateStatus == "issued") ||
      (this.isEndorsement == true &&
        (this.selectedEndorsementData.endorsement_no || "") != "")
        ? ""
        : this.certificateStatus;
    this.ableToIssue = temp == "draft" || temp == "issued";
    this.selectedDeclarationDetail["voyage_name"] =
      await this.commonService.getVoyageDesc(
        this.gcPolicyDetails.quote.data.voyage
      );
    this.selectedDeclarationDetail["total_si"] = await this.decimalPt(
      this.isEndorsement
        ? this.isPremiumEndorsement
          ? this.editableFields.total_si
          : this.selectedDeclarationDetail.quote.data.total_si
        : this.selectedDeclarationDetail.quote.data.total_si,
      true
    );
    this.selectedDeclarationDetail["net_premium_final"] = this.isEndorsement
      ? this.isPremiumEndorsement
        ? this.editableFields.net_premium_final
        : this.selectedDeclarationDetail.quote.data.net_premium_final
      : this.selectedDeclarationDetail.quote.data.net_premium_final;

    if (this.editableFields.default_new_client == "Yes") {
      this.editableFields["new_insured_district"] = await this.getDistrict(
        this.editableFields.new_insured_pincode
      );
    }
    //district-change
    // } else {
    //   this.editableFields['insured_district'] = await this.getDistrict(this.editableFields.client_pincode);
    // }
    if (this.pageContent == 3) {
      const countryUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/country`;
      const countryResponse = await this.commonService.httpGetMethod(
        countryUrl,
        "application/x-www-form-urlencoded; charset=UTF-8",
        true,
        {},
        "Declaration",
        this.impersonateFlag
      );
      this.totalCountryDetails =
        countryResponse.status == 0 ? countryResponse.data : [];
      this.settlingAgentValue = await this.formSettlingAgentName(
        this.isPremiumEndorsement
          ? this.editableFields.settling_agent
          : this.selectedDeclarationDetail.quote.data.settling_agent
      );
      this.claimsRepValue = await this.formSettlingAgentName(
        this.selectedDeclarationDetail.quote.data.claims_rep
      );
      let updatedNonStdClause = this.isEndorsement
        ? this.isPremiumEndorsement
          ? this.editableFields.non_std_clause
          : this.selectedDeclarationDetail.quote.data.non_std_clause
        : this.selectedDeclarationDetail.quote.data.non_std_clause;
      this.nonStdClause = `${
        JSON.stringify(
          this.selectedDeclarationDetail.quote.data.non_std_clause_policy_setup
        ) == JSON.stringify(updatedNonStdClause)
          ? this.selectedDeclarationDetail.quote.data
              .non_std_clause_policy_setup
          : updatedNonStdClause
      }`;
      this.selectedDeclarationDetail["expected_date_shipment"] = this
        .isEndorsement
        ? await this.commonService.formatDate(
            this.isPremiumEndorsement
              ? this.editableFields.expected_date_shipment
              : this.selectedDeclarationDetail.quote.data
                  .expected_date_shipment,
            "dd-MM-yyyy"
          )
        : await this.commonService.formatDate(
            this.selectedDeclarationDetail.quote.data.expected_date_shipment,
            "dd-MM-yyyy"
          );
      this.selectedDeclarationDetail["bill_date"] =
        await this.commonService.formatDate(
          this.isEndorsement
            ? this.editableFields.bill_date
            : this.selectedDeclarationDetail.quote.data.bill_date,
          "dd-MM-yyyy"
        );
      this.selectedDeclarationDetail["invoice_date"] = this.isEndorsement
        ? await this.commonService.formatDate(
            this.isPremiumEndorsement
              ? this.editableFields.invoice_date
              : this.selectedDeclarationDetail.quote.data.invoice_date,
            "dd-MM-yyyy"
          )
        : await this.commonService.formatDate(
            this.selectedDeclarationDetail.quote.data.invoice_date,
            "dd-MM-yyyy"
          );
      this.selectedDeclarationDetail["issue_date"] = this.isEndorsement
        ? await this.commonService.formatDate(
            this.isPremiumEndorsement
              ? this.editableFields.issue_date
              : this.selectedDeclarationDetail.quote.data.issue_date,
            "dd-MM-yyyy"
          )
        : await this.commonService.formatDate(
            this.selectedDeclarationDetail.quote.data.issue_date,
            "dd-MM-yyyy"
          );
      const lc_det = this.isEndorsement
        ? this.editableFields.lc_details
        : this.selectedDeclarationDetail.quote.data.lc_details;
      let ret = await this.commonService.checkNull(lc_det);
      this.selectedDeclarationDetail["lc_details"] = ret ? "" : lc_det;
      const subjt = this.isEndorsement
        ? this.editableFields.subject_matter_insured
        : this.selectedDeclarationDetail.quote.data.subject_matter_insured;
      ret = await this.commonService.checkNull(subjt);
      this.selectedDeclarationDetail["subject_matter_insured"] = ret
        ? ""
        : subjt;
      const mark = this.isEndorsement
        ? this.editableFields.marks_numbers
        : this.selectedDeclarationDetail.quote.data.marks_numbers;
      ret = await this.commonService.checkNull(mark);
      this.selectedDeclarationDetail["marks_numbers"] = ret ? "" : mark;
    }
  }

  /*
   * Created By : Sharann N
   * Description : check roe validation.
   *********************************************/
  async roeValidation() {
    let currencyType = this.declarationForm.get("currency_type").value;
    let invoiceCurrency = this.declarationForm.get("invoice_currency").value;
    let roe = this.f.roe.value;
    currencyType = currencyType == "DOLLAR" ? "USD" : currencyType;
    invoiceCurrency = invoiceCurrency == "DOLLAR" ? "USD" : invoiceCurrency;
    await this.getRoeDetails();
    const roeDetails: any = this.selectedRoeDetails.filter((value) => {
      return (
        (value.from_currency || "") == invoiceCurrency &&
        (value.to_currency || "") == this.f.currency_type.value
      );
    });
    const isMismatchInvoice =
      !this.prevInvoiceCurrency || this.prevInvoiceCurrency != invoiceCurrency
        ? true
        : false;
    const roeValue = invoiceCurrency
      ? currencyType == "INR"
        ? isMismatchInvoice
          ? roeDetails.length
            ? roeDetails[0].roe_value
            : ""
          : roe
        : isMismatchInvoice
        ? ""
        : roe
      : roe;
    this.prevInvoiceCurrency = invoiceCurrency;
    currencyType = currencyType == "DOLLAR" ? "USD" : currencyType;
    invoiceCurrency = invoiceCurrency == "DOLLAR" ? "USD" : invoiceCurrency;

    if (
      (this.pageContent == 8 &&
        this.getUserType != "underwriter" &&
        this.getUserType != "helpdesk") ||
      this.pageContent == 10
    )
      return;
    if (currencyType == invoiceCurrency) {
      this.declarationForm.controls["roe"].setValue("1");
      this.declarationForm.get("roe").disable();
      this.declarationForm.get("roe").setValidators([]);
      this.declarationForm.get("roe").updateValueAndValidity();
    } else if (
      (currencyType == "INR" && invoiceCurrency != "INR") ||
      (currencyType != "INR" && currencyType != invoiceCurrency)
    ) {
      // roe changes
      if (this.getUserType !== "underwriter")
        this.declarationForm.controls["roe"].setValue(roeValue);
      // roe changes
      else if (this.selectedValue === "Invoice Currency") {
        this.declarationForm.controls["roe"].setValue(roeValue);
      }
      if (this.pageContent == 2) {
        this.declarationForm.controls["roe"].enable();
      }
      this.declarationForm.get("roe").setValidators([Validators.required]);
      this.declarationForm.get("roe").updateValueAndValidity();
    }
    await this.checkRoe();
  }

  /*
   * Created By : Sharann N
   * Description : to download original/copy pdf.
   *********************************************/
  policyPdfDownload(isOriginal, idx = 0) {
    const isEndorse =
      isOriginal == -1
        ? this.historyData.contentData[idx].is_endorsement
        : this.isEndorsement;
    const endorseId =
      isOriginal == -1
        ? this.historyData.contentData[idx].endorsement_id
        : this.selectedEndorsementData.endorsement_id || "";
    const isOriginalDownload =
      (!isEndorse &&
        (
          this.selectedDeclarationDetail.data.is_original_downloaded || ""
        ).toLowerCase() == "yes") ||
      (isEndorse &&
        (
          this.selectedDeclarationDetail.data[
            `is_${endorseId}_original_downloaded`
          ] || ""
        ).toLowerCase() == "yes")
        ? true
        : false;
    if (isOriginalDownload && isOriginal == 1) {
      this.commonService.errorsmsg("Original PDF is already downoaded", "");
    } else {
      this.spinner.show();
      const policyId =
        isOriginal == -1
          ? this.historyData.contentData[idx].policy_id
          : this.selectedDeclarationDetail.policy_id || "";
      const certNo =
        isOriginal == -1
          ? this.historyData.contentData[idx].certificate_no
          : this.selectedDeclarationDetail.certificate_no;
      const url = `${
        this.commonVariablesService.baseURL
      }api/v1/marine_declaration/certificate_pdf?${
        isEndorse ? "endorsement_id=" + endorseId : "policy_id=" + policyId
      }${isOriginal == 1 ? "&pdf_type=original" : ""}`;
      try {
        this.commonService
          .getPdf(url, false)
          .subscribe(async (pdfData: any) => {
            const blob =
              (pdfData.type || "") == "application/pdf"
                ? pdfData
                : new Blob([pdfData], { type: "application/pdf" });
            var downloadURL = window.URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.href = downloadURL;
            link.download = `Policy-${certNo}.pdf`;
            link.click();
            this.spinner.hide();
            if (this.pageContent == 4) {
              await this.loadSavedCertificateData();
            } else if (this.pageContent == 6) {
              $("#history_table").DataTable().destroy();
              await this.loadHistoryData();
            }
          });
      } catch (error) {
        this.spinner.hide();
        this.commonService.errorsmsg(error || "Unable to download PDF", "");
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : get location using pincode.
   *********************************************/
  async getLocation(isNewInsuredPincode) {
    let formFieldName = "client_pincode";
    if (isNewInsuredPincode) {
      formFieldName = "new_insured_pincode";
    }
    const pincodeVal = this.declarationForm.get(formFieldName).value;
    if (!this.commonService.numberPattern.test(pincodeVal)) {
      //this.declarationForm.controls[formFieldName].setErrors({ 'pincode_invalid': true });
      this.declarationForm.controls[formFieldName].setErrors({
        pincode_invalid: true,
      });
      if (this.pageContent == 11) {
        return false;
      }
    } else {
      const pincodeDetails: any = this.totalNewPincodeDetails.filter(
        (value) => (value.num_pincode || "") == pincodeVal
      );
      this.declarationForm.patchValue({
        new_insured_city: pincodeDetails.length
          ? isNewInsuredPincode
            ? pincodeDetails[0].txt_city || ""
            : pincodeDetails[0].num_city_cd || ""
          : "",
        new_insured_district: pincodeDetails.length
          ? isNewInsuredPincode
            ? pincodeDetails[0].txt_district || ""
            : pincodeDetails[0].num_citydistrict_cd || ""
          : "",
        new_insured_state: pincodeDetails.length
          ? isNewInsuredPincode
            ? pincodeDetails[0].txt_state || ""
            : pincodeDetails[0].num_state_cd || ""
          : "",
        new_insured_country: pincodeDetails.length
          ? isNewInsuredPincode
            ? pincodeDetails[0].txt_country || ""
            : pincodeDetails[0].num_country_cd || ""
          : "",
      });
    }
  }

  /*
   * Created By : Sharann N
   * Description : dropdown for pincode.
   *********************************************/
  async newClientPincode(
    event: any,
    fieldValue: any = "",
    isKeyPress: boolean = true
  ) {
    if (this.pageContent != 11) {
      const inputChar = String.fromCharCode(
        !event.charCode ? event.which : event.charCode
      );
      fieldValue = isKeyPress ? fieldValue.concat(inputChar) : fieldValue;
    }
    if (fieldValue.length >= 3) {
      const pincodeUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/pincode`;
      const pincodeParamData = {
        num_pincode: fieldValue, //"62501"
      };
      const response = await this.commonService.httpGetMethod(
        pincodeUrl,
        "application/json",
        true,
        pincodeParamData,
        "Declaration",
        this.impersonateFlag
      );
      this.totalNewPincodeDetails = response.status == 0 ? response.data : [];
      this.totalNewPincodeDetails = Array.from(
        new Set(this.totalNewPincodeDetails.map((a) => a.num_pincode))
      ).map((id) => {
        return (
          this.totalNewPincodeDetails.find(
            (a) => a.num_pincode != "" && a.num_pincode === id
          ) || {
            num_pincode: "",
            txt_pincode_locality: "",
            txt_district: "",
            txt_city: "",
            txt_state: "",
            txt_country: "",
          }
        );
      });
      this.totalNewPincodeDetails.forEach((obj, index) => {
        obj["search_val"] = obj.num_pincode || "";
        obj["pincode"] = obj.num_pincode || "";
      });
    }
  }

  /*
   * Created By : Sharann N
   * Description : trigger the pincode select on dropdown.
   *********************************************/
  async typeaheadOnSelect(e: any) {
    this.selected = e.value ? e.value.split("~$")[0] : "";
    await this.getLocation(true);
  }

  /*
   * Created By : Sharann N
   * Description : trigger if no result for entered pincode.
   *********************************************/
  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
  }

  /*
   * Created By : Sharann N
   * Description : get master policy balance.
   *********************************************/
  async calcPolicyBalance(policyNo, shipmentDate) {
    const avalBalcUrl = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/policy_balance`;
    let balcParamData = {
      policy_no: policyNo,
    };
    let balcParamData1 = {
      policy_no: policyNo,
    };
    let response: any = {};
    if (shipmentDate) {
      balcParamData["date_of_dec"] = this.datePipe.transform(
        new Date(shipmentDate),
        "yyyy-MM-dd"
      );
      response =
        policyNo != undefined
          ? await this.commonService.httpGetMethod(
              avalBalcUrl,
              "application/json",
              true,
              balcParamData,
              "Declaration",
              this.impersonateFlag
            )
          : {
              data: {
                available_premium_balance_bulk: 0,
                available_opening_balance_bulk: 0,
                available_opening_balance_certificate: 0,
                available_premium_balance_certificate: 0,
              },
            };
    } else {
      response = {
        status: 0,
        data: {
          available_premium_balance_bulk: -1,
          available_opening_balance_bulk: -1,
          available_opening_balance_certificate: -1,
          available_premium_balance_certificate: -1,
        },
        txt: "",
      };
    }
    const response1 =
      policyNo != undefined
        ? await this.commonService.httpGetMethod(
            avalBalcUrl,
            "application/json",
            true,
            balcParamData1,
            "Declaration",
            this.impersonateFlag
          )
        : {
            data: {
              available_premium_balance_bulk: 0,
              available_opening_balance_bulk: 0,
              available_opening_balance_certificate: 0,
              available_premium_balance_certificate: 0,
            },
          };
    let ret: any = {},
      ret1: any = {},
      balance_res: any = {};

    if (response.status == 0 && response1.status == 0) {
      ret = response.data || {};
      ret1 = response1.data || {};
      if (
        ret.available_opening_balance_certificate >
        ret1.available_opening_balance_certificate
      ) {
        ret.available_opening_balance_certificate =
          ret1.available_opening_balance_certificate;
      }
      if (
        ret.available_premium_balance_certificate >
        ret1.available_premium_balance_certificate
      ) {
        ret.available_premium_balance_certificate =
          ret1.available_premium_balance_certificate;
      }
      balance_res = {
        without_date: ret1,
        min_balance:
          ret.available_opening_balance_certificate == -1 ? ret1 : ret,
      };
    } else if (response1.status != -114) {
      this.commonService.errorsmsg(
        response1.txt || "Unable to get master balance",
        ""
      );
    } else if (response.status != -114) {
      this.commonService.errorsmsg(
        response.txt || "Unable to get master balance",
        ""
      );
    }
    return balance_res;
  }

  /*
   * Created By : Sharann N
   * Description : validate the reactive form.
   *********************************************/
  async validateForm() {
    const isUpdateCert =
      (this.header.nav_to || "") == "endorse-cert" ? true : false;
    const formFieldAry =
      this.isAlreadyGenerated && this.isNstpEnabled
        ? ["reason_nstp"]
        : this.getUserType != "underwriter" && this.getUserType != "helpdesk"
        ? this.isRefToUw
          ? ["reason_change", "fields_to_change"]
          : this.isNewClient
          ? [
              "new_insured_name",
              "new_insured_address_1",
              "new_insured_pincode",
              "new_insured_city",
              "new_insured_district",
              "new_insured_state",
              "new_insured_country",
            ]
          : []
        : [];
    const validatorAry: any =
      (this.getUserType != "underwriter" && this.getUserType != "helpdesk") ||
      (this.isAlreadyGenerated && this.isNstpEnabled)
        ? [Validators.required]
        : [];
    for (const formField of formFieldAry) {
      this.declarationForm.get(formField).setValidators(validatorAry);
      this.declarationForm.get(formField).updateValueAndValidity();
    }
    this.uwRefferralReasons = [];
    if (this.getUserType != "underwriter" && this.getUserType != "helpdesk") {
      /* Lock date validation */
      const portalLockDate: any = new Date(
        this.isCloneMode
          ? this.cloneMasterPolicyDetails.quote.data.portal_lock_date
          : this.isDraftMode
          ? this.selectedDeclarationDetail.quote.data.portal_lock_date
          : isUpdateCert
          ? this.selectedEndorsementDetails.quote.data.portal_lock_date
          : this.selectedDeclarationDetail.data.portal_lock_date
      );
      const shipmentDate: any = new Date(
        this.declarationForm.controls.expected_date_shipment.value
      );
      const diffDays = Math.floor(
        (shipmentDate - portalLockDate) / (1000 * 60 * 60 * 24)
      );
      const isValid = diffDays > 0 ? true : false;
      if (isValid) {
        this.uwRefferralReasons.push(this.lockDateMsg);
      }
    }
    this.isCertificateAllowed = true;
    if (this.uwRefferralReasons.length) {
      this.modalRef = await this.modalService.show(
        this.uwCase,
        this.configCenter
      );
      this.isCertificateAllowed = false;
      this.spinner.hide();
      return -1;
    }
    if (this.declarationForm.invalid) {
      this.submitted = true;
      return 0;
    }
    return 1;
  }

  /*
   * Created By : Sharann N
   * Description : to finalize the quote and convert to policy.
   *********************************************/
  async payment(selectedData) {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    await this.spinner.show();
    this.isShowIssueCert = true;
    /* this.header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}') */
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    let tmpParam = await this.insuringClauseParam();
    let paramMany = {
      insureClauseParam: tmpParam,
      headerEndorsementId: this.header.endorsement_id || "",
      eproposalId: this.selectedEndorsementData.eproposal_id || "",
      //"fSiDeductible": (this.f.si_deductible.value || ''),
      fSiDeductible: this.declarationForm
        ? this.declarationForm.controls.si_deductible.value
        : this.selectedDeclarationDetail.quote.data.f_si_deductible || "",
      quoteId: this.selectedDeclarationDetail.quote_id || "",
      masterPolicyNo: this.selectedDeclarationDetail.quote.data.cust_fld_3 || "",
    };

    if ((this.header.endorsement_id || "") == "") {
      let quoteCreationParams: any = {
        Certificate_Bulk: "certificate",
        add_new_client:
          this.selectedDeclarationDetail.quote.data.add_new_client,
        backdate_days: this.selectedDeclarationDetail.quote.data.back_date_days,
        balance_premium: this.selectedDeclarationDetail.balance_premium,
        bov_percentage:
          this.selectedDeclarationDetail.quote.data.bov_percentage,
        bulk_declaration_type:
          this.selectedDeclarationDetail.quote.data.bulk_declaration_type,
        cancel_cert: this.selectedDeclarationDetail.quote.data.cancel_cert,
        cargo_premium: this.selectedDeclarationDetail.quote.data.cargo_premium,
        cargo_si: this.selectedDeclarationDetail.quote.data.cargo_si,
        cargo_si_policy_currency:
          this.selectedDeclarationDetail.quote.data.cargo_si_policy_currency,
        cargo_value: this.selectedDeclarationDetail.quote.data.cargo_value,
        cert_no: this.selectedDeclarationDetail.quote.data.cert_no,
        certificate_allowed:
          this.selectedDeclarationDetail.quote.data.certificate_allowed,
        claims_payable_at:
          this.selectedDeclarationDetail.quote.data.claims_payable_at,
        claims_rep: this.selectedDeclarationDetail.quote.data.claims_rep,
        client_address_1:
          this.selectedDeclarationDetail.quote.data.client_address_1,
        client_address_2:
          this.selectedDeclarationDetail.quote.data.client_address_2,
        client_address_3:
          this.selectedDeclarationDetail.quote.data.client_address_3,
        client_gstin: this.selectedDeclarationDetail.quote.data.client_gstin,
        client_name: this.selectedDeclarationDetail.quote.data.client_name,
        client_pincode:
          this.selectedDeclarationDetail.quote.data.client_pincode,
        coverage_type: this.selectedDeclarationDetail.quote.data.coverage_type,
        currency_type: this.selectedDeclarationDetail.quote.data.currency_type,
        cust_fld_1: this.selectedDeclarationDetail.quote.data.cust_fld_1,
        cust_fld_2: this.selectedDeclarationDetail.quote.data.cust_fld_2,
        cust_fld_3: this.selectedDeclarationDetail.quote.data.cust_fld_3,
        cust_fld_4: this.selectedDeclarationDetail.quote.data.cust_fld_4,
        cust_fld_9: this.selectedDeclarationDetail.quote.data.cust_fld_9,
        days_post_expiry:
          this.selectedDeclarationDetail.quote.data.days_post_expiry,
        declaration_type:
          this.selectedDeclarationDetail.quote.data.declaration_type,
        default_new_client:
          this.selectedDeclarationDetail.quote.data.default_new_client,
        duty_premium: this.selectedDeclarationDetail.quote.data.duty_premium,
        duty_si: this.selectedDeclarationDetail.quote.data.duty_si,
        // expected_date_shipment: this.selectedDeclarationDetail.quote.data.expected_date_shipment,
        expected_date_shipment: this.datePipe.transform(
          this.selectedDeclarationDetail.quote.data.expected_date_shipment,
          "yyyy-MM-dd"
        ),
        bill_no: this.selectedDeclarationDetail.quote.data.bill_no,
        // bill_date: this.selectedDeclarationDetail.quote.data.bill_date,
        bill_date: this.datePipe.transform(
          this.selectedDeclarationDetail.quote.data.bill_date,
          "yyyy-MM-dd"
        ),
        from_city: this.selectedDeclarationDetail.quote.data.from_city,
        from_country: this.selectedDeclarationDetail.quote.data.from_country,
        from_city_country:
          this.selectedDeclarationDetail.quote.data.from_city +
          "," +
          this.selectedDeclarationDetail.quote.data.from_country,
        to_city_country:
          this.selectedDeclarationDetail.quote.data.to_city +
          "," +
          this.selectedDeclarationDetail.quote.data.to_country,
        gst: this.selectedDeclarationDetail.quote.data.gst,
        insured_city: this.selectedDeclarationDetail.quote.data.insured_city,
        insured_district:
          this.selectedDeclarationDetail.quote.data.insured_district,
        insured_country:
          this.selectedDeclarationDetail.quote.data.insured_country,
        insured_state: this.selectedDeclarationDetail.quote.data.insured_state,
        invoice_currency:
          this.selectedDeclarationDetail.quote.data.invoice_currency,
        // invoice_date: this.selectedDeclarationDetail.quote.data.invoice_date,
        invoice_date: this.datePipe.transform(
          this.selectedDeclarationDetail.quote.data.invoice_date,
          "yyyy-MM-dd"
        ),
        invoice_no: this.selectedDeclarationDetail.quote.data.invoice_no,
        issuance_place:
          this.selectedDeclarationDetail.quote.data.issuance_place,
        // issue_date: this.selectedDeclarationDetail.quote.data.issue_date,
        issue_date: this.datePipe.transform(
          this.selectedDeclarationDetail.quote.data.issue_date,
          "yyyy-MM-dd"
        ),
        marine_final_rate_percentage:
          this.selectedDeclarationDetail.quote.data
            .marine_final_rate_percentage,
        //master_policy_no: this.selectedDeclarationDetail.policy_no,
        master_policy_no: this.selectedDeclarationDetail.quote.data.cust_fld_3,
        mode_of_conveyance:
          this.selectedDeclarationDetail.quote.data.mode_of_shipment,
        mode_of_shipment:
          this.selectedDeclarationDetail.quote.data.mode_of_shipment,
        net_premium_final:
          this.selectedDeclarationDetail.quote.data.net_premium_final,
        non_std_clause:
          this.selectedDeclarationDetail.quote.data.non_std_clause,
        non_std_clause_policy_setup:
          this.selectedDeclarationDetail.quote.data.non_std_clause_policy_setup,
        premium_display_policy_setup:
          this.selectedDeclarationDetail.quote.data
            .premium_display_policy_setup,
        opening_balance: this.selectedDeclarationDetail.opening_balance,
        packing: this.selectedDeclarationDetail.quote.data.packing,
        per_seeding_limit:
          this.selectedDeclarationDetail.quote.data.per_seeding_limit,
        pol_back_days: this.selectedDeclarationDetail.quote.data.pol_back_days,
        pol_bov: this.selectedDeclarationDetail.quote.data.pol_bov,
        pol_bulk_decl_type:
          this.selectedDeclarationDetail.quote.data.pol_bulk_decl_type,
        pol_certificate_allowed_yn:
          this.selectedDeclarationDetail.quote.data.certificate_allowed,
        pol_certificate_bulk: "certificate",
        pol_end_date: this.selectedDeclarationDetail.quote.data.pol_end_date,
        pol_marine_rate:
          this.selectedDeclarationDetail.quote.data.pol_marine_rate,
        pol_mode_conveyance:
          this.selectedDeclarationDetail.quote.data.pol_mode_conveyance,
        pol_policy_currency:
          this.selectedDeclarationDetail.quote.data.policy_currency_type,
        pol_policy_type: this.selectedDeclarationDetail.quote.data.policy_type,
        pol_start_date:
          this.selectedDeclarationDetail.quote.data.pol_start_date,
        pol_voyage: this.selectedDeclarationDetail.quote.data.pol_voyage,
        pol_sub_voyage:
          this.selectedDeclarationDetail.quote.data.pol_sub_voyage,
        pol_si: this.selectedDeclarationDetail.quote.data.pol_si,
        pol_tax: this.selectedDeclarationDetail.quote.data.tax_applicable,
        pol_psl: this.selectedDeclarationDetail.pol_psl,
        pol_post_days: this.selectedDeclarationDetail.quote.data.pol_post_days,
        policy_id: this.selectedDeclarationDetail.policy_id,
        policy_type: this.selectedDeclarationDetail.quote.data.policy_type,
        premium_value: this.selectedDeclarationDetail.quote.data.premium_value,
        product_id: this.commonVariablesService.declarationProductId,
        quote_id: this.selectedDeclarationDetail.quote_id,
        reason_cancel: this.selectedDeclarationDetail.quote.data.reason_cancel,
        reason_cancellation:
          this.selectedDeclarationDetail.quote.data.reason_cancellation,
        retain_cert: this.selectedDeclarationDetail.quote.data.retain_cert,
        settling_agent:
          this.selectedDeclarationDetail.quote.data.settling_agent,
        settling_agent_company:
          this.selectedDeclarationDetail.quote.data.settling_agent_company,
        settling_agent_address:
          this.selectedDeclarationDetail.quote.data.settling_agent_address,
        settling_agent_phone:
          this.selectedDeclarationDetail.quote.data.settling_agent_phone,
        settling_agent_email:
          this.selectedDeclarationDetail.quote.data.settling_agent_email,
        sub_voyage_type:
          this.selectedDeclarationDetail.quote.data.sub_voyage_type,
        subject_matter_insured:
          this.selectedDeclarationDetail.quote.data.subject_matter_insured,
        sum_insured_percentage:
          this.selectedDeclarationDetail.quote.data.sum_insured_percentage,
        tax_amount: this.selectedDeclarationDetail.quote.data.tax_applicable,
        to_city: this.selectedDeclarationDetail.quote.data.to_city,
        to_country: this.selectedDeclarationDetail.quote.data.to_country,
        total_premium: this.selectedDeclarationDetail.quote.data.total_premium,
        total_si: this.selectedDeclarationDetail.quote.data.total_si,
        tp_policy_no: this.selectedDeclarationDetail.quote.data.cust_fld_1,
        voyage_name: this.selectedDeclarationDetail.quote.data.voyage_name,
        __finalize: 1,
      };
      paramMany["quoteParam"] = quoteCreationParams;

      let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/client_user_for_certificate/paymentCertificate?productname=emarine`;
      let response = await this.commonService.httpPostMethod(
        url,
        paramMany,
        "application/json",
        true,
        "Declaration"
      );

      if (response.body.status == 0) {
        await this.spinner.hide();

        this.selectedDeclarationDetail = response.body.data;
        /* let header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
        let header = JSON.parse(
          window.localStorage.getItem("declaration-header") || "{}"
        );
        header.tp_policy_no = this.selectedDeclarationDetail.cust_fld_1 || "";
        header.insured_name =
          (
            this.selectedDeclarationDetail.quote.data.default_new_client || ""
          ).toLowerCase() == "yes"
            ? this.selectedDeclarationDetail.quote.data.new_insured_name || ""
            : this.selectedDeclarationDetail.quote.data.client_name || "";
        header.insured_city =
          this.selectedDeclarationDetail.quote.data.insured_branch || "";
        header.policy_id = this.selectedDeclarationDetail.policy_id || "";
        header.quote_id = this.selectedDeclarationDetail.quote_id || "";
        header.header_policy = this.selectedDeclarationDetail.cust_fld_1 || "";
        header.policy_no = this.selectedDeclarationDetail.cust_fld_3 || "";
        /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
        window.localStorage.setItem(
          "declaration-header",
          JSON.stringify(header)
        );
        if (this.pageContent == 11) {
          return true;
        } else {
          this.gotoPageContent(4);
        }
      } else if (
        response.body.status == -113 &&
        response.body.data.response &&
        response.body.data.response.modname == "qnstp"
      ) {
        await this.spinner.hide();

        if (this.pageContent == 11) {
          return "Need Approval";
        } else {
          this.commonService.errorsmsg("Need Approval", "");
        }
      } else if (response.body.status != -114) {
        await this.spinner.hide();

        if (this.pageContent == 11) {
          return response.body.data.response
            ? response.body.data.response.txt
            : response.body.txt || this.errorMsg;
        } else {
          this.commonService.errorsmsg(
            response.body.data.response
              ? response.body.data.response.txt
              : response.body.txt || this.errorMsg,
            ""
          );
        }
      }
      this.isShowIssueCert = false;
    } else {
      // const type = (this.isRefToUw || this.isAlreadyGenerated) ? this.commonService.declarationPremiumEndorsement : this.commonService.declarationEndorsement;
      // this.prdEndorsementDetails = await this.getEndorsementId(type);
      let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/client_user_for_certificate/paymentCertificate?productname=emarine`;
      let response = await this.commonService.httpPostMethod(
        url,
        paramMany,
        "application/json",
        true,
        "Declaration"
      );
      // let response = await this.commonService.httpPostMethod(saveEndorsementFinalizeUrl, paramData, 'application/json', true, 'Declaration', this.impersonateFlag);

      if (response.body.status == 0) {
        await this.spinner.hide();
        const responseData = response.body.data;
        let header = JSON.parse(
          window.localStorage.getItem("declaration-header") || "{}"
        );
        header.endores_policy_id = responseData.policy_id || "";
        header.endorsement_id = responseData.endorsement_id || "";
        /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
        window.localStorage.setItem(
          "declaration-header",
          JSON.stringify(header)
        );
        if (this.pageContent == 11) {
          return true;
        } else {
          await this.closeModal();
          this.gotoPageContent(4);
        }
      } else if (response.body.status != -114) {
        await this.spinner.hide();

        if (this.pageContent == 11) {
          return response.body.data.response
            ? response.body.data.response.txt
            : response.body.txt || this.errorMsg;
        } else {
          this.commonService.errorsmsg(
            response.body.data.response
              ? response.body.data.response.txt
              : response.body.txt || this.errorMsg,
            ""
          );
        }
      }
    }
    this.isShowIssueCert = false;
  }

  /*
   * Created By : Sharann N
   * Description : to get policy details.
   *********************************************/
  async getPolicyData(param, isPolicyNo: boolean = false) {
    const paramData = {};
    isPolicyNo
      ? (paramData["policy_no"] = param)
      : (paramData["policy_id"] = param);
    const response = await this.commonService.httpGetMethod(
      this.policyUrl,
      "application/json",
      true,
      paramData,
      "Declaration",
      this.impersonateFlag
    );
    const ret = response.status == 0 ? response.data[0] || {} : {};
    if (JSON.stringify(ret) == "{}") {
      this.commonService.errorsmsg(
        response.txt || "Unable to get policy details",
        ""
      );
    }
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : to load already generated certificate in form.
   *********************************************/
  async loadDraftData() {
    let paramData: any = {
      policy_id: this.header.policy_id,
    };
    let response = await this.commonService.httpGetMethod(
      this.policyUrl,
      "application/json",
      true,
      paramData,
      "Declaration",
      this.impersonateFlag
    );
    this.selectedDeclarationDetail =
      response.status == 0 ? response.data[0] || {} : {};
    this.selectedEndorsementDetails = this.selectedDeclarationDetail;
    if (JSON.stringify(this.selectedDeclarationDetail) == "{}") {
      this.commonService.errorsmsg("Unable to load policy details", "");
      return;
    }
    const url = `${this.commonVariablesService.baseURL}api/v1/policy`;
    paramData = {
      policy_no: this.header.policy_no,
    };
    response = await this.commonService.httpGetMethod(
      url,
      "application/json",
      true,
      paramData,
      "Declaration",
      this.impersonateFlag
    );
    let masterPolicyDetails = response.status == 0 ? response.data : [];

    const dtr = new Date(
      this.selectedDeclarationDetail.quote.data.issue_date || new Date()
    );
    await this.setMinMaxDate();
    this.isNstpEnabled =
      ((this.selectedDeclarationDetail.quote.data || {}).nstpyn || "") == "Yes"
        ? true
        : false;
    const subVoyageAry = await this.getSubVoyageAry(
      masterPolicyDetails[0].data.sub_voyage
    );
    this.selectedEndorsementData = {};
    //if (this.isAlreadyGenerated) {
    /* this.header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    this.selectedEndorsementData =
      (this.header.endorsement_id || "") == ""
        ? {}
        : await this.getEndromentDetails(this.header.endorsement_id);
    //}
    //this.isProposal = (this.selectedEndorsementData != '{}') && (this.getUserType == 'underwriter' || this.getUserType == 'helpdesk') ? true : false ;
    const isEndorsement =
      JSON.stringify(this.selectedEndorsementData) == "{}" ? false : true;
    this.isReferral = this.header.referral_type;
    await this.loadDropdownValues(isEndorsement);
    this.isDuplicate =
      this.getUserType == "helpdesk" &&
      this.pageContent == 9 &&
      this.isReferral == "Certificate Cancellation - Duplication"
        ? true
        : false;
    this.declarationForm.patchValue({
      tp_policy_no:
        masterPolicyDetails.length > 0
          ? masterPolicyDetails[0].cust_fld_1
          : this.isNstpEnabled
          ? this.selectedDeclarationDetail.quote.data.cust_fld_1
          : "",
      voyage_name:
        masterPolicyDetails.length > 0
          ? await this.commonService.getVoyageDesc(
              masterPolicyDetails[0].quote.data.voyage
            )
          : this.isNstpEnabled
          ? this.selectedDeclarationDetail.quote.data.voyage_name
          : "",
      sub_voyage_type:
        masterPolicyDetails.length > 0
          ? subVoyageAry.sub_voyage_name
          : this.isNstpEnabled
          ? this.selectedDeclarationDetail.quote.data.sub_voyage_type
          : "",
      currency_type:
        masterPolicyDetails.length > 0
          ? masterPolicyDetails[0].quote.data.policy_currency_type
          : this.isNstpEnabled
          ? this.selectedDeclarationDetail.quote.data.currency_type
          : "",
      bov_percentage:
        masterPolicyDetails.length > 0
          ? subVoyageAry.bov_percentage
          : this.isNstpEnabled
          ? this.selectedDeclarationDetail.quote.data.bov_percentage
          : "",
      uw_ref_type: this.isReferral,
      client_name: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.client_name
        : this.selectedDeclarationDetail.quote.data.client_name,
      client_address_1: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.client_address_1
        : this.selectedDeclarationDetail.quote.data.client_address_1,
      client_address_2: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.client_address_2
        : this.selectedDeclarationDetail.quote.data.client_address_2,
      client_address_3: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.client_address_3
        : this.selectedDeclarationDetail.quote.data.client_address_3,
      client_pincode: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.client_pincode
        : this.selectedDeclarationDetail.quote.data.client_pincode,
      insured_city: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.client_name
        : this.selectedDeclarationDetail.quote.data.insured_city,
      insured_district: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.insured_district
        : this.selectedDeclarationDetail.quote.data.insured_district,
      insured_state: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.insured_state
        : this.selectedDeclarationDetail.quote.data.insured_state,
      insured_country: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.insured_country
        : this.selectedDeclarationDetail.quote.data.insured_country,
      client_gstin: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.client_gstin
        : this.selectedDeclarationDetail.quote.data.client_gstin,
      add_new_client:
        this.selectedDeclarationDetail.quote.data.add_new_client || "No",
      add_client_name:
        this.selectedDeclarationDetail.quote.data.add_client_name,
      default_new_client:
        this.selectedDeclarationDetail.quote.data.default_new_client || "No",
      new_insured_name:
        this.selectedDeclarationDetail.quote.data.new_insured_name,
      new_insured_address_1:
        this.selectedDeclarationDetail.quote.data.new_insured_address_1,
      new_insured_address_2:
        this.selectedDeclarationDetail.quote.data.new_insured_address_2,
      new_insured_address_3:
        this.selectedDeclarationDetail.quote.data.new_insured_address_3,
      new_insured_pincode:
        this.selectedDeclarationDetail.quote.data.new_insured_pincode,
      new_insured_city:
        this.selectedDeclarationDetail.quote.data.new_insured_city,
      new_insured_district:
        this.selectedDeclarationDetail.quote.data.new_insured_district,
      new_insured_state:
        this.selectedDeclarationDetail.quote.data.new_insured_state,
      new_insured_country:
        this.selectedDeclarationDetail.quote.data.new_insured_country,
      new_insured_gstin:
        this.selectedDeclarationDetail.quote.data.new_insured_gstin,
      mode_of_shipment: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.mode_of_shipment
        : this.selectedDeclarationDetail.quote.data.mode_of_shipment,
      coverage_type: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.coverage_type
        : this.selectedDeclarationDetail.quote.data.coverage_type,
      packing: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.packing ||
          "In customary packing"
        : this.selectedDeclarationDetail.quote.data.packing ||
          "In customary packing",
      from_country: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.from_country
        : this.selectedDeclarationDetail.quote.data.from_country,
      to_country: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.to_country
        : this.selectedDeclarationDetail.quote.data.to_country,
      from_city: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.from_city
        : this.selectedDeclarationDetail.quote.data.from_city,
      to_city: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.to_city
        : this.selectedDeclarationDetail.quote.data.to_city,
      // from_city_country: `${this.selectedDeclarationDetail.quote.data.from_city}, ${this.selectedDeclarationDetail.quote.data.from_country}`,
      // to_city_country: `${this.selectedDeclarationDetail.quote.data.to_city}, ${this.selectedDeclarationDetail.quote.data.to_country}`,
      invoice_currency: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.invoice_currency
        : this.selectedDeclarationDetail.quote.data.invoice_currency,
      cargo_value: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.cargo_value
          : this.selectedDeclarationDetail.quote.data.cargo_value,
        true
      ),
      cargo_si_policy_currency: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.cargo_si_policy_currency
          : this.selectedDeclarationDetail.quote.data.cargo_si_policy_currency,
        true
      ),
      roe: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.roe
          : this.selectedDeclarationDetail.quote.data.roe,
        true
      ),
      cargo_si: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.cargo_si
          : this.selectedDeclarationDetail.quote.data.cargo_si,
        true
      ),
      duty_si: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.duty_si
          : this.selectedDeclarationDetail.quote.data.duty_si,
        true
      ),
      total_si: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.total_si
          : this.selectedDeclarationDetail.quote.data.total_si,
        true
      ),
      cargo_premium: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.cargo_premium
          : this.selectedDeclarationDetail.quote.data.cargo_premium,
        true
      ),
      duty_premium: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.duty_premium
          : this.selectedDeclarationDetail.quote.data.duty_premium,
        true
      ),
      total_premium: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.total_premium
          : this.selectedDeclarationDetail.quote.data.total_premium,
        true
      ),
      gst: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.gst
          : this.selectedDeclarationDetail.quote.data.gst,
        true
      ),
      net_premium_final: await this.decimalPt(
        isEndorsement
          ? this.selectedEndorsementData.eproposal.data.net_premium_final
          : this.selectedDeclarationDetail.quote.data.net_premium_final,
        true
      ),
      non_std_clause: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.non_std_clause
        : this.selectedDeclarationDetail.quote.data.non_std_clause,
      marine_final_rate_percentage: isEndorsement
        ? this.selectedEndorsementData.eproposal.data
            .marine_final_rate_percentage
        : this.selectedDeclarationDetail.quote.data
            .marine_final_rate_percentage,
      expected_date_shipment: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.expected_date_shipment
          ? new Date(
              this.selectedEndorsementData.eproposal.data.expected_date_shipment
            )
          : ""
        : this.selectedDeclarationDetail.quote.data.expected_date_shipment
        ? new Date(
            this.selectedDeclarationDetail.quote.data.expected_date_shipment
          )
        : "",
      issue_date: dtr,
      bill_no: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.bill_no
        : this.selectedDeclarationDetail.quote.data.bill_no,
      bill_date: isEndorsement
        ? new Date(this.selectedEndorsementData.eproposal.data.bill_date)
        : new Date(this.selectedDeclarationDetail.quote.data.bill_date) || "",
      lc_no: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.lc_no
        : this.selectedDeclarationDetail.quote.data.lc_no,
      issuance_place: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.issuance_place
        : this.selectedDeclarationDetail.quote.data.issuance_place,
      invoice_no: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.invoice_no
        : this.selectedDeclarationDetail.quote.data.invoice_no,
      invoice_date: isEndorsement
        ? new Date(this.selectedEndorsementData.eproposal.data.invoice_date)
        : new Date(this.selectedDeclarationDetail.quote.data.invoice_date),
      vessel_name: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.vessel_name
        : this.selectedDeclarationDetail.quote.data.vessel_name,
      consignee_name: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.consignee_name
        : this.selectedDeclarationDetail.quote.data.consignee_name,
      consignee_address: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.consignee_address
        : this.selectedDeclarationDetail.quote.data.consignee_address,
      financier_name: this.selectedDeclarationDetail.quote.data.financier_name,
      lc_details: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.lc_details
        : this.selectedDeclarationDetail.quote.data.lc_details,
      subject_matter_insured: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.subject_matter_insured
        : this.selectedDeclarationDetail.quote.data.subject_matter_insured,
      marks_numbers: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.marks_numbers
        : this.selectedDeclarationDetail.quote.data.marks_numbers,
      claims_payable_at:
        this.selectedDeclarationDetail.quote.data.claims_payable_at,
      settling_agent: this.selectedDeclarationDetail.quote.data.settling_agent,
      settling_agent_company:
        this.selectedDeclarationDetail.quote.data.settling_agent_company,
      settling_agent_address:
        this.selectedDeclarationDetail.quote.data.settling_agent_address,
      settling_agent_phone:
        this.selectedDeclarationDetail.quote.data.settling_agent_phone,
      settling_agent_email:
        this.selectedDeclarationDetail.quote.data.settling_agent_email,
      claims_rep: this.selectedDeclarationDetail.quote.data.claims_rep,
      reason_cancellation:
        this.getUserType == "underwriter" || this.getUserType == "helpdesk"
          ? this.isCancelMode
            ? this.isDuplicate
              ? "Duplication"
              : "Any Other"
            : ""
          : "",
      cancel_cert: this.isCancelMode
        ? this.selectedDeclarationDetail.quote.cust_fld_6
        : "",
      retain_cert: this.isCancelMode
        ? this.isAlreadyGenerated
          ? await this.getCertificateOrDraftNo(this.header.dup_cert_policy_no)
          : ""
        : "",
      reason_cancel: this.isCancelMode
        ? this.isAlreadyGenerated
          ? this.header.reason || ""
          : ""
        : "",
      cert_no: this.isCancelMode
        ? this.selectedDeclarationDetail.quote.cust_fld_6
        : "",
      reason_nstp: "",
      reason_change: isEndorsement
        ? ((this.getUserType == "underwriter" ||
            this.getUserType == "helpdesk") &&
            this.impersonateFlag) ||
          (this.getUserType != "underwriter" && this.getUserType != "helpdesk")
          ? ""
          : this.selectedEndorsementData.eproposal.data.reason_change
        : "",
      fields_to_change: isEndorsement
        ? ((this.getUserType == "underwriter" ||
            this.getUserType == "helpdesk") &&
            this.impersonateFlag) ||
          (this.getUserType != "underwriter" && this.getUserType != "helpdesk")
          ? ""
          : this.selectedEndorsementData.eproposal.data.fields_to_change
        : "",
      // endorsement_start_date: new Date(isEndorsement ? this.selectedEndorsementData.eproposal.data.expected_date_shipment || new Date : this.selectedDeclarationDetail.quote.data.expected_date_shipment || new Date),
      endorsement_start_date: new Date(
        this.datePipe.transform(this.minIssueDate, "yyyy-MM-dd")
      ),
      si_deductible: isEndorsement
        ? this.selectedEndorsementData.eproposal.data.si_deductible
        : this.selectedDeclarationDetail.quote.data.si_deductible,

      /* client_name: responseData.quote.data.default_new_client == 'Yes' ? responseData.quote.data.new_insured_name : responseData.quote.data.client_name,
      client_address_1: responseData.quote.data.default_new_client == 'Yes' ? responseData.quote.data.new_insured_address_1 : responseData.quote.data.client_address_1,
      client_address_2: responseData.quote.data.default_new_client == 'Yes' ? responseData.quote.data.new_insured_address_2 : responseData.quote.data.client_address_2,
      client_address_3: responseData.quote.data.default_new_client == 'Yes' ? responseData.quote.data.new_insured_address_3 : responseData.quote.data.client_address_3,
      client_pincode: pincode,
      insured_city: responseData.quote.data.default_new_client == 'Yes' ? responseData.quote.data.new_insured_city : responseData.quote.data.insured_city,
      insured_district: await this.getDistrict(pincode),
      insured_state: responseData.quote.data.default_new_client == 'Yes' ? responseData.quote.data.new_insured_state : responseData.quote.data.insured_state,
      insured_country: responseData.quote.data.default_new_client == 'Yes' ? responseData.quote.data.new_insured_country : responseData.quote.data.insured_country,
      client_gstin: responseData.quote.data.default_new_client == 'Yes' ? responseData.quote.data.new_insured_gstin : responseData.quote.data.client_gstin,
      add_new_client: (!isEndorsement) ? responseData.quote.data.add_new_client : this.selectedEndorsementData.eproposal.data.add_new_client,
      add_client_name: (!isEndorsement) ? responseData.quote.data.add_client_name : this.selectedEndorsementData.eproposal.data.add_client_name,
      default_new_client: (!isEndorsement) ? responseData.quote.data.default_new_client : this.selectedEndorsementData.eproposal.data.default_new_client,
      new_insured_name: (!isEndorsement) ? responseData.quote.data.new_insured_name : this.selectedEndorsementData.eproposal.data.new_insured_name,
      new_insured_address_1: (!isEndorsement) ? responseData.quote.data.new_insured_address_1 : this.selectedEndorsementData.eproposal.data.new_insured_address_1,
      new_insured_address_2: (!isEndorsement) ? responseData.quote.data.new_insured_address_2 : this.selectedEndorsementData.eproposal.data.new_insured_address_2,
      new_insured_address_3: (!isEndorsement) ? responseData.quote.data.new_insured_address_3 : this.selectedEndorsementData.eproposal.data.new_insured_address_3,
      new_insured_pincode: new_pincode,
      new_insured_city: responseData.quote.data.new_insured_city,
      new_insured_district: await this.getDistrict(new_pincode),
      new_insured_state: responseData.quote.data.new_insured_state,
      new_insured_country: responseData.quote.data.new_insured_country,
      new_insured_gstin: (!isEndorsement) ? responseData.quote.data.new_insured_gstin : this.selectedEndorsementData.eproposal.data.new_insured_gstin,
      mode_of_shipment: (!isEndorsement) ? responseData.quote.data.mode_of_shipment : this.selectedEndorsementData.eproposal.data.mode_of_shipment,
      coverage_type: (!isEndorsement) ? responseData.quote.data.coverage_type : this.selectedEndorsementData.eproposal.data.coverage_type,
      packing: (!isEndorsement) ? responseData.quote.data.packing : this.selectedEndorsementData.eproposal.data.packing,
      from_country: (!isEndorsement) ? responseData.quote.data.from_country : this.selectedEndorsementData.eproposal.data.from_country,
      to_country: (!isEndorsement) ? responseData.quote.data.to_country : this.selectedEndorsementData.eproposal.data.to_country,
      from_city: (!isEndorsement) ? responseData.quote.data.from_city : this.selectedEndorsementData.eproposal.data.from_city,
      to_city: (!isEndorsement) ? responseData.quote.data.to_city : this.selectedEndorsementData.eproposal.data.to_city,
      from_city_country: (!isEndorsement) ? `${responseData.quote.data.from_city}, ${responseData.quote.data.from_country}` : `${this.selectedEndorsementData.eproposal.data.from_city}, ${this.selectedEndorsementData.eproposal.data.from_country}`,
      to_city_country: (!isEndorsement) ? `${responseData.quote.data.to_city}, ${responseData.quote.data.to_country}` : `${this.selectedEndorsementData.eproposal.data.to_city}, ${this.selectedEndorsementData.eproposal.data.to_country}`,
      invoice_currency: (!isEndorsement) ? responseData.quote.data.invoice_currency : this.selectedEndorsementData.eproposal.data.invoice_currency,
      cargo_value: await this.decimalPt((!isEndorsement) ? responseData.quote.data.cargo_value : this.selectedEndorsementData.eproposal.data.cargo_value, true),
      cargo_si_policy_currency: await this.decimalPt(responseData.quote.data.cargo_si_policy_currency, true),
      roe: await this.decimalPt((!isEndorsement) ? responseData.quote.data.roe : this.selectedEndorsementData.eproposal.data.roe, true),
      cargo_si: await this.decimalPt((!isEndorsement) ? responseData.quote.data.cargo_si : this.selectedEndorsementData.eproposal.data.cargo_si, true),
      duty_si: await this.decimalPt((!isEndorsement) ? responseData.quote.data.duty_si : this.selectedEndorsementData.eproposal.data.duty_si, true),
      total_si: await this.decimalPt((!isEndorsement) ? responseData.quote.data.total_si : this.selectedEndorsementData.eproposal.data.total_si, true),
      cargo_premium: await this.decimalPt((!isEndorsement) ? responseData.quote.data.cargo_premium : (this.selectedEndorsementData.eproposal.data.cargo_premium), true),
      duty_premium: await this.decimalPt((!isEndorsement) ? responseData.quote.data.duty_premium : (this.selectedEndorsementData.eproposal.data.duty_premium), true),
      total_premium: await this.decimalPt((!isEndorsement) ? responseData.quote.data.total_premium : (this.selectedEndorsementData.eproposal.data.total_premium), true),
      gst: await this.decimalPt((!isEndorsement) ? responseData.quote.data.gst : (this.selectedEndorsementData.eproposal.data.gst), true),
      net_premium_final: await this.decimalPt((!isEndorsement) ? responseData.quote.data.net_premium_final : (this.selectedEndorsementData.eproposal.data.net_premium_final), true),
      non_std_clause: responseData.quote.data.non_std_clause,
      marine_final_rate_percentage: (!isEndorsement) ? responseData.quote.data.marine_final_rate_percentage : (this.selectedEndorsementData.eproposal.data.marine_final_rate_percentage),
      expected_date_shipment: (!isEndorsement) ? responseData.quote.data.expected_date_shipment ? new Date(responseData.quote.data.expected_date_shipment) : '' : this.selectedEndorsementData.eproposal.data.expected_date_shipment ? new Date(this.selectedEndorsementData.eproposal.data.expected_date_shipment) : '',
      // issue_date: (!isEndorsement) ? dtr : this.selectedEndorsementData.eproposal.data.issue_date,
      issue_date: new Date((!isEndorsement) ? dtr : this.selectedEndorsementData.eproposal.data.issue_date),
      bill_no: (!isEndorsement) ? responseData.quote.data.bill_no : this.selectedEndorsementData.eproposal.data.bill_no,
      bill_date: (!isEndorsement) ? responseData.quote.data.bill_date ? new Date(responseData.quote.data.bill_date) : '' : this.selectedEndorsementData.eproposal.data.bill_date ? new Date(this.selectedEndorsementData.eproposal.data.bill_date) : '',
      lc_no: (!isEndorsement) ? responseData.quote.data.lc_no : this.selectedEndorsementData.eproposal.data.lc_no,
      issuance_place: (!isEndorsement) ? responseData.quote.data.issuance_place : this.selectedEndorsementData.eproposal.data.issuance_place,
      invoice_no: (!isEndorsement) ? responseData.quote.data.invoice_no : this.selectedEndorsementData.eproposal.data.invoice_no,
      // invoice_date: (!isEndorsement) ? responseData.quote.data.invoice_date : this.selectedEndorsementData.eproposal.data.invoice_date,
      invoice_date: new Date((!isEndorsement) ? responseData.quote.data.invoice_date : this.selectedEndorsementData.eproposal.data.invoice_date),
      vessel_name: (!isEndorsement) ? responseData.quote.data.vessel_name : this.selectedEndorsementData.eproposal.data.vessel_name,
      consignee_name: (!isEndorsement) ? responseData.quote.data.consignee_name : this.selectedEndorsementData.eproposal.data.consignee_name,
      consignee_address: (!isEndorsement) ? responseData.quote.data.consignee_address : this.selectedEndorsementData.eproposal.data.consignee_address,
      financier_name: (!isEndorsement) ? responseData.quote.data.financier_name : this.selectedEndorsementData.eproposal.data.financier_name,
      lc_details: (!isEndorsement) ? responseData.quote.data.lc_details : this.selectedEndorsementData.eproposal.data.lc_details,
      subject_matter_insured: (!isEndorsement) ? responseData.quote.data.subject_matter_insured : this.selectedEndorsementData.eproposal.data.subject_matter_insured,
      marks_numbers: (!isEndorsement) ? responseData.quote.data.marks_numbers : this.selectedEndorsementData.eproposal.data.marks_numbers,
      claims_payable_at: responseData.quote.data.claims_payable_at,
      settling_agent: (!isEndorsement) ? responseData.quote.data.settling_agent : this.selectedEndorsementData.eproposal.data.settling_agent,
      settling_agent_company: (!isEndorsement) ? responseData.quote.data.settling_agent_company : this.selectedEndorsementData.eproposal.data.settling_agent_company,
      settling_agent_address: (!isEndorsement) ? responseData.quote.data.settling_agent_address : this.selectedEndorsementData.eproposal.data.settling_agent_address,
      settling_agent_phone: (!isEndorsement) ? responseData.quote.data.settling_agent_phone : this.selectedEndorsementData.eproposal.data.settling_agent_phone,
      settling_agent_email: (!isEndorsement) ? responseData.quote.data.settling_agent_email : this.selectedEndorsementData.eproposal.data.settling_agent_email,
      claims_rep: responseData.quote.data.claims_rep,
      cancel_cert: '',
      retain_cert: '',
      reason_cancel: '',
      cert_no: '',
      reason_nstp: '',
      reason_change: (!isEndorsement) ? '' : (typeof this.selectedEndorsementData.eproposal.data.reason_change == 'string') ? this.selectedEndorsementData.eproposal.data.reason_change : '',
      fields_to_change: (!isEndorsement) ? '' : (typeof this.selectedEndorsementData.eproposal.data.fields_to_change == 'string') ? this.selectedEndorsementData.eproposal.data.fields_to_change : '',
      // endorsement_start_date: new Date((!isEndorsement) ? responseData.quote.data.expected_date_shipment || new Date : this.selectedEndorsementData.eproposal.data.expected_date_shipment || new Date),
      endorsement_start_date: new Date(this.datePipe.transform(this.minIssueDate, 'yyyy-MM-dd')),
      si_deductible: (!isEndorsement) ? responseData.quote.data.si_deductible : this.selectedEndorsementData.eproposal.data.si_deductible */
    });

    const balance: any = await this.calcPolicyBalance(
      this.header.policy_no,
      isEndorsement
        ? this.selectedEndorsementData.eproposal.data.expected_date_shipment
          ? new Date(
              this.selectedEndorsementData.eproposal.data.expected_date_shipment
            )
          : ""
        : this.selectedDeclarationDetail.quote.data.expected_date_shipment
        ? new Date(
            this.selectedDeclarationDetail.quote.data.expected_date_shipment
          )
        : ""
    );
    this.declarationForm.patchValue({
      opening_balance: await this.decimalPt(
        balance.without_date.available_opening_balance_certificate || 0,
        true
      ),
      balance_premium: await this.decimalPt(
        balance.without_date.available_premium_balance_certificate || 0,
        true
      ),
    });
    await this.assignValueToForm();
    await this.getInsuringClause();
    this.fromCityVal = isEndorsement
      ? `${this.selectedEndorsementData.eproposal.data.from_city}, ${this.selectedEndorsementData.eproposal.data.from_country}`
      : `${this.selectedDeclarationDetail.quote.data.from_city}, ${this.selectedDeclarationDetail.quote.data.from_country}`;
    this.toCityVal = isEndorsement
      ? `${this.selectedEndorsementData.eproposal.data.to_city}, ${this.selectedEndorsementData.eproposal.data.to_country}`
      : `${this.selectedDeclarationDetail.quote.data.to_city}, ${this.selectedDeclarationDetail.quote.data.to_country}`;
    await this.validateFields();
  }

  /*
   * Created By : Sharann N
   * Description : to delete the quote(draft).
   *********************************************/
  async deleteDraft() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    const draftCreationDate = new Date(this.selectedDeclarationDetail.c_ts);
    let validDate = draftCreationDate;
    this.isDeletionBeyondDays = false;
    validDate.setDate(draftCreationDate.getDate() + 7);
    if (new Date().getTime() <= validDate.getTime()) {
      await this.spinner.show();
      let tmpParam = await this.insuringClauseParam();
      let paramMany = {
        insureClauseParam: tmpParam,
        selectedDeclarationDetail:
          JSON.stringify(this.selectedDeclarationDetail) == "{}"
            ? ""
            : this.selectedDeclarationDetail,
        masterPolicyNo:
          this.selectedDeclarationDetail.quote.data.cust_fld_3 || "",
        //"masterPolicyNo": (this.selectedDeclarationDetail.policy_no || '')
      };
      let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/client_user_for_certificate/deleteDraft`;
      let response = await this.commonService.httpPostMethod(
        url,
        paramMany,
        "application/json",
        true,
        "Declaration"
      );

      if (response.body.status == -114) {
        await this.closeModal();
        await this.spinner.hide();
      }
      if (response.body.status == 0) {
        await this.closeModal();
        await this.spinner.hide();
        this.commonService.successmsg(this.quoteDelMsg, "");
        this.gotoPageContent(1);
      } else if (response.body.status != -114) {
        await this.closeModal();
        await this.spinner.hide();
        this.commonService.errorsmsg(response.body.txt, "");
      }
    } else {
      await this.closeModal();
      // this.commonService.errorsmsg(this.deletionBeyondDaysMsg, '');
      this.isDeletionBeyondDays = true;
      await this.openModal(this.draftDelete);
    }
  }

  /*
   * Created By : Sharann N
   * Description : to validate bill date.
   *********************************************/
  billDateValidation() {
    const billNo = this.declarationForm.controls.bill_no.value;
    if (billNo === "") {
      this.declarationForm.get("bill_date").setValidators([]);
      this.declarationForm.get("bill_date").updateValueAndValidity();
    } else {
      this.declarationForm
        .get("bill_date")
        .setValidators([Validators.required]);
      this.declarationForm.get("bill_date").updateValueAndValidity();
    }
  }

  /*
   * Created By : Sharann N
   * Description : check the field is required or not.
   *********************************************/
  isRequiredField(formFieldName) {
    const formField = this.declarationForm.get(formFieldName);
    if (!formField.validator) {
      return false;
    }

    const validator = formField.validator({} as AbstractControl);
    return validator && validator.required;
  }

  /*
   * Created By : Sharann N
   * Description : to validate the reason for cancel certificate.
   *********************************************/
  cancelReason() {
    let reason_cancellations = this.declarationForm.get(
      "reason_cancellation"
    ).value;
    this.isDuplicate = false;
    if (reason_cancellations == "Duplication") {
      //modified by gomathi
      this.isDuplicate = true;
      this.declarationForm
        .get("cancel_cert")
        .setValidators([Validators.required]);
      this.declarationForm.get("cancel_cert").updateValueAndValidity();
      this.declarationForm
        .get("retain_cert")
        .setValidators([Validators.required]);
      this.declarationForm.get("retain_cert").updateValueAndValidity();
      this.declarationForm.get("cert_no").setValidators([]);
      this.declarationForm.get("cert_no").updateValueAndValidity();
      this.declarationForm.get("reason_cancel").setValidators([]);
      this.declarationForm.get("reason_cancel").updateValueAndValidity();
    } else {
      this.declarationForm.get("cancel_cert").setValidators([]);
      this.declarationForm.get("cancel_cert").updateValueAndValidity();
      this.declarationForm.get("retain_cert").setValidators([]);
      this.declarationForm.get("retain_cert").updateValueAndValidity();
      this.declarationForm.get("cert_no").setValidators([Validators.required]);
      this.declarationForm.get("cert_no").updateValueAndValidity();
      this.declarationForm
        .get("reason_cancel")
        .setValidators([Validators.required]);
      this.declarationForm.get("reason_cancel").updateValueAndValidity();
    }
  }

  /*
   * Created By : Sharann N
   * Description : to raise cancellation request for certificate.
   *********************************************/
  async cancelValidate() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    const ret = await this.validateForm();
    if (ret == 0) {
      this.spinner.hide();
      this.isApproveOrReject = false;
      this.commonService.warningmsg("Please fill Mandatory fields", "Warning");
      return;
    } else if (ret == 1) {
      let params: any;
      if (this.isDuplicate) {
        let retaincert = this.declarationForm.controls.retain_cert.value.trim();
        let cancelCert = this.declarationForm.controls.cancel_cert.value.trim();
        if (retaincert.toLowerCase() == cancelCert.toLowerCase()) {
          this.commonService.errorsmsg(
            "Certificate number to be cancelled and Certificate number to be retained should be different",
            ""
          );
          return;
        }
        // cert_policy_no - certificate to be cancelled,
        // dup_cert_policy_no: certificate to be retained,
        params = {
          cert_policy_no: cancelCert,
          dup_cert_policy_no: retaincert,
          reason: "Certificate Cancellation - Duplication",
          referral_type: "Certificate Cancellation - Duplication",
        };
      } else {
        params = {
          cert_policy_no: this.declarationForm.controls.cert_no.value,
          reason: this.declarationForm.controls.reason_cancel.value.trim(),
          referral_type: "Certificate Cancellation - Any Other",
        };
      }

      /* const url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/cancel_certificate/initiate`;
      const response = await this.commonService.httpPostMethod(url, params, 'application/json', true, 'Declaration', this.impersonateFlag);
      return response; */
      return params;
      /* if (response.body.status === 0) {
        this.commonService.successmsg(response.body.data, '');
        this.gotoPageContent(1);
      } else if (response.body.status != -114) {
        this.commonService.errorsmsg(response.body.txt || 'Unable to create cancel certificate request', '');
      } */
    }
  }

  /*
   * Created By : Sharann N
   * Description : to get roe details for validating.
   *********************************************/
  async getRoeDetails() {
    /* Get roe details */
    if (this.declarationForm.controls.invoice_currency.value) {
      const roeUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/roe_master`;
      const roeParam = {
        from_currency: this.declarationForm.controls.invoice_currency.value,
        // to_currency: this.declarationForm.controls.currency_type.value
      };
      const roeResponse = await this.commonService.httpGetMethod(
        roeUrl,
        "application/x-www-form-urlencoded; charset=UTF-8",
        true,
        roeParam,
        "Declaration",
        this.impersonateFlag
      );
      this.selectedRoeDetails = roeResponse.status == 0 ? roeResponse.data : [];
    }
  }

  /*
   * Created By : Sharann N
   * Description : check dropdown has value or not.
   *********************************************/
  checkDropdown(field) {
    if (field == "settling_agent") {
      if (this.settlingAgentDetails.length == 0) {
        const formFieldName = "to_country";
        this.commonService.errorsmsg('Please fill "to country" field', "");
        this.declarationForm.controls[formFieldName].setErrors({
          reqiured: true,
        });
        const invalidControl = this.el.nativeElement.querySelector(
          `[formcontrolname="${formFieldName}"]`
        );
        invalidControl.focus();
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : to close modal.
   *********************************************/
  closeModal() {
    return new Promise(async (resolve) => {
      this.sampleData = [];
      this.excelData = [];
      if (this.modalRef) {
        this.modalRef.hide();
      }
      /* if(this.pageContent == 11){
        this.uploadCertificate.reset();
      } */
      resolve(true);
    });
  }

  /*
   * Created By : Sharann N
   * Description : focus on validation reqiured form field.
   *********************************************/
  async focusOnInvalidFormField(formName: FormGroup, fieldName: any = "") {
    if (fieldName) {
      const invalidControl = this.el.nativeElement.querySelector(
        '[formcontrolname="' + fieldName + '"]'
      );
      invalidControl.focus();
      this.fieldError[fieldName] = true;
      await this.closeModal();
    } else {
      const key = await this.commonService.checkInvalidFormField(formName);
      if (key) {
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]'
        );
        invalidControl.focus();
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : trigger when underwriter/helpdesk done approves/rejects the certificate.
   *********************************************/
  async approveOrReject(isApproved) {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    if (
      JSON.stringify(this.selectedEndorsementData) != "{}" &&
      this.isReferral == this.updateCertReferral
    ) {
      this.saveEndorsement(isApproved);
    } else {
      this.submitted = true;
      //Ticket No -154865
      //approve/reject duplication
      this.isApproveOrReject = true;
      await this.spinner.show();
      const ret = await this.validateForm();
      if (ret == 1) {
        if (this.declarationForm.valid) {
          if (this.pageContent == 9) {
            this.saveEndorsement(isApproved, true);
          } else {
            let tmpParam = await this.insuringClauseParam();
            let paramMany = {
              insureClauseParam: tmpParam,
              selectedDeclarationDetailReferralType:
                this.selectedDeclarationDetail.quote.data.referral_type || "",
              selectedDeclarationDetailQuoteId:
                this.selectedDeclarationDetail.quote_id,
              selectedDeclarationDetailPolicyId:
                this.selectedDeclarationDetail.policy_id,
              isApproved: isApproved,
              selectedDeclarationDetailQnstpId:
                this.selectedDeclarationDetail.qnstp_id,
              selectedDeclarationDetailCreatedBy:
                this.selectedDeclarationDetail["created_by"],
              masterPolicyId: this.masterPolicyId || "",
              reason_nstp:
                this.declarationForm.controls.reason_nstp.value || "",
              userEmail: this.userEmail || "",
            };
            let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/uw_user_for_certificate/approveOrReject`;

            if (
              this.selectedDeclarationDetail.quote.data.referral_type ==
              "Draft Deletion"
            ) {
              if (isApproved == 1) {
                let response = await this.commonService.httpPostMethod(
                  url,
                  paramMany,
                  "application/json",
                  true,
                  "Declaration",
                  this.impersonateFlag
                );

                if (response.body.status == -114) {
                  //Ticket No -154865
                  //approve/reject duplication
                  this.isApproveOrReject = false;
                  await this.closeModal();
                  await this.spinner.hide();
                }
                if (response.body.status == 0) {
                  await this.spinner.hide();
                  this.commonService.successmsg(this.quoteDelMsg, "");
                  await this.closeModal();
                  this.gotoPageContent(
                    this.getUserType == "underwriter" ||
                      this.getUserType == "helpdesk"
                      ? 0
                      : 1
                  );
                } else if (response.body.status != -114) {
                  await this.spinner.hide();
                  //Ticket No -154865
                  //approve/reject duplication
                  this.isApproveOrReject = false;
                  this.commonService.errorsmsg(response.body.txt, "");
                  await this.closeModal();
                }
              } else {
                await this.spinner.hide();
                //Ticket No -154865
                //approve/reject duplication
                this.isApproveOrReject = false;
                await this.convertToCertificate(isApproved);
              }
            } else {
              const paramData = {
                Certificate_Bulk: "certificate",
                quote_id: this.selectedDeclarationDetail.quote_id,
                policy_id: this.selectedDeclarationDetail.policy_id,
                product_id: this.commonVariablesService.declarationProductId,
                declaration_type: "certificate",
                certificate_bulk: "certificate",
                opening_balance: await this.removeSeparator(
                  this.declarationForm.controls.opening_balance.value
                ),
                balance_premium: await this.removeSeparator(
                  this.declarationForm.controls.balance_premium.value
                ),
                backdate_days:
                  this.selectedDeclarationDetail.quote.data.back_date_days,
                bov_percentage:
                  this.selectedDeclarationDetail.quote.data.bov_percentage,
                bulk_declaration_type:
                  this.selectedDeclarationDetail.quote.data
                    .bulk_declaration_type,
                cancel_cert:
                  this.selectedDeclarationDetail.quote.data.cancel_cert,
                cert_no: this.selectedDeclarationDetail.quote.data.cert_no,
                certificate_allowed:
                  this.selectedDeclarationDetail.quote.data.certificate_allowed,
                cust_fld_1:
                  this.selectedDeclarationDetail.quote.data.cust_fld_1,
                cust_fld_2:
                  this.selectedDeclarationDetail.quote.data.cust_fld_2,
                cust_fld_3:
                  this.selectedDeclarationDetail.quote.data.cust_fld_3,
                cust_fld_4:
                  this.selectedDeclarationDetail.quote.data.cust_fld_4,
                cust_fld_9:
                  this.selectedDeclarationDetail.quote.data.cust_fld_9,
                days_post_expiry:
                  this.selectedDeclarationDetail.quote.data.days_post_expiry,
                bill_no: this.selectedDeclarationDetail.quote.data.bill_no,
                from_city_country:
                  this.f.from_city.value + "," + this.f.from_country.value,
                to_city_country:
                  this.f.to_city.value + "," + this.f.to_country.value,
                invoice_no:
                  this.selectedDeclarationDetail.quote.data.invoice_no,
                non_std_clause_policy_setup:
                  this.selectedDeclarationDetail.quote.data
                    .non_std_clause_policy_setup,
                premium_display_policy_setup:
                  this.selectedDeclarationDetail.quote.data
                    .premium_display_policy_setup,
                packing: this.selectedDeclarationDetail.quote.data.packing,
                per_seeding_limit:
                  this.selectedDeclarationDetail.quote.data.per_seeding_limit,
                policy_type:
                  this.selectedDeclarationDetail.quote.data.policy_type,
                reason_cancel:
                  this.selectedDeclarationDetail.quote.data.reason_cancel,
                reason_cancellation:
                  this.selectedDeclarationDetail.quote.data.reason_cancellation,
                retain_cert:
                  this.selectedDeclarationDetail.quote.data.retain_cert,
                sum_insured_percentage:
                  this.selectedDeclarationDetail.quote.data
                    .sum_insured_percentage,
                tax_amount:
                  this.selectedDeclarationDetail.quote.data.tax_applicable,
                tax_applicable: await this.commonService.taxApplicableStatus(
                  this.pageContent == 2 && this.header.nav_to == ""
                    ? this.selectedDeclarationDetail.quote.data.tax_applicable
                    : this.selectedDeclarationDetail.quote.data
                        .tax_applicable || 0
                ),
                tp_policy_no:
                  this.selectedDeclarationDetail.quote.data.cust_fld_1,
                master_policy_no:
                  this.selectedDeclarationDetail.quote.data.cust_fld_3,
                sub_voyage_id:
                  this.selectedDeclarationDetail.quote.data.sub_voyage_id,
                __finalize: 0,
                ...this.declarationForm.getRawValue(),
                duty_premium: await this.removeSeparator(
                  this.declarationForm.controls.duty_premium.value
                ),
                duty_si: await this.removeSeparator(
                  this.declarationForm.controls.duty_si.value
                ),
                cargo_value: await this.removeSeparator(
                  this.declarationForm.controls.cargo_value.value
                ),
                cargo_si_policy_currency: await this.removeSeparator(
                  this.declarationForm.controls.cargo_si_policy_currency.value
                ),
                roe: await this.removeSeparator(
                  this.declarationForm.controls.roe.value
                ),
                cargo_si: await this.removeSeparator(
                  this.declarationForm.controls.cargo_si.value
                ),
                total_si: await this.removeSeparator(
                  this.declarationForm.controls.total_si.value
                ),
                cargo_premium: await this.removeSeparator(
                  this.declarationForm.controls.cargo_premium.value
                ),
                total_premium: await this.removeSeparator(
                  this.declarationForm.controls.total_premium.value
                ),
                gst: await this.removeSeparator(
                  this.declarationForm.controls.gst.value
                ),
                net_premium_final: await this.removeSeparator(
                  this.declarationForm.controls.net_premium_final.value
                ),
                marine_final_rate_percentage: await this.removeSeparator(
                  this.declarationForm.controls.marine_final_rate_percentage
                    .value
                ),
                f_cargo_si: await this.decimalPt(this.f.cargo_si.value, true),
                f_cargo_si_policy_currency: await this.decimalPt(
                  this.f.cargo_si_policy_currency.value,
                  true
                ),
                f_total_si: await this.decimalPt(this.f.total_si.value, true),
                f_cargo_premium: await this.decimalPt(
                  this.f.cargo_premium.value,
                  true
                ),
                f_duty_premium: await this.decimalPt(
                  this.f.duty_premium.value,
                  true
                ),
                f_total_premium: await this.decimalPt(
                  this.f.total_premium.value,
                  true
                ),
                f_gst: await this.decimalPt(this.f.gst.value, true),
                f_net_premium_final: await this.decimalPt(
                  this.f.net_premium_final.value,
                  true
                ),
                expected_date_shipment: this.datePipe.transform(
                  this.f.expected_date_shipment.value,
                  "yyyy-MM-dd"
                ),
                bill_date: this.datePipe.transform(
                  this.f.bill_date.value,
                  "yyyy-MM-dd"
                ),
                invoice_date: this.datePipe.transform(
                  this.f.invoice_date.value,
                  "yyyy-MM-dd"
                ),
                issue_date: this.datePipe.transform(
                  this.f.issue_date.value,
                  "yyyy-MM-dd"
                ),
                insuring_clause_and_condition: this.insuringClause,
                // policy_start_date: this.datePipe.transform(this.minIssueDate, 'yyyy-MM-dd'),
                policy_start_date: this.datePipe.transform(
                  this.f.expected_date_shipment.value,
                  "yyyy-MM-dd"
                ),
                policy_end_date: this.datePipe.transform(
                  this.maxIssueDate,
                  "yyyy-MM-dd"
                ),
              };

              paramMany["quoteParam"] = paramData;
              let quoteResponse = await this.commonService.httpPostMethod(
                url,
                paramMany,
                "application/json",
                true,
                "Declaration",
                this.impersonateFlag
              );

              if (quoteResponse.body.status == -114) {
                await this.closeModal();
                //Ticket No -154865
                //approve/reject duplication
                this.isApproveOrReject = false;
                await this.spinner.hide();
              }
              if (quoteResponse.body.status == 0) {
                await this.spinner.hide();

                this.header = JSON.parse(
                  window.localStorage.getItem("declaration-header") || "{}"
                );
                if (isApproved == 1) {
                  await this.convertToCertificate(isApproved);
                } else {
                  this.commonService.errorsmsg("Rejected successfully", "");
                  this.gotoPageContent(
                    this.getUserType == "underwriter" ||
                      this.getUserType == "helpdesk"
                      ? 0
                      : 1
                  );
                }
              } else if (quoteResponse.body.status != -114) {
                await this.spinner.hide();
                //Ticket No -154865
                //approve/reject duplication
                this.isApproveOrReject = false;
                this.commonService.errorsmsg(quoteResponse.body.txt, "");
              }
            }
          }
        } else {
          this.spinner.hide();
          //Ticket No -154865
          //approve/reject duplication
          this.isApproveOrReject = false;
          await this.focusOnInvalidFormField(this.declarationForm);
        }
      } else if (ret == 0) {
        await this.spinner.hide();
        //Ticket No -154865
        //approve/reject duplication
        this.isApproveOrReject = false;
        this.commonService.warningmsg(
          "Please fill Mandatory fields",
          "Warning"
        );
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : assign policy to underwiter/helpdesk and also after approve/reject assign to the policy created user.
   *********************************************/
  async assignto_user(id, nstpParam, isEndorsement: boolean = false) {
    const nstpUrl = isEndorsement
      ? `${this.commonVariablesService.baseURL}api/v2/endorsement/note/${id}`
      : `${this.commonVariablesService.baseURL}api/v1/policy/note/${id}`;
    const nstpResponse = await this.commonService.httpPostMethod(
      nstpUrl,
      nstpParam,
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );
    return nstpResponse;
  }

  /*
   * Created By : Sharann N
   * Description : to convert the policy assigned to group into assigned to me.
   *********************************************/
  async takeOverAction(isEndorsement) {
    const url = isEndorsement
      ? `${this.commonVariablesService.baseURL}api/v2/eproposal/claim/${this.selectedEndorsementData.endorsement_id}`
      : `${this.commonVariablesService.baseURL}api/v1/quote/claim/${this.header.quote_id}`;
    const response = await this.commonService.httpPostMethod(
      url,
      {},
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );
    if (response.body.status == 0) {
      // successfully assigned here
    } else if (response.body.status != -114) {
      this.commonService.errorsmsg(response.body.txt, "");
    }
  }

  /*
   * Created By : Sharann N
   * Description : to get selected subVoyage from the subVoyage array.
   *********************************************/
  getSubVoyageAry(array) {
    this.header.sub_voyage_id = this.header.sub_voyage_id || 0;
    this.header.prev_sub_voyage_id = this.header.prev_sub_voyage_id || 0;
    let i = 0,
      j = 0;
    nested_loop: for (const [idx, obj] of (
      this.gcEndorsementDetails || []
    ).entries()) {
      for (const [subIdx, subVoyageObj] of (
        obj.data.sub_voyage || []
      ).entries()) {
        if (
          [this.header.sub_voyage_id, this.header.prev_sub_voyage_id].includes(
            subVoyageObj.id
          )
        ) {
          i = idx;
          j = subIdx;
          break nested_loop;
        }
      }
    }
    /* let retAry = (array || []).filter(value => (value.id == this.header.sub_voyage_id || value.id == this.header.prev_sub_voyage_id));
    retAry = (retAry[0] || {}); */
    let retAry = this.gcEndorsementDetails[i]?.data?.sub_voyage[j] || {};
    retAry = retAry || {};
    if (JSON.stringify(retAry) == "{}") {
      this.commonService.errorsmsg("Unable to load sub voyage details", "");
    }
    return retAry;
  }

  /*
   * Created By : Sharann N
   * Description : check certificate has any nstp cases.
   *********************************************/
  async checkUwCase() {
    if (this.pageContent == 11) {
      this.uwRefferralReasons = [];
      const subVoyageAry = {
        per_seeding_limit:
          this.selectedDeclarationDetail.quote.data.per_seeding_limit,
        back_date_days: this.selectedDeclarationDetail.quote.data.backdate_days,
      };
      for (let i = 0; i < this.excelData.length; i++) {
        /* Country referral Case */
        const country = this.referralCountryDetails.filter((value) => {
          return (
            (value.country_name == this.excelData[i].from_Country ||
              value.country_name == this.excelData[i].to_Country) &&
            (value.referral || "").toLowerCase() != "approved"
          );
        });
        const isReferralCountry = country.length ? true : false;
        if (isReferralCountry) {
          this.uwRefferralReasons.push(this.countryRefMsg);
        }
        /* PSL Case */
        const si_deductible = this.calcPremiumData.cells.si_deductible;
        if (Number(si_deductible) > Number(subVoyageAry.per_seeding_limit)) {
          this.uwRefferralReasons.push(this.pslMsg);
        }
        /* Backdation Case */
        const days = subVoyageAry.back_date_days;
        const dateObj = new Date();
        dateObj.setDate(dateObj.getDate() - days);
        const isValid =
          new Date(this.excelData[i].date_Of_Shipment).getTime() <
          dateObj.getTime()
            ? true
            : false;
        if (isValid) {
          this.uwRefferralReasons.push(this.backDationMsg);
        }
      }
      const isHavingUWCase = this.uwRefferralReasons.length ? true : false;
      return isHavingUWCase;
    } else {
      const isUpdateCert =
        (this.header.nav_to || "") == "endorse-cert" ? true : false;
      this.uwRefferralReasons = [];
      if (!this.isRefToUw && !isUpdateCert) {
        const subVoyageAry = this.isCloneMode
          ? await this.getSubVoyageAry(
              this.cloneMasterPolicyDetails.data.sub_voyage
            )
          : this.isDraftMode
          ? {
              per_seeding_limit:
                this.selectedDeclarationDetail.quote.data.per_seeding_limit,
              back_date_days:
                this.selectedDeclarationDetail.quote.data.backdate_days,
            }
          : isUpdateCert
          ? {
              per_seeding_limit:
                this.selectedEndorsementDetails.quote.data.per_seeding_limit,
              back_date_days:
                this.selectedEndorsementDetails.quote.data.backdate_days,
            }
          : await this.getSubVoyageAry(
              this.selectedDeclarationDetail.data.sub_voyage
            );

        /* Country referral Case */
        const country = this.referralCountryDetails.filter((value) => {
          return (
            (value.country_name ==
              this.declarationForm.controls.from_country.value ||
              value.country_name ==
                this.declarationForm.controls.to_country.value) &&
            (value.referral || "").toLowerCase() != "approved"
          );
        });
        const isReferralCountry = country.length ? true : false;
        if (isReferralCountry) {
          this.uwRefferralReasons.push(this.countryRefMsg);
        }
        /* PSL Case */
        const si_deductible = this.isDraftMode
          ? this.selectedDeclarationDetail.quote.data.si_deductible
          : isUpdateCert
          ? this.selectedEndorsementDetails.quote.data.si_deductible
          : ((this.calcPremiumData || {}).cells || {}).si_deductible || 0;
        if (Number(si_deductible) > Number(subVoyageAry.per_seeding_limit)) {
          this.uwRefferralReasons.push(this.pslMsg);
        }
        /* Backdation Case */
        const days = subVoyageAry.back_date_days;
        const dateObj = new Date();
        dateObj.setDate(dateObj.getDate() - days);
        const isValid =
          new Date(
            this.declarationForm.controls.expected_date_shipment.value
          ).getTime() < dateObj.getTime()
            ? true
            : false;
        if (isValid) {
          this.uwRefferralReasons.push(this.backDationMsg);
        }
      }
      const isHavingUWCase = this.uwRefferralReasons.length ? true : false;
      return isHavingUWCase;
    }
  }

  /********************************************
   * Created By : Dinesh
   * Description : Form Insuring clause param.
   *********************************************/
  async insuringClauseParam() {
    // let tmpParam = {
    //   "sub_voyage_name": (this.declarationForm.controls.sub_voyage_type.value || ''),
    //   "voyage_name": await this.commonService.removeVoyageDesc(this.declarationForm.controls.voyage_name.value),
    //   "policy_type": (((this.selectedDeclarationDetail || {}).quote || {}).data || {}).policy_type || (((this.selectedEndorsementData || {}).eproposal || {}).data || {}).policy_type || (((this.selectedEndorsementDetails || {}).quote || {}).data || {}).policy_type || '',
    //   "coverage_type": (this.declarationForm.controls.coverage_type.value || ''),
    //   "mode_of_shipment": (this.f.mode_of_shipment.value || '')
    // };
    let tmpParam = {
      sub_voyage_name: this.declarationForm
        ? this.declarationForm.controls.sub_voyage_type.value
        : this.selectedDeclarationDetail.quote.data.pol_sub_voyage || "",
      voyage_name: this.declarationForm
        ? await this.commonService.removeVoyageDesc(
            this.declarationForm.controls.voyage_name.value
          )
        : this.selectedDeclarationDetail.quote.data.pol_voyage,
      policy_type:
        (((this.selectedDeclarationDetail || {}).quote || {}).data || {})
          .policy_type ||
        (((this.selectedEndorsementData || {}).eproposal || {}).data || {})
          .policy_type ||
        (((this.selectedEndorsementDetails || {}).quote || {}).data || {})
          .policy_type ||
        "",
      coverage_type: this.declarationForm
        ? this.declarationForm.controls.coverage_type.value
        : (this.isEndorsement
            ? this.isPremiumEndorsement
              ? this.editableFields.coverage_type
              : this.selectedDeclarationDetail.quote.data.coverage_type
            : this.selectedDeclarationDetail.quote.data.coverage_type) || "",
      mode_of_shipment: this.declarationForm
        ? this.declarationForm.controls.mode_of_shipment.value
        : (this.isEndorsement
            ? this.isPremiumEndorsement
              ? this.editableFields.mode_of_shipment
              : this.selectedDeclarationDetail.quote.data.mode_of_shipment
            : this.selectedDeclarationDetail.quote.data.mode_of_shipment) || "",
    };

    return tmpParam;
  }

  /*
   * Created By : Sharann N
   * Description : to save the certificate.
   *********************************************/
  async saveQuoteData() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    this.spinner.show();
    this.isReferred = false;
    await this.assignValueToForm();
    let saveNewClientParam, defaultNewClientParam;

    if (
      this.declarationForm.get("add_client_name").value == "Add New Client Name"
    ) {
      // await this.saveNewClient();
      saveNewClientParam = {
        role: "client",
        producer_code:
          this.selectedDeclarationDetail.quote.data.insured_id || "",
        producer_name:
          this.declarationForm.controls.new_insured_name.value || "",
        address_1:
          this.declarationForm.controls.new_insured_address_1.value || "",
        address_2:
          this.declarationForm.controls.new_insured_address_2.value || "",
        address_3:
          this.declarationForm.controls.new_insured_address_3.value || "",
        city: this.declarationForm.controls.new_insured_city.value || "",
        country: this.declarationForm.controls.new_insured_country.value || "",
        state: this.declarationForm.controls.new_insured_state.value || "",
        zipcode: this.declarationForm.controls.new_insured_pincode.value || "",
        gstin: this.declarationForm.controls.new_insured_gstin.value || "",
        active: "true",
        client: this.commonVariablesService.user_management_product,
        status: "true",
        lob: "marinecargo",
      };
    }
    const quoteId = this.isDraftMode
      ? this.selectedDeclarationDetail.quote_id
      : "";
    const policyId = this.isDraftMode
      ? this.selectedDeclarationDetail.policy_id
      : "";
    const subVoyageAry = this.isCloneMode
      ? await this.getSubVoyageAry(
          this.cloneMasterPolicyDetails.data.sub_voyage
        )
      : this.isDraftMode
      ? {
          certificate_bulk: "certificate",
          back_date_days:
            this.selectedDeclarationDetail.quote.data.backdate_days,
          bov_percentage:
            this.selectedDeclarationDetail.quote.data.bov_percentage,
          certificate_allowed:
            this.selectedDeclarationDetail.quote.data.certificate_allowed,
          id: this.selectedDeclarationDetail.quote.data.sub_voyage_id,
          days_post_expiry:
            this.selectedDeclarationDetail.quote.data.days_post_expiry,
          sub_voyage_name:
            this.selectedDeclarationDetail.quote.data.sub_voyage_name,
          min_shipment_premium:
            this.selectedDeclarationDetail.quote.data.min_shipment_premium,
          mode_of_conveyance:
            this.selectedDeclarationDetail.quote.data.mode_of_conveyance,
          coverage_type:
            this.selectedDeclarationDetail.quote.data.coverage_type,
          marine_final_rate_percentage:
            this.selectedDeclarationDetail.quote.data
              .marine_final_rate_percentage,
          transit_excess_in_certificate:
            this.selectedDeclarationDetail.quote.data
              .transit_excess_in_certificate,
        }
      : await this.getSubVoyageAry(
          this.selectedDeclarationDetail.data.sub_voyage
        );
    // this.isCloneMode ? this.selectedDeclarationDetail.cust_fld_3 : this.selectedDeclarationDetail.quote.cust_fld_3
    const additionFields = {
      Certificate_Bulk: "certificate",
      certificate_bulk: "certificate",
      backdate_days: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.back_date_days
        : subVoyageAry.back_date_days,
      bov_percentage: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.bov_percentage
        : subVoyageAry.bov_percentage,
      bulk_declaration_type: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.bulk_declaration_type
        : subVoyageAry.bulk_declaration_type,
      certificate_allowed: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.certificate_allowed
        : subVoyageAry.certificate_allowed,
      cust_fld_1: this.declarationForm.controls.tp_policy_no.value,
      cust_fld_2: "certificate",
      cust_fld_3:
        this.isCloneMode || this.isDraftMode
          ? this.selectedDeclarationDetail.quote.cust_fld_3 ||
            this.selectedDeclarationDetail.policy_no
          : this.selectedDeclarationDetail.policy_no,
      cust_fld_4: subVoyageAry.id,
      cust_fld_9:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.pol_voyage ||
            (await this.commonService.getVoyageDesc(
              this.selectedDeclarationDetail.quote.data.voyage
            ))
          : await this.commonService.getVoyageDesc(
              this.selectedDeclarationDetail.quote.data.voyage
            ),
      cust_fld_8: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.policy_ref_num
        : this.selectedDeclarationDetail.quote.data.policy_ref_num,
      sub_voyage_id: subVoyageAry.id,
      days_post_expiry: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.days_post_expiry
        : subVoyageAry.days_post_expiry,
      declaration_type: "certificate",
      master_policy_no:
        this.isCloneMode || this.isDraftMode
          ? this.selectedDeclarationDetail.quote.cust_fld_3 ||
            this.selectedDeclarationDetail.policy_no
          : this.selectedDeclarationDetail.policy_no,
      mode_of_conveyance: this.declarationForm.controls.mode_of_shipment.value,
      nstpyn: this.uwRefferralReasons.length ? "Yes" : "No",
      per_seeding_limit: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.per_seeding_limit
        : subVoyageAry.per_seeding_limit,
      pol_back_days: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_back_days
        : subVoyageAry.back_date_days,
      pol_bov: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_bov
        : subVoyageAry.bov_percentage,
      pol_bulk_decl_type: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_bulk_decl_type
        : subVoyageAry.bulk_declaration_type,
      pol_certificate_allowed_yn: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_certificate_allowed_yn
        : subVoyageAry.certificate_allowed,
      pol_certificate_bulk: "certificate",
      pol_end_date: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.gc_policy_end_date
        : this.selectedDeclarationDetail.quote.data.gc_policy_end_date,
      pol_marine_rate: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_marine_rate
        : this.isCloneMode
        ? this.selectedDeclarationDetail.quote.data
            .marine_final_rate_percentage ||
          (await this.removeSeparator(
            subVoyageAry.marine_final_rate_percentage
          ))
        : subVoyageAry.marine_final_rate_percentage,
      pol_mode_conveyance: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_mode_conveyance
        : this.declarationForm.controls.mode_of_shipment.value,
      pol_policy_currency: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.policy_currency_type
        : this.selectedDeclarationDetail.quote.data.policy_currency_type,
      pol_policy_no: this.declarationForm.controls.tp_policy_no.value,
      pol_policy_type: this.selectedDeclarationDetail.quote.data.policy_type,
      pol_post_days: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_post_days
        : subVoyageAry.days_post_expiry,
      pol_psl: this.selectedDeclarationDetail.pol_psl,
      pol_si:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.pol_si ||
            this.selectedDeclarationDetail.quote.data.voyage.initial_sum_insured
          : this.selectedDeclarationDetail.quote.data.voyage
              .initial_sum_insured,
      pol_start_date: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.gc_policy_start_date
        : this.selectedDeclarationDetail.quote.data.gc_policy_start_date,
      pol_sub_voyage: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_sub_voyage
        : subVoyageAry.sub_voyage_name,
      pol_tax: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.tax_applicable
        : this.selectedDeclarationDetail.quote.data.tax_applicable,
      pol_voyage:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.pol_voyage ||
            (await this.commonService.getVoyageDesc(
              this.selectedDeclarationDetail.quote.data.voyage
            ))
          : await this.commonService.getVoyageDesc(
              this.selectedDeclarationDetail.quote.data.voyage
            ),
      policy_id: policyId,
      policy_type: this.selectedDeclarationDetail.quote.data.policy_type,
      premium_value: this.selectedDeclarationDetail.quote.data.premium_value,
      product_id: this.commonVariablesService.declarationProductId,
      quote_id: quoteId,
      sum_insured_percentage:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.sum_insured_percentage ||
            subVoyageAry.si_percentage
          : this.selectedDeclarationDetail.quote.data.si_percentage ||
            subVoyageAry.si_percentage,
      tax_amount: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.tax_applicable
        : this.selectedDeclarationDetail.quote.data.tax_applicable,
      tax_applicable: await this.commonService.taxApplicableStatus(
        this.pageContent == 2 && this.header.nav_to == ""
          ? this.selectedDeclarationDetail.quote.data.tax_applicable
          : this.isCloneMode
          ? this.cloneMasterPolicyDetails.quote.data.tax_applicable
          : this.selectedDeclarationDetail.quote.data.tax_applicable
      ),
      portal_lock_date: this.isCloneMode
        ? this.cloneMasterPolicyDetails.data.portal_lock_date
        : this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.portal_lock_date
        : this.selectedDeclarationDetail.data.portal_lock_date,
      __finalize: 0,
      referral_remark: this.referralRemarksVal,
      min_shipment_premium: subVoyageAry.min_shipment_premium,
      transit_excees:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.transit_excees ||
            this.selectedDeclarationDetail.quote.data.voyage.transit_excees
          : this.selectedDeclarationDetail.quote.data.voyage.transit_excees,
      transit_excess_in_certificate: subVoyageAry.transit_excess_in_certificate,
      non_std_clause_policy_setup: subVoyageAry.non_standard_clauses,
      premium_display_policy_setup: subVoyageAry.display_premium,
      // policy_start_date: this.datePipe.transform(this.minIssueDate, 'yyyy-MM-dd'),
      policy_start_date: this.datePipe.transform(
        this.f.expected_date_shipment.value,
        "yyyy-MM-dd"
      ),
      policy_end_date: this.datePipe.transform(this.maxIssueDate, "yyyy-MM-dd"),
    };
    let paramData = {};
    const extrakeys = {
      duty_premium: await this.removeSeparator(
        this.declarationForm.controls.duty_premium.value
      ),
      duty_si: await this.removeSeparator(
        this.declarationForm.controls.duty_si.value
      ),
      cargo_value: await this.removeSeparator(
        this.declarationForm.controls.cargo_value.value
      ),
      cargo_si_policy_currency: await this.removeSeparator(
        this.declarationForm.controls.cargo_si_policy_currency.value
      ),
      roe: await this.removeSeparator(this.declarationForm.controls.roe.value),
      cargo_si: await this.removeSeparator(
        this.declarationForm.controls.cargo_si.value
      ),
      total_si: await this.removeSeparator(
        this.declarationForm.controls.total_si.value
      ),
      cargo_premium: await this.removeSeparator(
        this.declarationForm.controls.cargo_premium.value
      ),
      total_premium: await this.removeSeparator(
        this.declarationForm.controls.total_premium.value
      ),
      gst: await this.removeSeparator(this.declarationForm.controls.gst.value),
      net_premium_final: await this.removeSeparator(
        this.declarationForm.controls.net_premium_final.value
      ),
      marine_final_rate_percentage: await this.removeSeparator(
        this.declarationForm.controls.marine_final_rate_percentage.value
      ),
    };

    paramData = {
      ...additionFields,
      ...this.declarationForm.getRawValue(),
      ...extrakeys,
      ...{ insuring_clause_and_condition: this.insuringClause },
      expected_date_shipment: this.datePipe.transform(
        this.f.expected_date_shipment.value,
        "yyyy-MM-dd"
      ),
      bill_date: this.datePipe.transform(this.f.bill_date.value, "yyyy-MM-dd"),
      invoice_date: this.datePipe.transform(
        this.f.invoice_date.value,
        "yyyy-MM-dd"
      ),
      issue_date: this.datePipe.transform(
        this.f.issue_date.value,
        "yyyy-MM-dd"
      ),
    };

    /* Need to remove 'extraKeys' after insillion issue fixed */
    const isCountry =
      this.uwRefferralReasons.indexOf(this.countryRefMsg) > -1 ? 1 : undefined;
    const isShipment =
      this.uwRefferralReasons.indexOf(this.backDationMsg) > -1 ? 1 : undefined;
    const isPsl =
      this.uwRefferralReasons.indexOf(this.pslMsg) > -1 ? 1 : undefined;
    let extraKeys = {
      is_country_referral: isCountry,
      is_shipmentdate_below_backdate: isShipment,
      is_psl_exceeds: isPsl,
    };

    extraKeys = JSON.parse(JSON.stringify(extraKeys));
    paramData = { ...paramData, ...extraKeys };

    const isDefaultClient =
      this.declarationForm.get("default_new_client").value;

    if (isDefaultClient == "Yes") {
      let id = "";
      for (const data of this.totalBrokerDetails) {
        if (
          data.producer_name ==
          this.declarationForm.get("new_insured_name").value
        )
          id = data.producer_code;
      }
      const defaultNewClientUrl = `${this.commonVariablesService.baseURL}api/v1/marine_mp_gc_data/insured`;
      defaultNewClientParam = {
        //policy_number: this.policyNumber,
        policy_number: this.policyNumber
          ? this.policyNumber
          : this.selectedDeclarationDetail.quote.cust_fld_1,
        policy_ref_num: this.selectedDeclarationDetail.cust_fld_3
          ? this.selectedDeclarationDetail.cust_fld_3
          : this.selectedDeclarationDetail.quote.cust_fld_3,
        //policy_ref_num: this.selectedDeclarationDetail.quote.cust_fld_3,
        insured_id: id,
        insured_name: this.declarationForm.get("new_insured_name").value,
        insured_add1: this.declarationForm.get("new_insured_address_1").value,
        insured_add2: this.declarationForm.get("new_insured_address_2").value,
        insured_add3: this.declarationForm.get("new_insured_address_3").value,
        insured_city: this.declarationForm.get("new_insured_city").value,
        insured_state: this.declarationForm.get("new_insured_state").value,
        insured_country: this.declarationForm.get("new_insured_country").value,
        insured_zipcode: this.declarationForm.get("new_insured_pincode").value,
        insured_gstin: this.declarationForm.get("new_insured_gstin").value,
        insured_district: this.declarationForm.get("new_insured_district")
          .value,
        certificate_number: "",
      };
      /* let defaultNewClientResponse = await this.commonService.httpPostMethod(defaultNewClientUrl, defaultNewClientParam, 'application/json', true, 'Declaration', this.impersonateFlag)
      if (defaultNewClientResponse.body.status != 0 && defaultNewClientResponse.body.status != -114) {
        this.commonService.errorsmsg(defaultNewClientResponse.body.txt, 'Error')
        return;
      } */
    }

    await this.spinner.show();
    let tmpParam = await this.insuringClauseParam();
    let paramMany = {
      addClientName: this.declarationForm.get("add_client_name").value
        ? this.declarationForm.get("add_client_name").value
        : "",
      isDefaultClient: isDefaultClient ? isDefaultClient : "",
      addNewClient: this.declarationForm.get("add_new_client").value
        ? this.declarationForm.get("add_new_client").value
        : "",
      insureClauseParam: tmpParam,
      saveNewClientParam: saveNewClientParam || "",
      defaultNewClientParam: defaultNewClientParam || "",
      quoteParam: paramData,
    };

    let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/client_user_for_certificate/saveQuoteData?productname=emarine`;
    const quoteResponse = await this.commonService.httpPostMethod(
      url,
      paramMany,
      "application/json",
      true,
      "Declaration"
    );
    // const quoteResponse = await this.commonService.httpPostMethod(url, paramMany, 'application/json', true, 'Declaration', this.impersonateFlag);
    // this.spinner.hide();
    if (quoteResponse.body.status == -114) {
      await this.spinner.hide();
      await this.closeModal();
    }
    if (quoteResponse.body.status == 0) {
      await this.spinner.hide();

      if (quoteResponse.body.data.isNstpEnabledFromRes) {
        await this.closeModal();
        this.commonService.successmsg(`${this.refToUW}`, "");
        this.gotoPageContent(1);
      } else {
        this.selectedDeclarationDetail = quoteResponse.body.data.quoteRes;
        // (this.pageContent == 2 || this.header.nav_to == 'update_draft') ? this.commonService.successmsg('Draft saved successfully', '') : '';
        if (this.pageContent == 2) {
          this.commonService.successmsg("Draft saved successfully", "");
        }
        /* let header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
        let header = JSON.parse(
          window.localStorage.getItem("declaration-header") || "{}"
        );
        header.tp_policy_no =
          this.selectedDeclarationDetail.quote.cust_fld_1 || "";
        header.insured_name =
          isDefaultClient == "Yes"
            ? this.declarationForm.get("new_insured_name").value
            : this.selectedDeclarationDetail.quote.data.client_name || "";
        header.insured_city =
          isDefaultClient == "Yes"
            ? this.declarationForm.get("new_insured_city").value
            : this.selectedDeclarationDetail.quote.data.insured_branch || "";
        header.policy_id = this.selectedDeclarationDetail.policy_id || "";
        header.quote_id = this.selectedDeclarationDetail.quote_id || "";
        header.header_policy =
          this.selectedDeclarationDetail.quote.cust_fld_1 || "";
        header.policy_no =
          this.selectedDeclarationDetail.quote.cust_fld_3 || "";
        header.nav_to = "acc_del_draft";
        header.certificate_status = "";
        /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
        window.localStorage.setItem(
          "declaration-header",
          JSON.stringify(header)
        );
        await this.closeModal();
        this.gotoPageContent(3);
      }
    } else if (quoteResponse.body.status != -114) {
      await this.spinner.hide();
      await this.closeModal();
      let tmpError = (quoteResponse.body.txt || "").split("~");
      this.commonService.errorsmsg(tmpError[1] || quoteResponse.body.txt, "");
    }
  }

  /*
   * Created By : Sharann N
   * Description : to agree the certificate will move to underwriter.
   *********************************************/
  changeReferChkFlg() {
    if ($("#refer").prop("checked")) {
      $("#refer").prop("checked", false);
      this.isReferred = false;
    } else {
      $("#refer").prop("checked", true);
      this.isReferred = true;
    }
  }

  /*
   * Created By : Sharann N
   * Description : to get referral remarks entered by user.
   *********************************************/
  referralRemarks(value) {
    this.referralRemarksVal = value;
  }

  /*
   * Created By : Sharann N
   * Description : to open modal template.
   *********************************************/
  async openModal(template: TemplateRef<any>) {
    this.modalRef = await this.modalService.show(template, this.configCenter);
    this.spinner.hide();
  }

  /*
   * Created By : Sharann N
   * Description : to check the master endorsement on click `expected date of shipment`.
   *********************************************/
  expectedDate() {
    setTimeout(async () => {
      this.minBillDate = new Date(
        this.declarationForm.controls.expected_date_shipment.value
      );
      const checkBillDateValue =
        (this.declarationForm.controls.expected_date_shipment.value || "") !=
          "" && (this.f.bill_date.value || "") != "Invalid Date"
          ? new Date(
              this.datePipe.transform(this.minBillDate, "yyyy-MM-dd") +
                "T00:00:00"
            ).getTime() <=
            new Date(
              this.datePipe.transform(this.f.bill_date.value, "yyyy-MM-dd") +
                "T00:00:00"
            ).getTime()
          : "";
      if (
        !(
          (this.header.nav_to == "update_draft" ||
            this.header.nav_to == "endorse-cert" ||
            this.header.nav_to == "canc_cert" ||
            this.isReferral) &&
          checkBillDateValue
        )
      ) {
        this.declarationForm.controls.bill_date.setValue("");
      }

      let myMoment: moment.Moment = moment(
        this.f.expected_date_shipment.value,
        "DD/MM/YYYY",
        true
      );
      if (myMoment["_d"] != "Invalid Date" && this.pageContent == 2) {
        await this.reAssignGcData();
      }
    }, 500);
  }

  /*
   * Created By : Sharann N
   * Description : to check roe field.
   *********************************************/
  async checkRoe(event = "") {
    if (this.pageContent == 11) {
      if (event != "") {
        let declRoeValue = event["ROE (Rate of exchange)"];
        const invoiceCurrency = event["Invoice currency Type"];
        const roeUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/roe_master`;
        const roeParam = {
          from_currency: invoiceCurrency,
        };
        const roeResponse = await this.commonService.httpGetMethod(
          roeUrl,
          "application/x-www-form-urlencoded; charset=UTF-8",
          true,
          roeParam,
          "Declaration",
          this.impersonateFlag
        );
        this.selectedRoeDetails =
          roeResponse.status == 0 ? roeResponse.data : [];
        const roeDetails: any = this.selectedRoeDetails.filter((value) => {
          return (
            (value.from_currency || "") == invoiceCurrency &&
            (value.to_currency || "") == this.policyCurrencyType
          );
        });
        if (declRoeValue) {
          const gcRoeValue = roeDetails.length ? roeDetails[0].roe_value : -1;
          //check roe value is zero or not
          const isRoeZero =
            isNaN(declRoeValue) || Number(declRoeValue) === 0 ? true : false;
          declRoeValue = Number(declRoeValue);
          //check roe value is within -15% to +15% variation
          const isRoeInvalid =
            gcRoeValue == -1
              ? false
              : declRoeValue <
                  Number((gcRoeValue - (gcRoeValue / 100) * 15).toFixed(2)) ||
                declRoeValue >
                  Number((gcRoeValue + (gcRoeValue / 100) * 15).toFixed(2));
          if (isRoeZero || isRoeInvalid) {
            return false;
          } else return true;
        }
      }
    } else {
      this.fieldError["roe"] = false;
      this.declarationForm.controls["roe"].setErrors(null);
      let declRoeValue = this.f.roe.value;
      const invoiceCurrency = this.f.invoice_currency.value;
      const roeDetails: any = this.selectedRoeDetails.filter((value) => {
        return (
          (value.from_currency || "") == invoiceCurrency &&
          (value.to_currency || "") == this.f.currency_type.value
        );
      });
      if (declRoeValue) {
        const gcRoeValue = roeDetails.length ? roeDetails[0].roe_value : -1;
        // check roe value is zero or not
        const isRoeZero =
          isNaN(declRoeValue) || Number(declRoeValue) === 0 ? true : false;
        declRoeValue = Number(declRoeValue);
        // check roe value is within -15% to +15% variation
        const isRoeInvalid =
          gcRoeValue == -1
            ? false
            : declRoeValue <
                Number((gcRoeValue - (gcRoeValue / 100) * 15).toFixed(2)) ||
              declRoeValue >
                Number((gcRoeValue + (gcRoeValue / 100) * 15).toFixed(2));
        if (isRoeZero || isRoeInvalid) {
          this.declarationForm.controls["roe"].setErrors({ invalidData: true });
          this.fieldError["roe"] = true;
        }
        if (event) {
          await this.calculateCertificatePremium();
        }
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : navigate to update draft/certificate page.
   *********************************************/
  async updateDraftOrCert(type) {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    this.isShowSubmitButton = false;
    /* let header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
    let header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    header.quote_id = this.selectedDeclarationDetail.quote_id;
    header.policy_id = this.selectedDeclarationDetail.policy_id;
    header.policy_no = this.selectedDeclarationDetail.master_policy_no;
    header.tp_policy_no = this.selectedDeclarationDetail.quote.cust_fld_1;
    header.sub_voyage_id =
      this.selectedDeclarationDetail.quote.data.sub_voyage_id;
    header.nav_to =
      type == 0 ? "update_draft" : type == 1 ? "endorse-cert" : "canc_cert";
    const pageId = type == 0 ? 8 : type == 1 ? 10 : 9;
    /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
    window.localStorage.setItem("declaration-header", JSON.stringify(header));
    this.gotoPageContent(pageId);
  }

  /*
   * Created By : Sharann N
   * Description : to load endorsement list for selected certificate.
   *********************************************/
  async loadEndorsementList() {
    this.spinner.show();
    const endorsementListUrl = `${this.commonVariablesService.baseURL}api/v2/endorsement/list/${this.masterPolicyId}`;
    const response = await this.commonService.httpGetMethod(
      endorsementListUrl,
      "application/json",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    if (response.status == 0) {
      this.totalEndorseResponseData = this.isAlreadyGenerated
        ? response.data.filter((value) => {
            return (
              (value.prd_endorsement.endorsement_name || "")
                .toLowerCase()
                .replace(/\s/g, "") ==
              this.commonService.declarationPremiumEndorsement
            );
          })
        : response.data.filter((value) => {
            return (
              (value.prd_endorsement.endorsement_name || "")
                .toLowerCase()
                .replace(/\s/g, "") ==
                this.commonService.declarationEndorsement ||
              (value.prd_endorsement.endorsement_name || "")
                .toLowerCase()
                .replace(/\s/g, "") ==
                this.commonService.declarationPremiumEndorsement
            );
          });
      let endorsementDetails = {
        policy_id: "",
        endorsement_id: "",
      };
      if (this.totalEndorseResponseData.length) {
        const data =
          this.totalEndorseResponseData[
            this.totalEndorseResponseData.length - 1
          ];
        endorsementDetails = await this.getEndromentDetails(
          data.endorsement_id
        );
      }
      await this.goToEndorsementData(endorsementDetails);
    } else if (response.status != -114) {
      this.spinner.hide();
      this.commonService.errorsmsg(response.txt || this.errorMsg, "");
    }
  }

  /*
   * Created By : Sharann N
   * Description : get the details of selected endorsment.
   *********************************************/
  async getEndromentDetails(endoresId) {
    const endorsementUrl = `${this.commonVariablesService.baseURL}api/v2/endorsement/${endoresId}`;
    const response = await this.commonService.httpGetMethod(
      endorsementUrl,
      "application/json",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    const ret = response.status == 0 ? response.data[0] || {} : {};
    if (JSON.stringify(ret) == "{}") {
      this.commonService.errorsmsg("Unable to get endorsement details", "");
    }
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : store selected endorsement data in sessionstorage.
   *********************************************/
  async goToEndorsementData(resp) {
    /* let header = JSON.parse(sessionStorage.getItem('declaration-header')); */
    let header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    header.endores_policy_id = resp.policy_id || "";
    header.endorsement_id = resp.endorsement_id || "";
    /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
    window.localStorage.setItem("declaration-header", JSON.stringify(header));
    this.isAlreadyGenerated && this.pageContent == 8
      ? await this.loadDraftData()
      : await this.checkEndorsement();
  }

  /*
   * Created By : Sharann N
   * Description : check certificate has endorsment or not.
   *********************************************/
  async checkEndorsement() {
    /* this.header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    this.pageContent == 3 || this.pageContent == 4
      ? await this.loadSavedCertificateData()
      : this.pageContent == 9
      ? await this.loadDraftData()
      : await this.loadSelectedEndorsementData();
  }

  /*
   * Created By : Sharann N
   * Description : get insillion endorsement details.
   *********************************************/
  async getEndorsementId(type) {
    const avalBalcUrl = `${this.commonVariablesService.baseURL}api/v1/product/endorsement`;
    const balcParamData = {
      product_id: this.commonVariablesService.declarationProductId,
    };
    const response = await this.commonService.httpGetMethod(
      avalBalcUrl,
      "application/json",
      true,
      balcParamData,
      "Declaration",
      this.impersonateFlag
    );
    let ret = response.status == 0 ? response.data || [] : [];
    if (ret.length == 0) {
      this.commonService.errorsmsg(
        response.txt || "Unable to get endorsement details",
        ""
      );
    }
    ret = ret.filter((value) => {
      return (
        (value.endorsement_name || "").toLowerCase().replace(/\s/g, "") == type
      );
    });
    return ret[0] || {};
  }

  /*
   * Created By : Sharann N
   * Description : to load selected endorsement data for the certificate.
   *********************************************/
  async loadSelectedEndorsementData() {
    /* this.header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    const policyId =
      (this.header.endores_policy_id || "") == ""
        ? this.masterPolicyId
        : this.header.endores_policy_id;
    this.selectedEndorsementData =
      (this.header.endorsement_id || "") == ""
        ? {}
        : await this.getEndromentDetails(this.header.endorsement_id);
    const policyUrl = `${this.commonVariablesService.baseURL}api/v1/policy/${policyId}`;
    const response = await this.commonService.httpGetMethod(
      policyUrl,
      "application/json",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    if (response.status == 0) {
      const responseData = response.data[0];
      this.selectedEndorsementDetails = responseData;
      const dtr = new Date(responseData.quote.data.issue_date || new Date());
      this.minIssueDate = new Date(responseData.quote.data.pol_start_date);
      this.minIssueDate = new Date(
        this.datePipe.transform(this.minIssueDate, "yyyy-MM-dd") + "T00:00:00Z"
      );
      this.maxIssueDate = new Date(responseData.quote.data.pol_end_date);
      this.maxIssueDate = new Date(
        this.datePipe.transform(this.maxIssueDate, "yyyy-MM-dd") + "T00:00:00Z"
      );
      console.log(this.maxIssueDate);
      this.isNstpEnabled =
        ((responseData.quote.data || {}).nstpyn || "") == "Yes" ? true : false;
      const endores_policy_id = this.header.endores_policy_id || "";
      // const isPremiumEndorsement = ((((this.selectedEndorsementData.eproposal || {}).data || {}).endorsement_name || '').toLowerCase().replace(/\s/g, "") == (this.commonService.declarationPremiumEndorsement)) ? true : false;
      const isEndorsement = endores_policy_id == "" ? false : true;
      this.isReferral = responseData.quote.data.uw_ref_type || "";
      await this.loadDropdownValues(isEndorsement);
      const pincode =
        responseData.quote.data.default_new_client == "Yes"
          ? responseData.quote.data.new_insured_pincode
          : responseData.quote.data.client_pincode;
      const new_pincode = !isEndorsement
        ? responseData.quote.data.new_insured_pincode
        : this.selectedEndorsementData.eproposal.data.new_insured_pincode;
      this.declarationForm.patchValue({
        tp_policy_no: responseData.quote.data.cust_fld_1,
        voyage_name: responseData.quote.data.voyage_name,
        sub_voyage_type: responseData.quote.data.sub_voyage_type,
        currency_type: responseData.quote.data.currency_type,
        bov_percentage: responseData.quote.data.bov_percentage,
        uw_ref_type: this.isReferral,
        client_name:
          responseData.quote.data.default_new_client == "Yes"
            ? responseData.quote.data.new_insured_name
            : responseData.quote.data.client_name,
        client_address_1:
          responseData.quote.data.default_new_client == "Yes"
            ? responseData.quote.data.new_insured_address_1
            : responseData.quote.data.client_address_1,
        client_address_2:
          responseData.quote.data.default_new_client == "Yes"
            ? responseData.quote.data.new_insured_address_2
            : responseData.quote.data.client_address_2,
        client_address_3:
          responseData.quote.data.default_new_client == "Yes"
            ? responseData.quote.data.new_insured_address_3
            : responseData.quote.data.client_address_3,
        client_pincode: pincode,
        insured_city:
          responseData.quote.data.default_new_client == "Yes"
            ? responseData.quote.data.new_insured_city
            : responseData.quote.data.insured_city,
        insured_district: await this.getDistrict(pincode),
        insured_state:
          responseData.quote.data.default_new_client == "Yes"
            ? responseData.quote.data.new_insured_state
            : responseData.quote.data.insured_state,
        insured_country:
          responseData.quote.data.default_new_client == "Yes"
            ? responseData.quote.data.new_insured_country
            : responseData.quote.data.insured_country,
        client_gstin:
          responseData.quote.data.default_new_client == "Yes"
            ? responseData.quote.data.new_insured_gstin
            : responseData.quote.data.client_gstin,
        add_new_client: !isEndorsement
          ? responseData.quote.data.add_new_client
          : this.selectedEndorsementData.eproposal.data.add_new_client,
        add_client_name: !isEndorsement
          ? responseData.quote.data.add_client_name
          : this.selectedEndorsementData.eproposal.data.add_client_name,
        default_new_client: !isEndorsement
          ? responseData.quote.data.default_new_client
          : this.selectedEndorsementData.eproposal.data.default_new_client,
        new_insured_name: !isEndorsement
          ? responseData.quote.data.new_insured_name
          : this.selectedEndorsementData.eproposal.data.new_insured_name,
        new_insured_address_1: !isEndorsement
          ? responseData.quote.data.new_insured_address_1
          : this.selectedEndorsementData.eproposal.data.new_insured_address_1,
        new_insured_address_2: !isEndorsement
          ? responseData.quote.data.new_insured_address_2
          : this.selectedEndorsementData.eproposal.data.new_insured_address_2,
        new_insured_address_3: !isEndorsement
          ? responseData.quote.data.new_insured_address_3
          : this.selectedEndorsementData.eproposal.data.new_insured_address_3,
        new_insured_pincode: new_pincode,
        new_insured_city: responseData.quote.data.new_insured_city,
        new_insured_district: await this.getDistrict(new_pincode),
        new_insured_state: responseData.quote.data.new_insured_state,
        new_insured_country: responseData.quote.data.new_insured_country,
        new_insured_gstin: !isEndorsement
          ? responseData.quote.data.new_insured_gstin
          : this.selectedEndorsementData.eproposal.data.new_insured_gstin,
        mode_of_shipment: !isEndorsement
          ? responseData.quote.data.mode_of_shipment
          : this.selectedEndorsementData.eproposal.data.mode_of_shipment,
        coverage_type: !isEndorsement
          ? responseData.quote.data.coverage_type
          : this.selectedEndorsementData.eproposal.data.coverage_type,
        packing: !isEndorsement
          ? responseData.quote.data.packing
          : this.selectedEndorsementData.eproposal.data.packing,
        from_country: !isEndorsement
          ? responseData.quote.data.from_country
          : this.selectedEndorsementData.eproposal.data.from_country,
        to_country: !isEndorsement
          ? responseData.quote.data.to_country
          : this.selectedEndorsementData.eproposal.data.to_country,
        from_city: !isEndorsement
          ? responseData.quote.data.from_city
          : this.selectedEndorsementData.eproposal.data.from_city,
        to_city: !isEndorsement
          ? responseData.quote.data.to_city
          : this.selectedEndorsementData.eproposal.data.to_city,
        from_city_country: !isEndorsement
          ? `${responseData.quote.data.from_city}, ${responseData.quote.data.from_country}`
          : `${this.selectedEndorsementData.eproposal.data.from_city}, ${this.selectedEndorsementData.eproposal.data.from_country}`,
        to_city_country: !isEndorsement
          ? `${responseData.quote.data.to_city}, ${responseData.quote.data.to_country}`
          : `${this.selectedEndorsementData.eproposal.data.to_city}, ${this.selectedEndorsementData.eproposal.data.to_country}`,
        invoice_currency: !isEndorsement
          ? responseData.quote.data.invoice_currency
          : this.selectedEndorsementData.eproposal.data.invoice_currency,
        cargo_value: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.cargo_value
            : this.selectedEndorsementData.eproposal.data.cargo_value,
          true
        ),
        cargo_si_policy_currency: await this.decimalPt(
          responseData.quote.data.cargo_si_policy_currency,
          true
        ),
        roe: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.roe
            : this.selectedEndorsementData.eproposal.data.roe,
          true
        ),
        cargo_si: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.cargo_si
            : this.selectedEndorsementData.eproposal.data.cargo_si,
          true
        ),
        duty_si: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.duty_si
            : this.selectedEndorsementData.eproposal.data.duty_si,
          true
        ),
        total_si: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.total_si
            : this.selectedEndorsementData.eproposal.data.total_si,
          true
        ),
        cargo_premium: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.cargo_premium
            : this.selectedEndorsementData.eproposal.data.cargo_premium,
          true
        ),
        duty_premium: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.duty_premium
            : this.selectedEndorsementData.eproposal.data.duty_premium,
          true
        ),
        total_premium: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.total_premium
            : this.selectedEndorsementData.eproposal.data.total_premium,
          true
        ),
        gst: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.gst
            : this.selectedEndorsementData.eproposal.data.gst,
          true
        ),
        net_premium_final: await this.decimalPt(
          !isEndorsement
            ? responseData.quote.data.net_premium_final
            : this.selectedEndorsementData.eproposal.data.net_premium_final,
          true
        ),
        non_std_clause: responseData.quote.data.non_std_clause,
        marine_final_rate_percentage: !isEndorsement
          ? responseData.quote.data.marine_final_rate_percentage
          : this.selectedEndorsementData.eproposal.data
              .marine_final_rate_percentage,
        expected_date_shipment: !isEndorsement
          ? responseData.quote.data.expected_date_shipment
            ? new Date(responseData.quote.data.expected_date_shipment)
            : ""
          : this.selectedEndorsementData.eproposal.data.expected_date_shipment
          ? new Date(
              this.selectedEndorsementData.eproposal.data.expected_date_shipment
            )
          : "",
        // issue_date: (!isEndorsement) ? dtr : this.selectedEndorsementData.eproposal.data.issue_date,
        issue_date: new Date(
          !isEndorsement
            ? dtr
            : this.selectedEndorsementData.eproposal.data.issue_date
        ),
        bill_no: !isEndorsement
          ? responseData.quote.data.bill_no
          : this.selectedEndorsementData.eproposal.data.bill_no,
        bill_date: !isEndorsement
          ? responseData.quote.data.bill_date
            ? new Date(responseData.quote.data.bill_date)
            : ""
          : this.selectedEndorsementData.eproposal.data.bill_date
          ? new Date(this.selectedEndorsementData.eproposal.data.bill_date)
          : "",
        lc_no: !isEndorsement
          ? responseData.quote.data.lc_no
          : this.selectedEndorsementData.eproposal.data.lc_no,
        issuance_place: !isEndorsement
          ? responseData.quote.data.issuance_place
          : this.selectedEndorsementData.eproposal.data.issuance_place,
        invoice_no: !isEndorsement
          ? responseData.quote.data.invoice_no
          : this.selectedEndorsementData.eproposal.data.invoice_no,
        // invoice_date: (!isEndorsement) ? responseData.quote.data.invoice_date : this.selectedEndorsementData.eproposal.data.invoice_date,
        invoice_date: new Date(
          !isEndorsement
            ? responseData.quote.data.invoice_date
            : this.selectedEndorsementData.eproposal.data.invoice_date
        ),
        vessel_name: !isEndorsement
          ? responseData.quote.data.vessel_name
          : this.selectedEndorsementData.eproposal.data.vessel_name,
        consignee_name: !isEndorsement
          ? responseData.quote.data.consignee_name
          : this.selectedEndorsementData.eproposal.data.consignee_name,
        consignee_address: !isEndorsement
          ? responseData.quote.data.consignee_address
          : this.selectedEndorsementData.eproposal.data.consignee_address,
        financier_name: !isEndorsement
          ? responseData.quote.data.financier_name
          : this.selectedEndorsementData.eproposal.data.financier_name,
        lc_details: !isEndorsement
          ? responseData.quote.data.lc_details
          : this.selectedEndorsementData.eproposal.data.lc_details,
        subject_matter_insured: !isEndorsement
          ? responseData.quote.data.subject_matter_insured
          : this.selectedEndorsementData.eproposal.data.subject_matter_insured,
        marks_numbers: !isEndorsement
          ? responseData.quote.data.marks_numbers
          : this.selectedEndorsementData.eproposal.data.marks_numbers,
        claims_payable_at: responseData.quote.data.claims_payable_at,
        settling_agent: !isEndorsement
          ? responseData.quote.data.settling_agent
          : this.selectedEndorsementData.eproposal.data.settling_agent,
        settling_agent_company: !isEndorsement
          ? responseData.quote.data.settling_agent_company
          : this.selectedEndorsementData.eproposal.data.settling_agent_company,
        settling_agent_address: !isEndorsement
          ? responseData.quote.data.settling_agent_address
          : this.selectedEndorsementData.eproposal.data.settling_agent_address,
        settling_agent_phone: !isEndorsement
          ? responseData.quote.data.settling_agent_phone
          : this.selectedEndorsementData.eproposal.data.settling_agent_phone,
        settling_agent_email: !isEndorsement
          ? responseData.quote.data.settling_agent_email
          : this.selectedEndorsementData.eproposal.data.settling_agent_email,
        claims_rep: responseData.quote.data.claims_rep,
        cancel_cert: "",
        retain_cert: "",
        reason_cancel: "",
        cert_no: "",
        reason_nstp: "",
        reason_change: !isEndorsement
          ? ""
          : typeof this.selectedEndorsementData.eproposal.data.reason_change ==
            "string"
          ? this.selectedEndorsementData.eproposal.data.reason_change
          : "",
        fields_to_change: !isEndorsement
          ? ""
          : typeof this.selectedEndorsementData.eproposal.data
              .fields_to_change == "string"
          ? this.selectedEndorsementData.eproposal.data.fields_to_change
          : "",
        // endorsement_start_date: new Date((!isEndorsement) ? responseData.quote.data.expected_date_shipment || new Date : this.selectedEndorsementData.eproposal.data.expected_date_shipment || new Date),
        endorsement_start_date: new Date(
          this.datePipe.transform(this.minIssueDate, "yyyy-MM-dd")
        ),
        si_deductible: !isEndorsement
          ? responseData.quote.data.si_deductible
          : this.selectedEndorsementData.eproposal.data.si_deductible,
      });
      const balance: any = await this.calcPolicyBalance(
        responseData.quote.data.cust_fld_3,
        !isEndorsement
          ? responseData.quote.data.expected_date_shipment
            ? new Date(responseData.quote.data.expected_date_shipment)
            : ""
          : this.selectedEndorsementData.eproposal.data.expected_date_shipment
          ? new Date(
              this.selectedEndorsementData.eproposal.data.expected_date_shipment
            )
          : ""
      );
      this.declarationForm.patchValue({
        opening_balance: await this.decimalPt(
          balance.without_date.available_opening_balance_certificate,
          true
        ),
        balance_premium: await this.decimalPt(
          balance.without_date.available_premium_balance_certificate,
          true
        ),
      });
      await this.assignValueToForm();
      await this.getInsuringClause();
      this.validateFields();
    } else if (response.status != -114) {
      this.commonService.errorsmsg(response.txt, "");
    }
  }

  /*
   * Created By : Sharann N
   * Description : to save the endorsement.
   *********************************************/
  async saveEndorsement(approveType, isCancelCertificate = false) {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    if (isCancelCertificate) {
      // cancel certifciate request creates endorsement and refer to UW
      this.isRefToUw = true;
    }
    await this.assignValueToForm();
    const ret = approveType == 2 ? 1 : await this.validateForm();
    if (ret == 1) {
      let status = "",
        cancelValidateParam = {};

      if (approveType == 2 ? true : this.declarationForm.valid) {
        if (isCancelCertificate) {
          //Ticket No 154865
          this.isApproveOrReject = true;
          this.isApproveOrReject = true;
          cancelValidateParam = await this.cancelValidate();
        }
        await this.spinner.show();
        const type =
          this.isRefToUw || this.isAlreadyGenerated
            ? this.commonService.declarationPremiumEndorsement
            : this.commonService.declarationEndorsement;
        this.prdEndorsementDetails = await this.getEndorsementId(type);
        const saveEndorsementUrl = `${this.commonVariablesService.baseURL}api/v2/eproposal`;
        let request = {
          eproposal_id: "",
          policy_id: this.masterPolicyId,
          eproposal_status: "",
          eproposal_reason: "",
          __finalize: 0,
        };
        if (this.isAlreadyGenerated) {
          if (approveType == 1) {
            status = "Approved";
          } else if (approveType == 0) {
            status = "Rejected";
          }
          request = {
            eproposal_id: this.selectedEndorsementData.eproposal_id,
            policy_id: this.selectedEndorsementData.policy_id,
            eproposal_status: status,
            eproposal_reason:
              this.declarationForm.controls.reason_nstp.value || "",
            __finalize: 1,
          };
        }
        const additionFields = {
          eproposal_id: request.eproposal_id,
          eproposal_no: "",
          product_id: this.commonVariablesService.declarationProductId,
          cert_id: "",
          prd_endorsement_id: this.prdEndorsementDetails.prd_endorsement_id,
          policy_id: request.policy_id,
          eproposal_status: request.eproposal_status,
          eproposal_reason: request.eproposal_reason,
          __finalize: request.__finalize,
        };
        const responseData = this.isAlreadyGenerated
          ? this.selectedDeclarationDetail.quote.data
          : this.selectedEndorsementDetails.quote.data;
        const dtr = new Date(responseData.issue_date || new Date());
        const endores_policy_id = this.header.endores_policy_id || "";
        const endoresmentData = endores_policy_id
          ? this.selectedEndorsementData.eproposal.data
          : this.selectedEndorsementDetails.quote.data;
        let editableFields = {};
        if (this.isRefToUw || this.isAlreadyGenerated) {
          editableFields["add_new_client"] =
            this.declarationForm.controls.add_new_client.value || "";
          editableFields["default_new_client"] =
            this.declarationForm.controls.default_new_client.value || "";
          editableFields["add_client_name"] =
            this.declarationForm.controls.add_client_name.value || "";
          editableFields["new_insured_name"] =
            this.declarationForm.controls.new_insured_name.value || "";
          editableFields["new_insured_address_1"] =
            this.declarationForm.controls.new_insured_address_1.value || "";
          editableFields["new_insured_address_2"] =
            this.declarationForm.controls.new_insured_address_2.value || "";
          editableFields["new_insured_address_3"] =
            this.declarationForm.controls.new_insured_address_3.value || "";
          editableFields["new_insured_pincode"] =
            this.declarationForm.controls.new_insured_pincode.value || "";
          editableFields["new_insured_gstin"] =
            this.declarationForm.controls.new_insured_gstin.value || "";
          editableFields["mode_of_shipment"] =
            this.declarationForm.controls.mode_of_shipment.value || "";
          editableFields["packing"] =
            this.declarationForm.controls.packing.value || "";
          editableFields["from_country"] =
            this.declarationForm.controls.from_country.value || "";
          editableFields["to_country"] =
            this.declarationForm.controls.to_country.value || "";
          editableFields["from_city"] =
            this.declarationForm.controls.from_city.value || "";
          editableFields["to_city"] =
            this.declarationForm.controls.to_city.value || "";
          editableFields["from_city_country"] =
            this.declarationForm.controls.from_city_country.value || "";
          editableFields["to_city_country"] =
            this.declarationForm.controls.to_city_country.value || "";
          editableFields["coverage_type"] =
            this.declarationForm.controls.coverage_type.value || "";
          editableFields["insuring_clause_and_condition"] =
            this.insuringClause || "";
          editableFields["invoice_currency"] =
            this.declarationForm.controls.invoice_currency.value || "";
          editableFields["cargo_value"] =
            this.declarationForm.controls.cargo_value.value || "";
          editableFields["roe"] = this.declarationForm.controls.roe.value || "";
          editableFields["duty_si"] =
            this.declarationForm.controls.duty_si.value || "";
          editableFields["cargo_si"] =
            this.declarationForm.controls.cargo_si.value || "";
          editableFields["cargo_si_policy_currency"] =
            this.declarationForm.controls.cargo_si_policy_currency.value || "";
          editableFields["total_si"] =
            this.declarationForm.controls.total_si.value || "";
          editableFields["cargo_premium"] =
            this.declarationForm.controls.cargo_premium.value || "";
          editableFields["duty_premium"] =
            this.declarationForm.controls.duty_premium.value || "";
          editableFields["total_premium"] =
            this.declarationForm.controls.total_premium.value || "";
          editableFields["gst"] = this.declarationForm.controls.gst.value || "";
          editableFields["net_premium_final"] =
            this.declarationForm.controls.net_premium_final.value || "";
          editableFields["marine_final_rate_percentage"] =
            this.declarationForm.controls.marine_final_rate_percentage.value ||
            "";
          // editableFields['expected_date_shipment'] = this.declarationForm.controls.expected_date_shipment.value || '';
          editableFields["expected_date_shipment"] = this.datePipe.transform(
            this.declarationForm.controls.expected_date_shipment.value || "",
            "yyyy-MM-dd"
          );
          editableFields["non_std_clause"] =
            this.declarationForm.controls.non_std_clause.value || "";
          editableFields["invoice_no"] =
            this.declarationForm.controls.invoice_no.value || "";
          // editableFields['invoice_date'] = this.declarationForm.controls.invoice_date.value || '';
          editableFields["invoice_date"] = this.datePipe.transform(
            this.declarationForm.controls.invoice_date.value || "",
            "yyyy-MM-dd"
          );
          editableFields["financier_name"] =
            this.declarationForm.controls.financier_name.value || "";
          // editableFields['issue_date'] = this.declarationForm.controls.issue_date.value || '';
          editableFields["issue_date"] = this.datePipe.transform(
            this.declarationForm.controls.issue_date.value || "",
            "yyyy-MM-dd"
          );
          editableFields["subject_matter_insured"] =
            this.declarationForm.controls.subject_matter_insured.value || "";
          editableFields["settling_agent"] =
            this.declarationForm.controls.settling_agent.value || "";
          editableFields["settling_agent_company"] =
            this.declarationForm.controls.settling_agent_company.value || "";
          editableFields["settling_agent_address"] =
            this.declarationForm.controls.settling_agent_address.value || "";
          editableFields["settling_agent_phone"] =
            this.declarationForm.controls.settling_agent_phone.value || "";
          editableFields["settling_agent_email"] =
            this.declarationForm.controls.settling_agent_email.value || "";
          editableFields["endorsement_start_date"] =
            this.declarationForm.controls.endorsement_start_date.value ||
            new Date();
          editableFields["si_deductible"] =
            ((this.calcPremiumData.cells || {}).si_deductible || 0) == 0
              ? responseData.si_deductible
              : this.calcPremiumData.cells.si_deductible;
        }
        editableFields["bill_no"] = this.isRefToUw
          ? endoresmentData.bill_no || ""
          : this.declarationForm.controls.bill_no.value || "";
        editableFields["bill_date"] = this.datePipe.transform(
          this.isRefToUw
            ? endoresmentData.bill_date || ""
            : this.declarationForm.controls.bill_date.value || "",
          "yyyy-MM-dd"
        );
        editableFields["lc_no"] = this.isRefToUw
          ? endoresmentData.lc_no || ""
          : this.declarationForm.controls.lc_no.value || "";
        editableFields["issuance_place"] = this.isRefToUw
          ? endoresmentData.issuance_place || ""
          : this.declarationForm.controls.issuance_place.value || "";
        editableFields["vessel_name"] = this.isRefToUw
          ? endoresmentData.vessel_name
          : this.declarationForm.controls.vessel_name.value || "";
        editableFields["consignee_name"] = this.isRefToUw
          ? endoresmentData.consignee_name || ""
          : this.declarationForm.controls.consignee_name.value || "";
        editableFields["consignee_address"] = this.isRefToUw
          ? endoresmentData.consignee_address || ""
          : this.declarationForm.controls.consignee_address.value || "";
        editableFields["lc_details"] = this.isRefToUw
          ? endoresmentData.lc_details || ""
          : this.declarationForm.controls.lc_details.value || "";
        editableFields["marks_numbers"] = this.isRefToUw
          ? endoresmentData.marks_numbers || ""
          : this.declarationForm.controls.marks_numbers.value || "";
        editableFields["reason_change"] = this.isRefToUw
          ? this.declarationForm.controls.reason_change.value || ""
          : typeof endoresmentData.reason_change == "string"
          ? endoresmentData.reason_change || ""
          : "";
        editableFields["fields_to_change"] = this.isRefToUw
          ? this.declarationForm.controls.fields_to_change.value || ""
          : typeof endoresmentData.fields_to_change == "string"
          ? endoresmentData.fields_to_change || ""
          : "";

        this.isReferral = this.isRefToUw
          ? isCancelCertificate
            ? this.isDuplicate
              ? "Certificate Cancellation - Duplication"
              : "Certificate Cancellation - Any Other"
            : this.updateCertReferral
          : responseData.uw_ref_type || responseData.referral_type || "";
        const pincode = responseData.client_pincode;
        const new_pincode = this.isAlreadyGenerated
          ? editableFields["new_insured_pincode"]
          : endoresmentData.new_insured_pincode;
        const balance: any = await this.calcPolicyBalance(
          responseData.cust_fld_3,
          this.isAlreadyGenerated
            ? editableFields["expected_date_shipment"]
            : endoresmentData.expected_date_shipment
        );
        const premiumFields = {
          cargo_value: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["cargo_value"]
              : endoresmentData.cargo_value || responseData.cargo_value
          ),
          cargo_si_policy_currency: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["cargo_si_policy_currency"]
              : endoresmentData.cargo_si_policy_currency ||
                  responseData.cargo_si_policy_currency
          ),
          cargo_si: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["cargo_si"]
              : endoresmentData.cargo_si || responseData.cargo_si
          ),
          duty_si: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["duty_si"]
              : endoresmentData.duty_si || responseData.duty_si
          ),
          total_si: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["total_si"]
              : endoresmentData.total_si || responseData.total_si
          ),
          cargo_premium: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["cargo_premium"]
              : endoresmentData.cargo_premium || responseData.cargo_premium
          ),
          duty_premium: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["duty_premium"]
              : endoresmentData.duty_premium || responseData.duty_premium
          ),
          total_premium: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["total_premium"]
              : endoresmentData.total_premium || responseData.total_premium
          ),
          gst: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["gst"]
              : endoresmentData.gst || responseData.gst
          ),
          net_premium_final: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["net_premium_final"]
              : endoresmentData.net_premium_final ||
                  responseData.net_premium_final
          ),
          si_deductible: this.isAlreadyGenerated
            ? editableFields["si_deductible"]
            : endoresmentData.si_deductible || responseData.si_deductible,
        };
        const formData = {
          tp_policy_no: responseData.cust_fld_1,
          voyage_name: responseData.voyage_name,
          sub_voyage_type: responseData.sub_voyage_type,
          opening_balance:
            balance.min_balance.available_opening_balance_certificate,
          balance_premium:
            balance.min_balance.available_premium_balance_certificate,
          currency_type: responseData.currency_type,
          bov_percentage: responseData.bov_percentage,
          policy_type: responseData.policy_type,
          uw_ref_type: this.isReferral,
          client_name: responseData.client_name,
          client_address_1: responseData.client_address_1,
          client_address_2: responseData.client_address_2,
          client_address_3: responseData.client_address_3,
          client_pincode: pincode,
          insured_city: responseData.insured_city,
          insured_district: await this.getDistrict(pincode),
          insured_state: responseData.insured_state,
          insured_country: responseData.insured_country,
          client_gstin: responseData.client_gstin,
          add_new_client: this.isAlreadyGenerated
            ? editableFields["add_new_client"]
            : endoresmentData.add_new_client,
          add_client_name: this.isAlreadyGenerated
            ? editableFields["add_client_name"]
            : endoresmentData.add_client_name,
          default_new_client: this.isAlreadyGenerated
            ? editableFields["default_new_client"]
            : endoresmentData.default_new_client,
          new_insured_name: this.isAlreadyGenerated
            ? editableFields["new_insured_name"]
            : endoresmentData.new_insured_name,
          new_insured_address_1: this.isAlreadyGenerated
            ? editableFields["new_insured_address_1"]
            : endoresmentData.new_insured_address_1,
          new_insured_address_2: this.isAlreadyGenerated
            ? editableFields["new_insured_address_2"]
            : endoresmentData.new_insured_address_2,
          new_insured_address_3: this.isAlreadyGenerated
            ? editableFields["new_insured_address_3"]
            : endoresmentData.new_insured_address_3,
          new_insured_pincode: new_pincode,
          new_insured_city: endoresmentData.new_insured_city,
          new_insured_district: await this.getDistrict(new_pincode),
          new_insured_state: endoresmentData.new_insured_state,
          new_insured_country: endoresmentData.new_insured_country,
          new_insured_gstin: this.isAlreadyGenerated
            ? editableFields["new_insured_gstin"]
            : endoresmentData.new_insured_gstin,
          mode_of_shipment: this.isAlreadyGenerated
            ? editableFields["mode_of_shipment"]
            : endoresmentData.mode_of_shipment,
          coverage_type: this.isAlreadyGenerated
            ? editableFields["coverage_type"]
            : endoresmentData.coverage_type,
          insuring_clause_and_condition: this.isAlreadyGenerated
            ? editableFields["insuring_clause_and_condition"]
            : endoresmentData.insuring_clause_and_condition,
          packing: this.isAlreadyGenerated
            ? editableFields["packing"]
            : endoresmentData.packing,
          from_country: this.isAlreadyGenerated
            ? editableFields["from_country"]
            : endoresmentData.from_country,
          to_country: this.isAlreadyGenerated
            ? editableFields["to_country"]
            : endoresmentData.to_country,
          from_city: this.isAlreadyGenerated
            ? editableFields["from_city"]
            : endoresmentData.from_city,
          to_city: this.isAlreadyGenerated
            ? editableFields["to_city"]
            : endoresmentData.to_city,
          from_city_country: this.isAlreadyGenerated
            ? editableFields["from_city_country"]
            : `${endoresmentData.from_city}, ${endoresmentData.from_country}`,
          to_city_country: this.isAlreadyGenerated
            ? editableFields["to_city_country"]
            : `${endoresmentData.to_city}, ${endoresmentData.to_country}`,
          invoice_currency: this.isAlreadyGenerated
            ? editableFields["invoice_currency"]
            : endoresmentData.invoice_currency || responseData.invoice_currency,
          cargo_value:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? -premiumFields.cargo_value
              : premiumFields.cargo_value,
          cargo_si_policy_currency:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? -premiumFields.cargo_si_policy_currency
              : premiumFields.cargo_si_policy_currency,
          roe: await this.removeSeparator(
            this.isAlreadyGenerated
              ? editableFields["roe"]
              : endoresmentData.roe || responseData.roe
          ),
          cargo_si:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? -premiumFields.cargo_si
              : premiumFields.cargo_si,
          duty_si:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? -premiumFields.duty_si
              : premiumFields.duty_si,
          total_si:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? -premiumFields.total_si
              : premiumFields.total_si,
          cargo_premium:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? -premiumFields.cargo_premium
              : premiumFields.cargo_premium,
          duty_premium:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? -premiumFields.duty_premium
              : premiumFields.duty_premium,
          total_premium:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? 0
              : premiumFields.total_premium,
          gst:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? 0
              : premiumFields.gst,
          net_premium_final:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? 0
              : premiumFields.net_premium_final,
          non_std_clause: this.isAlreadyGenerated
            ? editableFields["non_std_clause"]
            : endoresmentData.non_std_clause || responseData.non_std_clause,
          non_std_clause_policy_setup: responseData.non_std_clause_policy_setup,
          premium_display_policy_setup:
            responseData.premium_display_policy_setup,
          marine_final_rate_percentage: this.isAlreadyGenerated
            ? editableFields["marine_final_rate_percentage"]
            : endoresmentData.marine_final_rate_percentage ||
              responseData.marine_final_rate_percentage,
          // expected_date_shipment: (this.isAlreadyGenerated) ? editableFields['expected_date_shipment'] : endoresmentData.expected_date_shipment,
          expected_date_shipment: this.datePipe.transform(
            this.isAlreadyGenerated
              ? editableFields["expected_date_shipment"]
              : endoresmentData.expected_date_shipment,
            "yyyy-MM-dd"
          ),
          // issue_date: (this.isAlreadyGenerated) ? editableFields['issue_date'] : dtr,
          issue_date: this.datePipe.transform(
            this.isAlreadyGenerated ? editableFields["issue_date"] : dtr,
            "yyyy-MM-dd"
          ),
          bill_no: editableFields["bill_no"],
          bill_date: this.datePipe.transform(
            editableFields["bill_date"]
              ? new Date(editableFields["bill_date"])
              : "",
            "yyyy-MM-dd"
          ),
          lc_no: editableFields["lc_no"],
          issuance_place: editableFields["issuance_place"],
          invoice_no: this.isAlreadyGenerated
            ? editableFields["invoice_no"]
            : endoresmentData.invoice_no,
          // invoice_date: (this.isAlreadyGenerated) ? editableFields['invoice_date'] : endoresmentData.invoice_date,
          invoice_date: this.datePipe.transform(
            this.isAlreadyGenerated
              ? editableFields["invoice_date"]
              : endoresmentData.invoice_date,
            "yyyy-MM-dd"
          ),
          vessel_name: editableFields["vessel_name"],
          consignee_name: editableFields["consignee_name"],
          consignee_address: editableFields["consignee_address"],
          financier_name: this.isAlreadyGenerated
            ? editableFields["financier_name"]
            : endoresmentData.financier_name,
          lc_details: editableFields["lc_details"],
          subject_matter_insured: this.isAlreadyGenerated
            ? editableFields["subject_matter_insured"]
            : endoresmentData.subject_matter_insured ||
              responseData.subject_matter_insured,
          marks_numbers: editableFields["marks_numbers"],
          claims_payable_at:
            endoresmentData.claims_payable_at || responseData.claims_payable_at,
          settling_agent: this.isAlreadyGenerated
            ? editableFields["settling_agent"]
            : endoresmentData.settling_agent,
          settling_agent_company: this.isAlreadyGenerated
            ? editableFields["settling_agent_company"]
            : endoresmentData.settling_agent_company,
          settling_agent_address: this.isAlreadyGenerated
            ? editableFields["settling_agent_address"]
            : endoresmentData.settling_agent_address,
          settling_agent_phone: this.isAlreadyGenerated
            ? editableFields["settling_agent_phone"]
            : endoresmentData.settling_agent_phone,
          settling_agent_email: this.isAlreadyGenerated
            ? editableFields["settling_agent_email"]
            : endoresmentData.settling_agent_email,
          claims_rep: endoresmentData.claims_rep || responseData.claims_rep,
          cancel_cert: "",
          retain_cert: "",
          reason_cancel: "",
          cert_no: "",
          reason_nstp: "",
          reason_change: editableFields["reason_change"],
          fields_to_change: editableFields["fields_to_change"],
          // endorsement_start_date: new Date((this.isAlreadyGenerated) ? editableFields['expected_date_shipment'] : endoresmentData.expected_date_shipment),
          endorsement_start_date: new Date(
            this.datePipe.transform(this.minIssueDate, "yyyy-MM-dd")
          ),
          transit_excees: responseData.transit_excees,
          transit_excess_in_certificate:
            responseData.transit_excess_in_certificate,
          si_deductible:
            this.isAlreadyGenerated && isCancelCertificate && approveType == 1
              ? -premiumFields.si_deductible
              : premiumFields.si_deductible,
          Certificate_Bulk: "certificate",
          bulk_declaration_type: "certificate",
          quote_id: endoresmentData.quote_id || responseData.quote_id,
          policy_id: endoresmentData.policy_id || responseData.policy_id,
          policy_no: endoresmentData.policy_no || responseData.policy_no,
          master_policy_no: endoresmentData.master_policy_no || responseData.master_policy_no,
          tax_applicable: await this.commonService.taxApplicableStatus(
            responseData.tax_applicable
          ),
        };
        const paramData = {
          ...additionFields,
          ...formData,
          // policy_start_date: this.datePipe.transform(this.minIssueDate, 'yyyy-MM-dd'),
          policy_start_date: this.datePipe.transform(
            new Date(
              this.isAlreadyGenerated
                ? editableFields["expected_date_shipment"]
                : endoresmentData.expected_date_shipment
            ),
            "yyyy-MM-dd"
          ),
          policy_end_date: this.datePipe.transform(
            this.maxIssueDate,
            "yyyy-MM-dd"
          ),
        };

        let tmpParam = await this.insuringClauseParam();
        let paramMany = {
          insureClauseParam: tmpParam,
          userType: this.getUserType,
          isCancelCertificate: isCancelCertificate,
          isDuplicate: this.isDuplicate,
          endorsementDetails: this.prdEndorsementDetails || "",
          isRefToUw: this.isRefToUw,
          reason_change:
            this.declarationForm.controls.reason_change.value || "",
          selectedEndorsementPolicyId: this.selectedEndorsementDetails
            ? this.selectedEndorsementDetails.policy_id
            : "",
          cancelValidateParam: cancelValidateParam,
          type: type,
          selectedDeclarationDetail:
            JSON.stringify(this.selectedDeclarationDetail) == "{}"
              ? ""
              : this.selectedDeclarationDetail,
          approveType: approveType,
          cert_policy_no: this.declarationForm.controls.cert_no.value || "",
          cancel_status: status || "",
          reason_nstp: this.declarationForm.controls.reason_nstp.value || "",
          selectedEndorsementId:
            JSON.stringify(this.selectedEndorsementData) == "{}"
              ? ""
              : this.selectedEndorsementData.endorsement_id,
          fSiDeductible: this.f.si_deductible.value || "",
          eproposal: paramData,
        };

        // let response = await this.commonService.httpPostMethod(saveEndorsementUrl, paramData, 'application/json', true, 'Declaration', this.impersonateFlag);
        let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/client_user_for_certificate/saveEndorsement`;
        let response = await this.commonService.httpPostMethod(
          url,
          paramMany,
          "application/json",
          true,
          "Declaration"
        );

        if (response.body.status == 0) {
          await this.spinner.hide();

          if (
            this.getUserType != "underwriter" &&
            this.getUserType != "helpdesk"
          ) {
            if (this.isRefToUw) {
              if (isCancelCertificate) {
                this.commonService.successmsg(
                  response.body.data.cancelInitiateRes,
                  ""
                );
                this.gotoPageContent(1);
              } else {
                this.commonService.successmsg(
                  "Certificate refered to underwriter",
                  ""
                );
                this.gotoPageContent(1);
              }
            } else {
              const responseDataObj = response.body.data.eproposalRes;
              let header = JSON.parse(
                window.localStorage.getItem("declaration-header") || "{}"
              );
              header.endores_policy_id = responseDataObj.policy_id || "";
              header.endorsement_id = responseDataObj.endorsement_id || "";
              header.nav_to = "acc_del_draft";
              header.certificate_status = "";
              /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
              window.localStorage.setItem(
                "declaration-header",
                JSON.stringify(header)
              );
              await this.closeModal();
              this.gotoPageContent(3);
            }
          } else {
            if (isCancelCertificate) {
              this.commonService.successmsg(
                `Cancellation of Certificate is ${status}`,
                ""
              );
              this.gotoPageContent(
                this.getUserType == "underwriter" ||
                  this.getUserType == "helpdesk"
                  ? 0
                  : 1
              );
            } else {
              this.commonService.successmsg(
                "Certificate updated successfully",
                ""
              );
              this.gotoPageContent(0);
            }
          }
        } else if (response.body.status != -114) {
          //Ticket No 154865
          this.isShowCancelButton = false;
          await this.spinner.hide();
          this.commonService.errorsmsg(response.body.txt, "");
        }
      } else {
        //Ticket No 154865
        this.isShowCancelButton = false;
        this.focusOnInvalidFormField(this.declarationForm);
      }
    } else if (ret == 0) {
      //Ticket No 154865
      this.isApproveOrReject = false;
      await this.spinner.hide();
      //Ticket No 154865
      this.isShowCancelButton = false;
      this.commonService.warningmsg("Please fill Mandatory fields", "Warning");
    }
  }

  /*
   * Created By : Sharann N
   * Description : to refer the certificate to underwriter.
   *********************************************/
  async referToUW() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    this.isRefToUw = true;
    await this.saveOrUpdateQuote();
  }

  /*
   * Created By : Sharann N
   * Description : to delete the draft referral.
   *********************************************/
  async deleteDraftReferral() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    await this.spinner.show();
    const paramData = {
      quote_id: this.selectedDeclarationDetail.quote_id,
      policy_id: this.selectedDeclarationDetail.policy_id,
      product_id: this.commonVariablesService.declarationProductId,
      declaration_type: "certificate",
      certificate_bulk: "certificate",
      ...this.selectedDeclarationDetail.quote.data,
      __finalize: 0,
      referral_type: "Draft Deletion",
    };

    let tmpParam = await this.insuringClauseParam();
    let paramMany = {
      insureClauseParam: tmpParam,
      quoteParam: paramData,
    };
    let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/client_user_for_certificate/deleteDraftReferral`;
    let quoteResponse = await this.commonService.httpPostMethod(
      url,
      paramMany,
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );

    if (quoteResponse.body.status == -114) {
      await this.spinner.hide();
      await this.closeModal();
    }
    if (quoteResponse.body.status == 0) {
      await this.spinner.hide();
      this.commonService.successmsg(this.refToUW, "");
      await this.closeModal();
      this.gotoPageContent(1);
    } else if (quoteResponse.body.status != -114) {
      await this.spinner.hide();
      this.commonService.errorsmsg(quoteResponse.body.txt, "");
      await this.closeModal();
    }
  }

  /*
   * Created By : Sharann N
   * Description : convert the quote(draft) into policy(certificate).
   *********************************************/
  async convertToCertificate(isApproved) {
    await this.spinner.show();
    let tmpParam = await this.insuringClauseParam();
    let paramMany = {
      insureClauseParam: tmpParam,
      selectedDeclarationDetailPolicyId:
        this.selectedDeclarationDetail.policy_id,
      selectedDeclarationDetailQuoteId: this.selectedDeclarationDetail.quote_id,
      selectedDeclarationDetailCreatedBy:
        this.selectedDeclarationDetail["created_by"],
      selectedEndorsementId:
        JSON.stringify(this.selectedEndorsementData) == "{}"
          ? ""
          : this.selectedEndorsementData.endorsement_id,
      statusParam: status || "",
      isApproved: isApproved,
      masterPolicyId: this.masterPolicyId || "",
    };

    let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/uw_user_for_certificate/convertToCertificate`;

    if (JSON.stringify(this.selectedEndorsementData) != "{}") {
      let response = await this.commonService.httpPostMethod(
        url,
        paramMany,
        "application/json",
        true,
        "Declaration",
        this.impersonateFlag
      );

      if (response.body.status == 0) {
        await this.spinner.hide();
        this.commonService.successmsg(
          isApproved ? "Approved" : "Convert to Certificate",
          ""
        );
        this.gotoPageContent(
          this.getUserType == "underwriter" || this.getUserType == "helpdesk"
            ? 0
            : 1
        );
      } else {
        await this.spinner.hide();
        this.commonService.errorsmsg(response.body.txt, "");
      }
    } else {
      /*const pincode = this.selectedDeclarationDetail.quote.data.client_pincode;
      let quoteCreationParams: any = {
          Certificate_Bulk: 'certificate',
          add_new_client: this.selectedDeclarationDetail.quote.data.add_new_client,
          backdate_days: this.selectedDeclarationDetail.quote.data.back_date_days,
          balance_premium: this.selectedDeclarationDetail.balance_premium,
          bov_percentage: this.selectedDeclarationDetail.quote.data.bov_percentage,
          bulk_declaration_type: this.selectedDeclarationDetail.quote.data.bulk_declaration_type,
          cancel_cert: this.selectedDeclarationDetail.quote.data.cancel_cert,
          cargo_premium: this.selectedDeclarationDetail.quote.data.cargo_premium,
          cargo_si: this.selectedDeclarationDetail.quote.data.cargo_si,
          cargo_si_policy_currency: this.selectedDeclarationDetail.quote.data.cargo_si_policy_currency,
          cargo_value: this.selectedDeclarationDetail.quote.data.cargo_value,
          cert_no: this.selectedDeclarationDetail.quote.data.cert_no,
          certificate_allowed: this.selectedDeclarationDetail.quote.data.certificate_allowed,
          claims_payable_at: this.selectedDeclarationDetail.quote.data.claims_payable_at,
          claims_rep: this.selectedDeclarationDetail.quote.data.claims_rep,
          client_address_1: this.selectedDeclarationDetail.quote.data.client_address_1,
          client_address_2: this.selectedDeclarationDetail.quote.data.client_address_2,
          client_address_3: this.selectedDeclarationDetail.quote.data.client_address_3,
          client_gstin: this.selectedDeclarationDetail.quote.data.client_gstin,
          client_name: this.selectedDeclarationDetail.quote.data.client_name,
          client_pincode: pincode,
          coverage_type: this.selectedDeclarationDetail.quote.data.coverage_type,
          currency_type: this.selectedDeclarationDetail.quote.data.currency_type,
          cust_fld_1: this.selectedDeclarationDetail.quote.data.cust_fld_1,
          cust_fld_2: this.selectedDeclarationDetail.quote.data.cust_fld_2,
          cust_fld_3: this.selectedDeclarationDetail.quote.data.cust_fld_3,
          cust_fld_4: this.selectedDeclarationDetail.quote.data.cust_fld_4,
          cust_fld_9: this.selectedDeclarationDetail.quote.data.cust_fld_9,
          days_post_expiry: this.selectedDeclarationDetail.quote.data.days_post_expiry,
          declaration_type: this.selectedDeclarationDetail.quote.data.declaration_type,
          default_new_client: this.selectedDeclarationDetail.quote.data.default_new_client,
          duty_premium: this.selectedDeclarationDetail.quote.data.duty_premium,
          duty_si: this.selectedDeclarationDetail.quote.data.duty_si,
          // expected_date_shipment: this.selectedDeclarationDetail.quote.data.expected_date_shipment,
          expected_date_shipment: this.datePipe.transform(this.selectedDeclarationDetail.quote.data.expected_date_shipment, 'yyyy-MM-dd'),
          bill_no: this.selectedDeclarationDetail.quote.data.bill_no,
          // bill_date: this.selectedDeclarationDetail.quote.data.bill_date,
          bill_date: this.datePipe.transform(this.selectedDeclarationDetail.quote.data.bill_date, 'yyyy-MM-dd'),
          from_city: this.selectedDeclarationDetail.quote.data.from_city,
          from_country: this.selectedDeclarationDetail.quote.data.from_country,
          from_city_country: this.selectedDeclarationDetail.quote.data.from_city + "," + this.selectedDeclarationDetail.quote.data.from_country,
          to_city_country: this.selectedDeclarationDetail.quote.data.to_city + "," + this.selectedDeclarationDetail.quote.data.to_country,
          gst: this.selectedDeclarationDetail.quote.data.gst,
          insured_city: this.selectedDeclarationDetail.quote.data.insured_city,
          insured_district: await this.getDistrict(pincode),
          insured_country: this.selectedDeclarationDetail.quote.data.insured_country,
          insured_state: this.selectedDeclarationDetail.quote.data.insured_state,
          invoice_currency: this.selectedDeclarationDetail.quote.data.invoice_currency,
          // invoice_date: this.selectedDeclarationDetail.quote.data.invoice_date,
          invoice_date: this.datePipe.transform(this.selectedDeclarationDetail.quote.data.invoice_date, 'yyyy-MM-dd'),
          invoice_no: this.selectedDeclarationDetail.quote.data.invoice_no,
          issuance_place: this.selectedDeclarationDetail.quote.data.issuance_place,
          // issue_date: this.selectedDeclarationDetail.quote.data.issue_date,
          issue_date: this.datePipe.transform(this.selectedDeclarationDetail.quote.data.issue_date, 'yyyy-MM-dd'),
          marine_final_rate_percentage: this.selectedDeclarationDetail.quote.data.marine_final_rate_percentage,
          master_policy_no: this.selectedDeclarationDetail.policy_no,
          mode_of_conveyance: this.selectedDeclarationDetail.quote.data.mode_of_shipment,
          mode_of_shipment: this.selectedDeclarationDetail.quote.data.mode_of_shipment,
          net_premium_final: this.selectedDeclarationDetail.quote.data.net_premium_final,
          non_std_clause: this.selectedDeclarationDetail.quote.data.non_std_clause,
          non_std_clause_policy_setup: this.selectedDeclarationDetail.quote.data.non_std_clause_policy_setup,
          premium_display_policy_setup: this.selectedDeclarationDetail.quote.data.premium_display_policy_setup,
          opening_balance: this.selectedDeclarationDetail.opening_balance,
          packing: this.selectedDeclarationDetail.quote.data.packing,
          per_seeding_limit: this.selectedDeclarationDetail.quote.data.per_seeding_limit,
          pol_back_days: this.selectedDeclarationDetail.quote.data.pol_back_days,
          pol_bov: this.selectedDeclarationDetail.quote.data.pol_bov,
          pol_bulk_decl_type: this.selectedDeclarationDetail.quote.data.pol_bulk_decl_type,
          pol_certificate_allowed_yn: this.selectedDeclarationDetail.quote.data.certificate_allowed,
          pol_certificate_bulk: 'certificate',
          pol_end_date: this.selectedDeclarationDetail.quote.data.pol_end_date,
          pol_marine_rate: this.selectedDeclarationDetail.quote.data.pol_marine_rate,
          pol_mode_conveyance: this.selectedDeclarationDetail.quote.data.pol_mode_conveyance,
          pol_policy_currency: this.selectedDeclarationDetail.quote.data.policy_currency_type,
          pol_policy_type: this.selectedDeclarationDetail.quote.data.policy_type,
          pol_start_date: this.selectedDeclarationDetail.quote.data.pol_start_date,
          pol_voyage: this.selectedDeclarationDetail.quote.data.pol_voyage,
          pol_sub_voyage: this.selectedDeclarationDetail.quote.data.pol_sub_voyage,
          pol_si: this.selectedDeclarationDetail.quote.data.pol_si,
          pol_tax: this.selectedDeclarationDetail.quote.data.tax_applicable,
          pol_psl: this.selectedDeclarationDetail.pol_psl,
          pol_post_days: this.selectedDeclarationDetail.quote.data.pol_post_days,
          policy_id: this.selectedDeclarationDetail.policy_id,
          policy_type: this.selectedDeclarationDetail.quote.data.policy_type,
          premium_value: this.selectedDeclarationDetail.quote.data.premium_value,
          product_id: this.commonVariablesService.declarationProductId,
          quote_id: this.selectedDeclarationDetail.quote_id,
          reason_cancel: this.selectedDeclarationDetail.quote.data.reason_cancel,
          reason_cancellation: this.selectedDeclarationDetail.quote.data.reason_cancellation,
          retain_cert: this.selectedDeclarationDetail.quote.data.retain_cert,
          settling_agent: this.selectedDeclarationDetail.quote.data.settling_agent,
          settling_agent_company: this.selectedDeclarationDetail.quote.data.settling_agent_company,
          settling_agent_address: this.selectedDeclarationDetail.quote.data.settling_agent_address,
          settling_agent_phone: this.selectedDeclarationDetail.quote.data.settling_agent_phone,
          settling_agent_email: this.selectedDeclarationDetail.quote.data.settling_agent_email,
          sub_voyage_type: this.selectedDeclarationDetail.quote.data.sub_voyage_type,
          subject_matter_insured: this.selectedDeclarationDetail.quote.data.subject_matter_insured,
          sum_insured_percentage: this.selectedDeclarationDetail.quote.data.sum_insured_percentage,
          tax_amount: this.selectedDeclarationDetail.quote.data.tax_applicable,
          to_city: this.selectedDeclarationDetail.quote.data.to_city,
          to_country: this.selectedDeclarationDetail.quote.data.to_country,
          total_premium: this.selectedDeclarationDetail.quote.data.total_premium,
          total_si: this.selectedDeclarationDetail.quote.data.total_si,
          tp_policy_no: this.selectedDeclarationDetail.quote.data.cust_fld_1,
          voyage_name: this.selectedDeclarationDetail.quote.data.voyage_name,
          // policy_start_date: this.datePipe.transform(this.minIssueDate, 'yyyy-MM-dd'),
          policy_start_date: this.datePipe.transform(this.selectedDeclarationDetail.quote.data.expected_date_shipment, 'yyyy-MM-dd'),
          policy_end_date: this.datePipe.transform(this.maxIssueDate, 'yyyy-MM-dd'),
          __finalize: 1
        }*/
      const paramData = {
        quote_id: this.selectedDeclarationDetail.quote_id,
      };

      paramMany["quoteParam"] = paramData;
      paramMany["maxIssueDate"] = this.maxIssueDate;
      let response = await this.commonService.httpPostMethod(
        url,
        paramMany,
        "application/json",
        true,
        "Declaration",
        this.impersonateFlag
      );

      if (response.body.status == 0) {
        await this.spinner.hide();

        if (response.body.txt.pincodeErrorMsg != "") {
          if (
            typeof response.body.txt === "object" &&
            response.body.txt.pincodeErrorMsg != ""
          ) {
            this.commonService.errorsmsg(response.body.txt.pincodeErrorMsg, "");
          }
        }

        this.commonService.successmsg(
          isApproved ? "Approved" : "Convert to Certificate",
          ""
        );
        this.gotoPageContent(
          this.getUserType == "underwriter" || this.getUserType == "helpdesk"
            ? 0
            : 1
        );
      } else if (
        response.body.status == -113 &&
        response.body.data.response &&
        response.body.data.response.modname == "qnstp"
      ) {
        await this.spinner.hide();
        this.commonService.errorsmsg("Need Approval", "");
      } else {
        await this.spinner.hide();
        if (response.body.txt.pincodeErrorMsg != "") {
          if (
            typeof response.body.txt === "object" &&
            response.body.txt.pincodeErrorMsg != ""
          ) {
            this.commonService.errorsmsg(response.body.txt.pincodeErrorMsg, "");
          }
        }

        this.commonService.errorsmsg(
          response.body.data.response
            ? response.body.data.response.txt
            : typeof response.body.txt === "object"
            ? response.body.txt.errorMsg
            : response.body.txt || this.errorMsg,
          ""
        );
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : get value with decimal point and `,` sepeartor.
   *********************************************/
  decimalPt(value, isAwait: boolean = false) {
    const decimalValue =
      (value || "") == "" ||
      String(value).trim() == "#VALUE?" ||
      String(value).trim() == "-"
        ? (0).toFixed(2)
        : Number(String(value).replace(/,/g, "").trim())
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (isAwait) {
      return new Promise(async (resolve) => {
        return resolve(decimalValue);
      });
    } else {
      return decimalValue;
    }
  }

  /*
   * Created By : Sharann N
   * Description : get common insuring clauses from master.
   *********************************************/
  async getCommonInsuringClause() {
    this.spinner.show();
    const insureClauseUrl = `${this.commonVariablesService.baseURL}api/v1/master/marine_common_insured_clause`;
    const insureResponse = await this.commonService.httpGetMethod(
      insureClauseUrl,
      "application/json",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    this.commonInsuringClause = "";
    if (insureResponse.status == 0) {
      for (const obj of insureResponse.data || []) {
        this.commonInsuringClause += obj.status == 0 ? `${obj.value}\n` : "";
      }
    } else if (insureResponse.status != -114) {
      this.commonService.errorsmsg(
        insureResponse.txt || "Unable to get common insuring clause",
        ""
      );
    }
  }

  /*
   * Created By : Sharann N
   * Description : get insuring clauses from master.
   *********************************************/
  async getInsuringClause() {
    /* Get Insured Clause */
    let insureClauseUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/insuring_clause_and_condition`;
    const params = {
      sub_voyage_name: this.declarationForm.controls.sub_voyage_type.value,
      voyage_name: await this.commonService.removeVoyageDesc(
        this.declarationForm.controls.voyage_name.value
      ),
      policy_type:
        (((this.selectedDeclarationDetail || {}).quote || {}).data || {})
          .policy_type ||
        (((this.selectedEndorsementData || {}).eproposal || {}).data || {})
          .policy_type ||
        (((this.selectedEndorsementDetails || {}).quote || {}).data || {})
          .policy_type ||
        "",
      coverage_type: this.declarationForm.controls.coverage_type.value,
    };
    this.insuringClause = "";
    let insureResponse = await this.commonService.httpGetMethod(
      insureClauseUrl,
      "application/x-www-form-urlencoded; charset=UTF-8",
      true,
      params,
      "Declaration",
      this.impersonateFlag
    );
    if (insureResponse.status == 0) {
      const filteredData = insureResponse.data.length
        ? insureResponse.data.filter((val) => {
            return (val.mode_of_conveyance || "")
              .toLowerCase()
              .includes((this.f.mode_of_shipment.value || "").toLowerCase());
          })
        : [""];
      this.insuringClause =
        filteredData.length == 0
          ? ""
          : filteredData[0].insuring_clause_and_condition || "";
    } else if (insureResponse.status != -114) {
      this.commonService.errorsmsg("Unable to get insuring clause", "");
    }

    /* Get common insuring clause */
    await this.getCommonInsuringClause();
    this.insuringClause += `\n${this.commonInsuringClause}`;
  }

  /*
   * Created By : Sharann N
   * Description : remove the `,` sepearator.
   *********************************************/
  async removeSeparator(data) {
    return data &&
      String(data).trim() != "-" &&
      String(data).trim() != "#VALUE?"
      ? String(data).replace(/,/g, "")
      : 0;
  }

  /*
   * Created By : Sharann N
   * Description : get the district value form pincode.
   *********************************************/
  async getDistrict(pincode) {
    if (pincode) {
      const pincodeUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/pincode`;
      const pincodeParamData = {
        num_pincode: pincode,
      };
      const response = await this.commonService.httpGetMethod(
        pincodeUrl,
        "application/json",
        true,
        pincodeParamData,
        "Declaration",
        this.impersonateFlag
      );
      let districtValue = "";
      if (response.status == 0) {
        districtValue = ((response.data || [])[0] || "").txt_district || "";
      } else if (response.status != -114) {
        this.commonService.errorsmsg(
          response.txt || "Unable to get district",
          ""
        );
      }
      return districtValue;
    } else {
      return "";
    }
  }

  /*
   * Created By : Sharann N
   * Description : to re-assign the gc details from master endorsement details.
   *********************************************/
  async reAssignGcData(param = {}) {
    let obj;
    let details: any = [];
    // Ticket no - 161061 upload excel changes
    if (
      this.isCloneMode ||
      this.f.expected_date_shipment.value ||
      this.shipmentDate
    ) {
      if (JSON.stringify(param) == "{}") {
        // Ticket no - 161061 upload excel changes

        // Ticket No : 176527 Same voyage name changes start
        obj = {
          expected_date_shipment: {
            value: this.isCloneMode
              ? this.f.expected_date_shipment.value ||
                this.selectedDeclarationDetail.quote.data.expected_date_shipment
              : this.f.expected_date_shipment.value || this.shipmentDate,
          },
          voyage_name: {
            value: this.isCloneMode
              ? this.f.voyage_name.value ||
                this.selectedDeclarationDetail.quote.data.pol_voyage
              : this.f.voyage_name.value,
          },
          sub_voyage_type: {
            value: this.isCloneMode
              ? this.f.sub_voyage_type.value ||
                this.selectedDeclarationDetail.quote.data.sub_voyage_type
              : this.f.sub_voyage_type.value,
          },
          risk_details: { value: this.header.risk_detail_serial },
          gc_running_id: { value: this.header.gc_running_id },
        };
        details = await this.commonService.getSelectedGcData(
          obj,
          this.gcEndorsementDetails,
          true
        );
      }
      /* if (JSON.stringify(param) != '{}') 
			obj = param;
		  else {
			obj = {
			  expected_date_shipment: { value: this.isCloneMode ? this.f.expected_date_shipment.value || this.selectedDeclarationDetail.quote.data.expected_date_shipment : this.f.expected_date_shipment.value },
			  voyage_name: { value: this.isCloneMode ? this.f.voyage_name.value || this.selectedDeclarationDetail.quote.data.pol_voyage : this.f.voyage_name.value },
			  sub_voyage_type: { value: this.isCloneMode ? this.f.sub_voyage_type.value || this.selectedDeclarationDetail.quote.data.sub_voyage_type : this.f.sub_voyage_type.value }
			};
			details = await this.commonService.getSelectedGcData(obj, this.gcEndorsementDetails, true);
		  } */
    }
    if (details.length) {
      this.isEndorsementValue = true;
      /* let header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
      let header = JSON.parse(
        window.localStorage.getItem("declaration-header") || "{}"
      );
      header.policy_id = this.isCloneMode
        ? header.policy_id
        : details[0].quote.data.policy_id || "";
      header.policy_no = details[0].quote.data.master_policy_no || "";
      header.sub_voyage_id = details[0].data.sub_voyage[0].id || 0;
      /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
      //window.localStorage.setItem('declaration-header', JSON.stringify(header));  //Priyadharshini -->Endorsement date update
      this.header = JSON.parse(
        window.localStorage.getItem("declaration-header") || "{}"
      );
      if (this.isCloneMode) {
        this.cloneMasterPolicyDetails = details[0];
      } else {
        this.selectedDeclarationDetail = details[0];
      }
      this.minIssueDate = new Date(
        details[0].quote.data.portal_effective_date ||
          details[0].quote.data.gc_policy_start_date
      );
      this.minIssueDate = new Date(
        this.datePipe.transform(this.minIssueDate, "yyyy-MM-dd") + "T00:00:00Z"
      );
      // this.minIssueDate = new Date(details.length ? details[0].endorsement_start_date || details[0].quote.data.voyage.voyage_start_date : details[0].quote.data.gc_policy_start_date);
      this.maxIssueDate = new Date(details[0].quote.data.gc_policy_end_date);
      this.maxIssueDate = new Date(
        this.datePipe.transform(this.maxIssueDate, "yyyy-MM-dd") + "T00:00:00Z"
      );
      // this.minBillDate = this.minIssueDate;
      await this.reAssignGcDataToForm();
    }
    else{
      //excel issue
      this.isEndorsementValue = false;
      }
    await this.loadDropdownValues();
    // await this.calculateCertificatePremium();
    await this.claimsPay();
  }

  /*
   * Created By : Sharann N
   * Description : to re-assign the values of form fields from master endorsement details.
   *********************************************/
  async reAssignGcDataToForm() {
    const gcPolicyData = this.isCloneMode
      ? this.cloneMasterPolicyDetails
      : this.selectedDeclarationDetail;
    const subVoyageAry = await this.getSubVoyageAry(
      gcPolicyData.data.sub_voyage
    );
    this.modeOfConveyance = subVoyageAry.mode_of_conveyance;
    const modeOfConveyanceAry = (this.modeOfConveyance || "").split(",");
    const balance: any = await this.calcPolicyBalance(
      this.selectedDeclarationDetail.master_policy_no,
      this.f.expected_date_shipment.value
    );
    let tempDeclarationDetails = this.isCloneMode
		? this.cloneMasterPolicyDetails
		: this.selectedDeclarationDetail;
    // Ticket no - 161061 upload excel changes
    this.defaultPolicyInsuredName = tempDeclarationDetails;
    const clientDetails = await this.getInsuredDetails(tempDeclarationDetails);
    this.declarationForm.patchValue({
      voyage_name: await this.commonService.getVoyageDesc(
        gcPolicyData.quote.data.voyage
      ),
      sub_voyage_type: this.subVoyageName,
      opening_balance: await this.decimalPt(
        balance.without_date.available_opening_balance_certificate || 0,
        true
      ),
      balance_premium: await this.decimalPt(
        balance.without_date.available_premium_balance_certificate || 0,
        true
      ),
      currency_type: gcPolicyData.policy_currency_type,
      bov_percentage: subVoyageAry.bov_percentage,
      uw_ref_type: this.isReferral,
      client_name: clientDetails.clientName,
      client_address_1: clientDetails.clientAdd1,
      client_address_2: clientDetails.clientAdd2,
      client_address_3: clientDetails.clientAdd3,
      client_pincode: clientDetails.pincode,
      insured_city: clientDetails.city,
      insured_district:
        (clientDetails.district || "") == ""
          ? await this.getDistrict(clientDetails.pincode)
          : clientDetails.district,
      insured_state: clientDetails.state,
      insured_country: clientDetails.country,
      client_gstin: clientDetails.gstin,
      /* add_new_client: tempDeclarationDetails.add_new_client || 'No',
      add_client_name: tempDeclarationDetails.add_client_name,
      default_new_client: tempDeclarationDetails.default_new_client || 'No',
      new_insured_name: tempDeclarationDetails.new_insured_name,
      new_insured_address_1: tempDeclarationDetails.new_insured_address_1,
      new_insured_address_2: tempDeclarationDetails.new_insured_address_2,
      new_insured_address_3: tempDeclarationDetails.new_insured_address_3,
      new_insured_pincode: new_pincode,
      new_insured_city: tempDeclarationDetails.new_insured_city,
      new_insured_district: ((tempDeclarationDetails.new_insured_district || '') == '') ? await this.getDistrict(new_pincode) : tempDeclarationDetails.new_insured_district,
      new_insured_state: tempDeclarationDetails.new_insured_state,
      new_insured_country: tempDeclarationDetails.new_insured_country,
      new_insured_gstin: tempDeclarationDetails.new_insured_gstin, */
      mode_of_shipment:
        modeOfConveyanceAry.length == 1
          ? modeOfConveyanceAry[0]
          : this.f.mode_of_shipment.value,
      coverage_type: subVoyageAry.coverage_type,
      packing:
        this.selectedDeclarationDetail.quote.data.packing ||
        "In customary packing",
      /*  from_country: tempDeclarationDetails.from_country,
       to_country: tempDeclarationDetails.to_country,
       from_city: tempDeclarationDetails.from_city,
       to_city: tempDeclarationDetails.to_city,
       from_city_country: this.isCloneMode ? `${tempDeclarationDetails.from_city}, ${tempDeclarationDetails.from_country}` : '',
       to_city_country: this.isCloneMode ? `${tempDeclarationDetails.to_city}, ${tempDeclarationDetails.to_country}` : '', */
      invoice_currency: this.f.invoice_currency.value,
      non_std_clause: subVoyageAry.non_standard_clauses,
      marine_final_rate_percentage: subVoyageAry.marine_final_rate_percentage,
      issue_date: new Date(
        this.selectedDeclarationDetail.quote.data.issue_date || new Date()
      ),
      // issuance_place: clientDetails.city
    });
  }

  /*
   * Created By : Sharann N
   * Description : to check policy's validity.
   *********************************************/
  async checkPolicyValidOrNot() {
    let res = await this.checkMasterPolicy();
    let valid = res ? 1 : 0;
    const subVoyageAry = await this.getSubVoyageAry([]);
    const masterPolicyDetails = await this.getPolicyData(
      this.header.policy_no,
      true
    );
    res = await this.commonService.checkPolicyExpiredOrNot(
      //masterPolicyDetails.quote.data.gc_policy_end_date,
      masterPolicyDetails.cust_fld_2 ? masterPolicyDetails.cust_fld_2 :masterPolicyDetails.quote.data.gc_policy_end_date,
      subVoyageAry.days_post_expiry
    );
    valid = res ? valid + 1 : valid;
    const ret = valid > 0;
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : get certificate or draft no.
   *********************************************/
  async getCertificateOrDraftNo(policyNo) {
    let ret = "";
    if (policyNo) {
      const policyData = await this.getPolicyData(policyNo, true);
      // if certificate no is not generated return policy_no likewise alternative for draft no is quote_id
      ret = policyData.policy_no
        ? policyData.quote.cust_fld_6
          ? policyData.quote.cust_fld_6
          : policyData.policy_no
        : policyData.quote.cust_fld_5
        ? policyData.quote.cust_fld_5
        : policyData.quote_id;
    }
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : to get insured detils.
   *********************************************/
  async getInsuredDetails(policyData) {
    let defaultClientUrl = `${this.commonVariablesService.baseURL}api/v1/marine_mp_gc_data/insured`;
    let defaultClientParam = {
      policy_ref_num: policyData.cust_fld_3,
    };
    let clientName = "",
      clientAdd1 = "",
      clientAdd2 = "",
      clientAdd3 = "",
      pincode = "",
      city = "",
      state = "",
      district = "",
      country = "",
      gstin = "";
    if (this.isNewClientApplicable == true) {
      this.defaultResponse = await this.commonService.httpGetMethod(
        defaultClientUrl,
        "",
        true,
        defaultClientParam,
        "Declaration",
        this.impersonateFlag
      );
      //let clientName = '', clientAdd1 = '', clientAdd2 = '', clientAdd3 = '', pincode = '', city = '', state = '', district = '', country = '', gstin = '';
      if (this.defaultResponse.status == 0) {
        if (this.defaultResponse.data.length > 0) {
          clientName =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_name;
          clientAdd1 =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_add1;
          clientAdd2 =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_add2;
          clientAdd3 =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_add3;
          pincode =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_zipcode;
          city =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_city;
          state =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_state;
          district =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_district;
          country =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_country;
          gstin =
            this.defaultResponse.data[this.defaultResponse.data.length - 1]
              .insured_gstin;
        }
      } else {
        this.spinner.hide();
        this.commonService.errorsmsg("Unable to get insured details", "");
      }
    }
    if (
      this.defaultResponse.status != 0 ||
      (this.defaultResponse.data || []).length == 0 ||
      this.isNewClientApplicable == false
    ) {
      clientName = this.isCloneMode
        ? policyData.client_name ||
          policyData.insured_name ||
          policyData.broker_name ||
          "-"
        : policyData.quote.data.insured_name;
      clientAdd1 = this.isCloneMode
        ? policyData.client_address_1 ||
          policyData.insured_add1 ||
          policyData.broker_address_1 ||
          "-"
        : policyData.quote.data.insured_add1;
      clientAdd2 = this.isCloneMode
        ? policyData.client_address_2 ||
          policyData.insured_add2 ||
          policyData.broker_address_2 ||
          "-"
        : policyData.quote.data.insured_add2;
      clientAdd3 = this.isCloneMode
        ? policyData.client_address_3 ||
          policyData.insured_add3 ||
          policyData.broker_address_3 ||
          "-"
        : policyData.quote.data.insured_add3;
      pincode = this.isCloneMode
        ? policyData.client_zipcode ||
          policyData.insured_zipcode ||
          policyData.broker_zipcode ||
          "-"
        : policyData.quote.data.insured_zipcode;
      city = this.isCloneMode
        ? policyData.client_city ||
          policyData.insured_city ||
          policyData.broker_city
        : this.selectedDeclarationDetail.quote.data.insured_city;
      state = this.isCloneMode
        ? policyData.client_state ||
          policyData.insured_state ||
          policyData.broker_state
        : this.selectedDeclarationDetail.quote.data.insured_state;
      district = this.isCloneMode
        ? policyData.client_district ||
          policyData.insured_district ||
          policyData.broker_district
        : this.selectedDeclarationDetail.quote.data.insured_district;
      country = this.isCloneMode
        ? policyData.client_country ||
          policyData.insured_country ||
          policyData.broker_country
        : this.selectedDeclarationDetail.quote.data.insured_country;
      gstin = this.isCloneMode
        ? policyData.client_gstin ||
          policyData.insured_gstin ||
          policyData.broker_gstin
        : policyData.quote.data.insured_gstin;
    }

    // let clientName = '', clientAdd1 = '', clientAdd2 = '', clientAdd3 = '', pincode = '', city = '', state = '', district = '', country = '', gstin = '';
    return {
      clientName: clientName,
      clientAdd1: clientAdd1,
      clientAdd2: clientAdd2,
      clientAdd3: clientAdd3,
      pincode: pincode,
      city: city,
      state: state,
      district: district,
      country: country,
      gstin: gstin,
    };
  }

  /*
   * Created By : Sharann N
   * Description : to assign value as textarea value in div content.
   *********************************************/
  async assignValueToForm() {
    if (this.pageContent != 11) {
      for (const obj of [
        "lc_details",
        "subject_matter_insured",
        "marks_numbers",
      ]) {
        const ret = await this.commonService.checkNull(
          document.getElementById(obj).innerText
        );
        this.declarationForm.controls[obj].setValue(
          (this.f[obj].value || "") != "" &&
            (this.f[obj].value || "") != document.getElementById(obj).innerText
            ? ret
              ? this.f[obj].value
              : document.getElementById(obj).innerText
            : ret
            ? ""
            : document.getElementById(obj).innerText
        );
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : paste as plain text.
   *********************************************/
  onPaste(event: ClipboardEvent, id) {
    // cancel paste
    event.preventDefault();
    // get text representation of clipboard
    let clipboardData = event.clipboardData || (<any>window).clipboardData;
    let pastedText = clipboardData.getData("text/plain");
    // insert text manually
    document.execCommand("insertText", false, pastedText);
  }

  /*
   * Created By : Sharann N
   * Description : marine final rate % validation.
   *********************************************/
  async mfrValidation(event: any) {
    const subVoyageAry = await this.getSubVoyageAry(this.gcPolicyDetails);
    const initialMFR = subVoyageAry.marine_final_rate_percentage;
    await this.commonService.numeric_keyPress(
      event,
      "mfr",
      String(initialMFR || ".").split(".")[1].length
    );
    // await this.calculateCertificatePremium();
  }

  /*
   * Created By : Sharann N
   * Description : to load history data in audit trail.
   *********************************************/
  async loadHistoryData() {
    this.spinner.show();
    /* this.header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    let url = `${this.commonVariablesService.baseURL}api/v1/policy`;
    const params = {
      policy_id: this.header.policy_id,
    };
    let response = await this.commonService.httpGetMethod(
      url,
      "application/json",
      true,
      params,
      "Declaration",
      this.impersonateFlag
    );
    if (response.status != 0 && response.status != -114) {
      this.commonService.errorsmsg(
        response.txt || "Unable to load history data",
        ""
      );
      return;
    }
    const declPolicyDetails = response.data[0];
    this.spinner.show();
    const endorsementListUrl = `${this.commonVariablesService.baseURL}api/v2/endorsement/list/${this.header.policy_id}`;
    response = await this.commonService.httpGetMethod(
      endorsementListUrl,
      "application/json",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    if (response.status != 0 && response.status != -114) {
      this.spinner.hide();
      this.commonService.errorsmsg(
        response.txt || "Unable to load updated data",
        ""
      );
      return;
    }
    const totalEndorseResponseData = response.data || [];
    this.spinner.show();
    url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/history_data/${this.header.policy_id}`;
    response = await this.commonService.httpGetMethod(
      url,
      "application/json",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    if (response.status != 0 && response.status != -114) {
      this.spinner.hide();
      this.commonService.errorsmsg(
        response.txt || "Unable to load history data",
        ""
      );
      return;
    }

    this.historyData = {
      is_certificate:
        declPolicyDetails.quote.cust_fld_2.toLowerCase() == "certificate"
          ? true
          : false,
      policy_id: this.header.policy_id,
      contentData: [],
    };
    this.spinner.show();
    // For Endorsements
    for (const obj of totalEndorseResponseData) {
      const policyData = await this.getPolicyData(this.header.policy_id);
      if (policyData.policy_id) {
        this.historyData.contentData.push({
          certificate_no: `${
            policyData.cust_fld_6 +
            "_" +
            ("0" + obj.endorsement_index).slice(-2)
          }`,
          user_id: obj.author,
          // convert to ISO datetime timestamp
          date_time: this.datePipe.transform(obj.u_ts, "dd-MM-yyyy h:mm:ss a"),
          date_obj: new Date(obj.u_ts),
          change_desc: `Update Certificate`,
          pdf: policyData.cust_fld_6 == "" ? "-" : "Download PDF",
          endorsement_id: obj.endorsement_id,
          policy_id: this.header.policy_id,
          idx: this.historyData.contentData.length,
          is_endorsement: true,
        });
      }
    }
    // For Policies and Quotes
    for (const obj of response.data) {
      const respObj = JSON.parse(obj.data);
      let desc = "";
      const arrayKeys = Object.keys(respObj);
      if ((respObj["certificate_bulk_no"] || "").indexOf("C") > -1) {
        desc = /is_EN([0-9]+_original_downloaded)/.test(obj.data)
          ? `Updated Certificate's Original downloaded`
          : arrayKeys.indexOf("is_original_downloaded") > -1
          ? `Original PDF of Certificate's downloaded`
          : arrayKeys.indexOf("pdf_date") > -1
          ? `Copy PDF of Certificate's downloaded`
          : arrayKeys.indexOf("certificate_bulk_no") > -1
          ? `Certificate converted from draft`
          : arrayKeys.indexOf("draft_no") > -1
          ? `Draft Created`
          : "";
      } else {
        desc =
          arrayKeys.indexOf("certificate_bulk_no") > -1
            ? `Bulk declartion converted from draft`
            : arrayKeys.indexOf("draft_no") > -1
            ? `Draft Created`
            : "";
      }
      const certDraftNo =
        arrayKeys.indexOf("certificate_bulk_no") > -1
          ? respObj["certificate_bulk_no"]
          : arrayKeys.indexOf("draft_no") > -1
          ? respObj["draft_no"]
          : "";
      const matches = obj.data.match(/is_EN([0-9]+_original_downloaded)/);
      const endorseId = (matches || [])[0] || "";
      const duplicateAry = this.historyData.contentData.filter((value) => {
        return (value.change_desc || "") == desc;
      });
      if (desc && duplicateAry.length == 0) {
        this.historyData.contentData.push({
          certificate_no: certDraftNo,
          user_id: obj.author,
          date_time: this.datePipe.transform(obj.u_ts, "dd-MM-yyyy h:mm:ss a"),
          date_obj: new Date(obj.u_ts),
          change_desc: desc,
          pdf: certDraftNo == "" ? "-" : "Download PDF",
          endorsement_id: endorseId,
          policy_id: this.header.policy_id,
          idx: this.historyData.contentData.length,
          is_endorsement: endorseId == "" ? false : true,
        });
      }
    }
    this.historyData.contentData.sort((a, b) => {
      return new Date(a.date_obj).getTime() - new Date(b.date_obj).getTime();
    });

    this.spinner.hide();
    // this.dtTrigger.next();
  }

  /**Added by Priyadharshiniin for certificate */
  async onFileUpload() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    if (this.uploadCertificate.value.file == "") {
      this.uploadCertificate.controls.file.setErrors({ required: true });
      this.submitted = true;
      return;
    }
    //$("#certificateData").DataTable().destroy();
    this.sampleData = [];
    this.excalValFlag = await this.excelFieldValidation();
    if (!this.excalValFlag) {
      this.fileUpload.nativeElement.value = null;
      this.sampleData = [];
    }
    this.recordLength = this.excelData.length;
    if (this.recordLength > this.excelRecordVal) {
      this.commonService.errorsmsg("Maximum 200 records can be uploaded", "");
    } else {
      let count = 0;
      for (let i = 0; i < this.sampleData.length; i++) {
        if (this.sampleData[i].statusmsg == this.failureTxt) count++;
      }
      if (this.sampleData.length == count)
        this.isShowGenerateCertificate = false;
      else this.isShowGenerateCertificate = true;
      this.modalRef = await this.modalService.show(
        this.excelTbl,
        this.configCenter
      );
    }
  }
  /**Added by Priyadharshiniin for certificate */
  async proceedDetailedDeclr() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    let hasError = false,
      count = 0;
    const prevselectedDeclarationDetail = this.selectedDeclarationDetail;
    $("#certificateData").DataTable().destroy();
    for (let item = 0; item < this.sampleData.length; item++) {
      try {
        this.selectedDeclarationDetail = prevselectedDeclarationDetail;
        if (this.sampleData[item].statusmsg == this.successTxt) {
          let result = await this.convertExcelToCertificate(
            this.sampleData[item]
          );
          if (result != true) {
            this.sampleData[item].statusmsg = "Failure";
            this.sampleData[item].statusreason = result;
            count++;
            hasError = true;
          } else {
            hasError = false;
            let sampledate = new Date(this.selectedDeclarationDetail.c_ts);
            let convertDate;
            convertDate = this.datePipe.transform(sampledate, "dd/MM/yyyy");
            this.certificateCompletedResult.push({
              cert_no: this.selectedDeclarationDetail.policy_no
                ? this.selectedDeclarationDetail.quote.cust_fld_6
                : this.selectedDeclarationDetail.quote.cust_fld_5,
              invoice_no: this.sampleData[item].invoice_No,
              invoice_date: this.sampleData[item].invoice_Date,
              status: "Success",
              transact_date: convertDate,
              total_si: this.selectedDeclarationDetail.quote.data.total_si,
              premium:
                this.selectedDeclarationDetail.quote.data.net_premium_final,
              data: {},
            });
          }
        } else {
          hasError = true;
        }
      } catch (e) {
        this.spinner.hide();
        return;
      }
    }
    if (count > 0) this.isShowGenerateCertificate = false;
    else this.isShowGenerateCertificate = true;
    this.dtTrigger.next();
    await this.completedTableContent("");
    // Excel Upload changes start: Ticket No - 144238
    for (let i = 0; i < this.excelData.length; i++) {
      if (this.excelData[i].statusmsg === "Failure") {
        hasError = true;
      }
    }

    // Excel Upload changes end: Ticket No - 144238
    if (hasError == false) {
      this.commonService.successmsg(
        "Certificate Uploaded Successfully",
        "Success"
      );
      this.uploadCertificate.controls.file.setValue("");
      this.closeModal();
      this.uploadCertificate.reset();
    }
    this.selectedDeclarationDetail = prevselectedDeclarationDetail;
    // Excel Upload changes start: Ticket No - 144238
    for (let i = 0; i < this.sampleExcelData.length; i++) {
      this.sampleExcelData[i].statusreason = this.excelData[i].statusreason;
      this.sampleExcelData[i].statusmsg = this.excelData[i].statusmsg;
    }
    // Excel Upload changes end
  }

  /*
   * Created By : Vishnuraj
   * Description : To change Date Format.
   *********************************************/
  detectFormat(date: string): string {
    let format: string = "";
    let s_date = date.split("/");
    let d = s_date[0],
      m = s_date[1],
      y = s_date[2];
    if (d.length == 1 || d.length == 2) {
      format = "D".repeat(d.length) + "/";
    }
    if (m.length == 1 || m.length == 2) {
      format += "M".repeat(m.length) + "/";
    }
    if (y.length == 2 || y.length == 4) {
      format += "Y".repeat(y.length);
    }
    return format;
  }

  /*
   * Created By : Priyadharshini
   * Description : To validate Excel field values
   *********************************************/
  async excelFieldValidation() {
    this.sampleData = [];
    let sampleArray = [];
    if (this.excelData.length == 0) {
      this.sampleData.push({
        statusmsg: this.failureTxt,
        statusreason: "No data Available",
      });
      this.excelData = this.sampleData;
      return false;
    }
    for (let x = 0; x < this.excelData.length; x++) {
      let tempAry = {};
      let sampleAry = {};
      let errorMsg = "";

      for (let y = 0; y < this.excelHeaders.length; y++) {
        let headerName = this.excelHeaders[y];
        let headerFlag = 0;
        // let voyageName = await this.commonService.removeVoyageDesc(this.voyageName);
        if (headerName == "Insured Name") {
          if (
            this.excelData[x][headerName] != "" &&
            this.excelData[x][headerName] != undefined
          ) {
            this.excelData1[y].isMandatory = true;
            this.excelData1[y + 1].isMandatory = true;
            this.excelData1[y + 4].isMandatory = true;
          } else {
            this.excelData1[y].isMandatory = false;
            this.excelData1[y + 1].isMandatory = false;
            this.excelData1[y + 4].isMandatory = false;
          }
          if (this.addClientInCertificate.toLowerCase() == "no") {
            // Ticket no - 161061 upload excel changes
            let dateOfShipment: any =
              this.excelData[x]["Expected date of shipment (tooltip)"] + "";
            this.shipmentDate = Moment(dateOfShipment, "DD-MM-YYYY").format(
              "YYYY-MM-DD"
            );
            if (
              this.excelData[x][headerName] != "" &&
              this.excelData[x][headerName] != undefined
            ) {
              // Ticket no - 161061 upload excel changes
              await this.reAssignGcData();
              if(this.isEndorsementValue || this.defaultPolicyInsuredName.insured_name != undefined || this.defaultPolicyInsuredName.insured_name != ""){
						
		            if (this.excelData[x][headerName].toLowerCase() != this.defaultPolicyInsuredName?.insured_name.toLowerCase() || this.excelData[x]['Address1'].toLowerCase() != this.defaultPolicyInsuredName.insured_add1.toLowerCase() || this.excelData[x]['Address2'].toLowerCase() != this.defaultPolicyInsuredName.insured_add2.toLowerCase() || this.excelData[x]['Address3'].toLowerCase() != this.defaultPolicyInsuredName.insured_add3.toLowerCase() || this.excelData[x]['Pincode'].toLowerCase() != this.defaultPolicyInsuredName.insured_zipcode.toLowerCase())
		            {
						errorMsg +=
							"Insured Details does not match with policy data" + ",";
				}
			}
			else {console.log("6")
			if(  this.excelData[x][headerName]?.toLowerCase() !=

		this.defaultPolicyInsuredName.clientName.toLowerCase() ||

	  this.excelData[x]["Address1"]?.toLowerCase() !=

		this.defaultPolicyInsuredName.clientAdd1.toLowerCase() ||

	  this.excelData[x]["Address2"]?.toLowerCase() !=

		this.defaultPolicyInsuredName.clientAdd2.toLowerCase() ||

	  this.excelData[x]["Address3"]?.toLowerCase() !=

		this.defaultPolicyInsuredName.clientAdd3.toLowerCase() ||

	  this.excelData[x]["Pincode"]?.toLowerCase() !=

		this.defaultPolicyInsuredName.pincode?.toLowerCase()){
			console.log("7")
			errorMsg +=

			"Insured Details does not match with policy data" + ",";
		}
	}
			}
		}}
        /* else if(headerName=='Bill of Lading No./Airway Bill No.'){
					if(this.excelData[x][headerName] != '' && this.excelData[x][headerName] != undefined){
						this.excelData1[y+1].isMandatory = true
					}
					else{
						this.excelData1[y+1].isMandatory = false
					}
				} */
        if (
          headerName.toLowerCase() != "statusmsg" &&
          headerName.toLowerCase() != "statusreason"
        ) {
          if (headerName in this.excelData[x]) {
            headerFlag = 1;
            tempAry[this.excelHeadersKey[y]] = this.excelData[x][headerName];
            sampleAry[headerName] = this.excelData[x][headerName];
          } else {
            // already headerFlag is assigned to 0
            // headerFlag = 0;
            tempAry[this.excelHeadersKey[y]] =
              this.excelData[x][this.excelHeadersKey[y]];
            sampleAry[headerName] = this.excelData[x][this.excelHeadersKey[y]];
          }

          let paramData;
          if (headerFlag != 0) {
            paramData = this.excelData[x][headerName];
          } else {
            paramData = this.excelData[x][this.excelHeadersKey[y]];
          }
          let chkMandatory = this.excelData1[y].isMandatory;
          let fieldType = this.excelData1[y].dataType;
          if (chkMandatory == true && this.commonService.checkNull(paramData)) {
            errorMsg += headerName + " is Required" + ",";
          }
          if (headerName == "Bill of Lading Date/Airway Bill Date") {
            let value = this.excelData[x][headerName] + "";
            if (value && value.indexOf("/") > -1) {
              errorMsg += headerName + " should be DD-MM-YYYY" + ",";
            } else if (
              value != "" &&
              value != undefined &&
              value != "undefined"
            ) {
              let expiryDate =
                this.selectedDeclarationDetail.quote.data.gc_policy_end_date;
              let expiryDateValue = new Date(expiryDate + "T00:00:00");
              let dateOfShipment: any =
                this.excelData[x]["Expected date of shipment (tooltip)"] + "";
              let myMoment1: moment.Moment = moment(value, "DD-MM-YYYY");
              var date = new Date(myMoment1.format("YYYY-MM-DD") + "T00:00:00");
              if (date + "" == "Invalid Date") {
                errorMsg += headerName + " should be Date,";
              }
              if (dateOfShipment && dateOfShipment.indexOf("/") > -1) {
                errorMsg +=
                  "Expected date of shipment (tooltip) should be DD-MM-YYYY" +
                  ",";
              } else {
                const obj = {
                  expected_date_shipment: { value: dateOfShipment },
                  voyage_name: { value: this.voyageName },
                  sub_voyage_type: { value: this.subVoyageName },
                };
                await this.reAssignGcData(obj);
                let myMoment: moment.Moment = moment(
                  dateOfShipment,
                  "DD-MM-YYYY"
                );
                let dateOfShipmentValue = new Date(
                  myMoment.format("YYYY-MM-DD") + "T00:00:00"
                );

                if (dateOfShipmentValue + "" == "Invalid Date") {
                  errorMsg += "Expected date of shipment should be Date,";
                }
                if (date < dateOfShipmentValue || date > expiryDateValue) {
                  errorMsg +=
                    headerName +
                    " should be Less Than Expiry date and Greater Than or Equal to Shipment Date" +
                    ",";
                }
                const minIssueDate = this.minIssueDate.toISOString();
                const maxIssueDate = this.maxIssueDate.toISOString();
                if (
                  dateOfShipmentValue < minIssueDate ||
                  dateOfShipmentValue > maxIssueDate
                ) {
                  errorMsg +=
                    "Expected date of shipment should be Less Than Expiry date and Greater Than Inception Date" +
                    ",";
                }
              }
            }
          }
          if (headerName == "From Country") {
            let count = 0;
            // let name =voyageName+'-'+this.subVoyageName;
            /* let fromCountry = this.fromCountryList[name]+''; */
            let fromCountryArray = this.fromCountryDetails;
            for (let i = 0; i < fromCountryArray.length; i++) {
              if (
                fromCountryArray[i].toLowerCase() ==
                this.excelData[x][headerName].toLowerCase()
              )
                count++;
            }

            if (count == 0) {
              if (fromCountryArray.length == 1)
                errorMsg +=
                  "For " +
                  this.subVoyageName +
                  " " +
                  headerName +
                  " is " +
                  fromCountryArray +
                  ",";
              else
                errorMsg +=
                  "For " +
                  this.subVoyageName +
                  " Entered From Country Should not be mapped " +
                  ",";
            }
          } else if (headerName == "To Country") {
            let count = 0;
            // let name =voyageName+'-'+this.subVoyageName;
            /* let fromCountry = this.fromCountryList[name]+''; */
            let fromCountryArray = this.fromCountryDetails;
            /* let toCountry = this.toCountryList[name]+''; */
            let toCountryArray = this.toCountryDetails;
            for (let i = 0; i < toCountryArray.length; i++) {
              if (
                toCountryArray[i].toLowerCase() ==
                this.excelData[x][headerName].toLowerCase()
              )
                count++;
            }
            if (count == 0) {
              if (toCountryArray.length == 1)
                errorMsg +=
                  "For " +
                  this.subVoyageName +
                  " " +
                  headerName +
                  " is " +
                  toCountryArray +
                  ",";
              else if (fromCountryArray.length == 1)
                errorMsg +=
                  "For " +
                  this.subVoyageName +
                  " " +
                  headerName +
                  " is other than " +
                  fromCountryArray +
                  ",";
              else
                errorMsg +=
                  headerName +
                  " should not be mapped against this " +
                  this.subVoyageName +
                  ",";
            }
          }
          if (headerName == "Mode of Shipment") {
            let array = this.modeOfConveyance.split(",");
            let count = 0;
            if (
              this.excelData[x][headerName] != "" &&
              this.excelData[x][headerName] != undefined
            ) {
              for (let i = 0; i < array.length; i++) {
                if (array[i].trim() != this.excelData[x][headerName].trim())
                  count++;
              }
            }
            if (array.length == count)
              errorMsg +=
                headerName +
                " should be one of these " +
                this.modeOfConveyance +
                ".,";
          }
          if (headerName == "Invoice currency Type") {
            let currencyArray = [];
            let count = 0;
            for (let i = 0; i < this.totalRoeDetails.length; i++) {
              if (currencyArray.length == 0) {
                currencyArray.push(this.totalRoeDetails[i].from_currency);
              } else {
                count = 0;
                for (let j = 0; j < currencyArray.length; j++) {
                  if (currencyArray[j] == this.totalRoeDetails[i].from_currency)
                    count++;
                }
                if (count == 0)
                  currencyArray.push(this.totalRoeDetails[i].from_currency);
              }
            }
            let totalCount = 0,
              currencyCount = 0;
            totalCount = currencyArray.length;
            for (let k = 0; k < currencyArray.length; k++) {
              if (this.excelData[x][headerName] != currencyArray[k]) {
                currencyCount++;
              }
            }
            if (totalCount == currencyCount)
              errorMsg += headerName + " should be valid currency type" + ",";
          }
          if (headerName == "Invoice Date") {
            var value1: any = this.excelData[x][headerName] + "";
            let myMoment: moment.Moment = moment(value1, "DD-MM-YYYY");
            let invoiceDate = new Date(
              myMoment.format("YYYY-MM-DD") + "T00:00:00"
            );
            const minIssueDate = this.minIssueDate.toISOString();
            const maxIssueDate = this.maxIssueDate.toISOString();
            if (invoiceDate + "" == "Invalid Date") {
              errorMsg += "Invoice Date should be Date,";
            } else if (value1.indexOf("/") > -1) {
              errorMsg += headerName + " should be DD-MM-YYYY,";
            } else if (
              invoiceDate < minIssueDate ||
              invoiceDate > maxIssueDate
            ) {
              errorMsg +=
                "Invoice Date should be Less Than Expiry date and Greater Than Inception Date" +
                ",";
            }
          }
          if (headerName == "Cargo value as per Invoice currency") {
            let value = Number(this.excelData[x][headerName]);
            //let value = this.excelData[x][headerName];
            if (isNaN(value) == true) {
              errorMsg += headerName + " should be " + fieldType + ",";
            }
            if (value < 0) {
              errorMsg += headerName + " should be greater than 0,";
            }
          }
          if (headerName == "Duty Sum Insured in INR") {
            let value = this.excelData[x][headerName];
            if (value != "" && value != undefined) {
              this.excelData1[y].dataType = "Numeric";
              fieldType = this.excelData1[y].dataType;
            } else {
              this.excelData1[y].dataType = "";
              fieldType = this.excelData1[y].dataType;
            }
          }

          // Consignee Address Validation changes start : Ticket no - 151387
          if (headerName === "Consignee Add") {
            let value = this.excelData[x][headerName];
            console.log(value);
            console.log(value.length);
            if (value != "" && value != undefined && value?.length > 300) {
              errorMsg += headerName + " should be less than 300 characters,";
            }
          }
          // Consigness Address Validation changes end

          if (
            ((fieldType.toLowerCase() == "numeric" && isNaN(paramData)) ||
              (fieldType.toLowerCase() == "varchar" && !isNaN(paramData)) ||
              (fieldType.toLowerCase() == "alphanumeric" &&
                !this.commonService.freeTextPattern.test(
                  this.excelData[x][headerName]
                ))) &&
            (this.excelData1[y].isMandatory
              ? this.commonService.checkNull(paramData)
              : !this.commonService.checkNull(paramData))
          ) {
            errorMsg += headerName + " should be " + fieldType + ",";
          }
        }
      }
      if (!this.commonService.checkNull(errorMsg)) {
        errorMsg = errorMsg.substring(0, errorMsg.length - 1);
        tempAry["statusreason"] = errorMsg;
        tempAry["statusmsg"] = this.failureTxt;
        sampleAry["statusmsg"] = this.failureTxt;
        sampleAry["statusreason"] = errorMsg;
      } else {
        tempAry["statusmsg"] = this.successTxt;
        tempAry["statusreason"] = "-";
        sampleAry["statusmsg"] = this.successTxt;
        sampleAry["statusreason"] = "-";
      }
      sampleArray.push(sampleAry);
      this.sampleData.push({ ...this.excelData[x], ...tempAry });
    }
    this.excelData = [];
    this.excelData = this.sampleData;
    this.sampleExcelData = sampleArray;
    if (this.excelData.length > 1)
      this.excelData.sort(function (a, b) {
        return a["date_Of_Shipment"].localeCompare(b["date_Of_Shipment"]);
      });
    let chkFlag: boolean = false;
    for (var t = 0; t < this.excelData.length; t++) {
      let statusDetail = this.excelData[t].statusmsg;
      if (statusDetail.toLowerCase() != "success") {
        chkFlag = true;
        break;
      }
    }
    if (!chkFlag) {
      return true;
    } else {
      return false;
    }
  }
  /*
   * Created By : Priyadharshini
   * Description : Excel file size and extension validation.
   *********************************************/
  async onFileChange(event) {
    //this.excelData = [];
    this.submitted = true;
    this.docDetails = {};
    const file = event.target.files[0]; // <--- File Object for future use.
    let workBook = null;
    const reader = new FileReader();
    reader.onload = () => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: "binary" });
      let firstsheet = workBook.SheetNames[0];
      const sheet = workBook.Sheets[firstsheet];
      let xlsxData = XLSX.utils.sheet_to_json(sheet, { raw: false });
      xlsxData = xlsxData || [];
      this.excelData = xlsxData;
      if (xlsxData.length) {
        this.excelData = [];
        for (const obj of xlsxData) {
          this.excelData.push({
            statusmsg: "",
            statusreason: "",
            "Insured Name": "",
            Address1: "",
            Address2: "",
            Address3: "",
            Pincode: "",
            "Mode of Shipment": "",
            "From Country": "",
            "To Country": "",
            "From-City": "",
            "To-City": "",
            "Invoice currency Type": "",
            "Cargo value as per Invoice currency": "",
            "ROE (Rate of exchange)": "",
            "Duty Sum Insured in INR": "",
            "Expected date of shipment (tooltip)": "",
            "Bill of Lading No./Airway Bill No.": "",
            "Bill of Lading Date/Airway Bill Date": "",
            "Letter of Credit No.": "",
            "Letter of Credit Description/Special Terms": "",
            "Place of Issuance": "",
            "Invoice Number": "",
            "Invoice Date": "",
            "Subject Matter Insured": "",
            "Marks & Numbers": "",
            "Vessel Name or Flight No/Airline": "",
            "Consignee Name": "",
            "Consignee Add": "",
            "Financier Name": "",
            ...(obj as {}),
          });
        }
      }
    };
    reader.readAsBinaryString(file);
    this.uploadCertificate.controls.file.setValue(file ? file : "");
    if (
      !event ||
      !event.target ||
      !event.target.files ||
      event.target.files.length === 0
    ) {
      return;
    }
    const name = event.target.files[0].name;
    const lastDot = name.lastIndexOf(".");
    const ext = name.substring(lastDot + 1);
    this.docDetails = {
      file_name: name,
      file_ext: ext,
    };
    let fileSize = event.target.files[0].size;
    if (fileSize / 1024 / 1024 <= 5) {
      if (this.allowedFileExt.indexOf(ext.toLowerCase()) === -1) {
        this.uploadCertificate.controls.file.setErrors({
          file_extension: true,
        });
      }
    } else if (fileSize / 1024 / 1024 > 5) {
      this.uploadCertificate.controls.file.setErrors({ file_size: true });
    }
  }
  /*
   * Created By : Priyadharshini
   * Description : Export Excel.
   *********************************************/
  exportAsExcel() {
    /* let exlAry = [];
		for (var t = 0; t < this.excelData.length; t++) {
			let statusDetail = this.excelData[t].statusmsg;
			if (statusDetail.toLowerCase() != 'success') {
				exlAry.push(this.excelData[t]);
			}
    } */
    this.excelService.exportExcel(
      this.sampleExcelData,
      "Certificate_Template.xlsx"
    );
  }
  /*
   * Created By : Vishnuraj
   * Description : Convert excel values into certificate.
   *********************************************/
  async convertExcelToCertificate(item) {
    const quoteId = this.isDraftMode
      ? this.selectedDeclarationDetail.quote_id
      : "";
    const policyId = this.isDraftMode
      ? this.selectedDeclarationDetail.policy_id
      : "";
    const subVoyageAry = this.isCloneMode
      ? await this.getSubVoyageAry(
          this.cloneMasterPolicyDetails.data.sub_voyage
        )
      : this.isDraftMode
      ? {
          certificate_bulk: "certificate",
          back_date_days:
            this.selectedDeclarationDetail.quote.data.backdate_days,
          bov_percentage:
            this.selectedDeclarationDetail.quote.data.bov_percentage,
          certificate_allowed:
            this.selectedDeclarationDetail.quote.data.certificate_allowed,
          id: this.selectedDeclarationDetail.quote.data.sub_voyage_id,
          days_post_expiry:
            this.selectedDeclarationDetail.quote.data.days_post_expiry,
          sub_voyage_name:
            this.selectedDeclarationDetail.quote.data.sub_voyage_name,
          min_shipment_premium:
            this.selectedDeclarationDetail.quote.data.min_shipment_premium,
          mode_of_conveyance:
            this.selectedDeclarationDetail.quote.data.mode_of_conveyance,
          coverage_type:
            this.selectedDeclarationDetail.quote.data.coverage_type,
          marine_final_rate_percentage:
            this.selectedDeclarationDetail.quote.data
              .marine_final_rate_percentage,
          transit_excess_in_certificate:
            this.selectedDeclarationDetail.quote.data
              .transit_excess_in_certificate,
        }
      : await this.getSubVoyageAry(
          this.selectedDeclarationDetail.data.sub_voyage
        );
    // this.isCloneMode ? this.selectedDeclarationDetail.cust_fld_3 : this.selectedDeclarationDetail.quote.cust_fld_3
    const additionFields = {
      Certificate_Bulk: "certificate",
      certificate_bulk: "certificate",
      backdate_days: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.back_date_days
        : subVoyageAry.back_date_days,
      bov_percentage: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.bov_percentage
        : subVoyageAry.bov_percentage,
      bulk_declaration_type: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.bulk_declaration_type
        : subVoyageAry.bulk_declaration_type,
      certificate_allowed: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.certificate_allowed
        : subVoyageAry.certificate_allowed,
      cust_fld_1: this.declarationForm.controls.tp_policy_no.value,
      cust_fld_2: "certificate",
      cust_fld_3:
        this.isCloneMode || this.isDraftMode
          ? this.selectedDeclarationDetail.quote.cust_fld_3
          : this.selectedDeclarationDetail.policy_no,
      cust_fld_4: subVoyageAry.id,
      cust_fld_9:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.pol_voyage
          : await this.commonService.getVoyageDesc(
              this.selectedDeclarationDetail.quote.data.voyage
            ),
      cust_fld_8: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.policy_ref_num
        : this.selectedDeclarationDetail.quote.data.policy_ref_num,
      sub_voyage_id: subVoyageAry.id,
      days_post_expiry: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.days_post_expiry
        : subVoyageAry.days_post_expiry,
      declaration_type: "certificate",
      master_policy_no:
        this.isCloneMode || this.isDraftMode
          ? this.selectedDeclarationDetail.quote.cust_fld_3
          : this.selectedDeclarationDetail.policy_no,
      mode_of_conveyance: item.mode_of_shipment,
      nstpyn: this.uwRefferralReasons.length ? "Yes" : "No",
      per_seeding_limit: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.per_seeding_limit
        : subVoyageAry.per_seeding_limit,
      pol_back_days: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_back_days
        : subVoyageAry.back_date_days,
      pol_bov: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_bov
        : subVoyageAry.bov_percentage,
      pol_bulk_decl_type: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_bulk_decl_type
        : subVoyageAry.bulk_declaration_type,
      pol_certificate_allowed_yn: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_certificate_allowed_yn
        : subVoyageAry.certificate_allowed,
      pol_certificate_bulk: "certificate",
      pol_end_date: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.gc_policy_end_date
        : this.selectedDeclarationDetail.quote.data.gc_policy_end_date,
      pol_marine_rate: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_marine_rate
        : this.isCloneMode
        ? this.selectedDeclarationDetail.quote.data.marine_final_rate_percentage
        : subVoyageAry.marine_final_rate_percentage,
      pol_mode_conveyance: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_mode_conveyance
        : item.mode_of_shipment,
      pol_policy_currency: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.policy_currency_type
        : this.selectedDeclarationDetail.quote.data.policy_currency_type,
      pol_policy_no: this.declarationForm.controls.tp_policy_no.value,
      pol_policy_type: this.selectedDeclarationDetail.quote.data.policy_type,
      pol_post_days: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_post_days
        : subVoyageAry.days_post_expiry,
      pol_psl: this.selectedDeclarationDetail.pol_psl,
      pol_si:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.pol_si
          : this.selectedDeclarationDetail.quote.data.voyage
              .initial_sum_insured,
      pol_start_date: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.gc_policy_start_date
        : this.selectedDeclarationDetail.quote.data.gc_policy_start_date,
      pol_sub_voyage: this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.pol_sub_voyage
        : subVoyageAry.sub_voyage_name,
      pol_tax: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.tax_applicable
        : this.selectedDeclarationDetail.quote.data.tax_applicable,
      pol_voyage:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.pol_voyage
          : await this.commonService.getVoyageDesc(
              this.selectedDeclarationDetail.quote.data.voyage
            ),
      policy_id: policyId,
      policy_type: this.selectedDeclarationDetail.quote.data.policy_type,
      premium_value: this.selectedDeclarationDetail.quote.data.premium_value,
      product_id: this.commonVariablesService.declarationProductId,
      quote_id: quoteId,
      sum_insured_percentage:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.sum_insured_percentage
          : this.selectedDeclarationDetail.quote.data.si_percentage,
      tax_amount: this.isCloneMode
        ? this.cloneMasterPolicyDetails.quote.data.tax_applicable
        : this.selectedDeclarationDetail.quote.data.tax_applicable,
      tax_applicable: await this.commonService.taxApplicableStatus(
        this.pageContent == 2 && this.header.nav_to == ""
          ? this.selectedDeclarationDetail.quote.data.tax_applicable
          : this.isCloneMode
          ? this.cloneMasterPolicyDetails.quote.data.tax_applicable
          : this.selectedDeclarationDetail.quote.data.tax_applicable
      ),
      portal_lock_date: this.isCloneMode
        ? this.cloneMasterPolicyDetails.data.portal_lock_date
        : this.isDraftMode
        ? this.selectedDeclarationDetail.quote.data.portal_lock_date
        : this.selectedDeclarationDetail.data.portal_lock_date,
      __finalize: 0,
      referral_remark: this.referralRemarksVal,
      min_shipment_premium: subVoyageAry.min_shipment_premium,
      transit_excees:
        this.isDraftMode || this.isCloneMode
          ? this.selectedDeclarationDetail.quote.data.transit_excees
          : this.selectedDeclarationDetail.quote.data.voyage.transit_excees,
      transit_excess_in_certificate: subVoyageAry.transit_excess_in_certificate,
      // policy_start_date: this.datePipe.transform(this.minIssueDate, 'yyyy-MM-dd'),
      policy_start_date: this.datePipe.transform(
        new Date(
          Moment(item.date_Of_Shipment, "DD/MM/YYYY").format("YYYY-MM-DD")
        ),
        "yyyy-MM-dd"
      ),
      policy_end_date: this.datePipe.transform(this.maxIssueDate, "yyyy-MM-dd"),
    };

    let paramData = {};
    /* const extrakeys = {
		  duty_premium: (this.declarationForm.controls.duty_premium.value && this.declarationForm.controls.duty_premium.value != '-') ? this.declarationForm.controls.duty_premium.value : 0,
		  duty_si: item.duty_Sum_Insured
		} */
    //Certificate Stage quote issue
    const extrakeys = {
      duty_premium:
        this.declarationForm.controls.duty_premium.value &&
        this.declarationForm.controls.duty_premium.value != "-"
          ? this.declarationForm.controls.duty_premium.value
          : "0",
      duty_si: item.duty_Sum_Insured ? parseFloat(item.duty_Sum_Insured) : 0,
    };
    /* console.log(item.billing_Date?Moment(item.billing_Date, "DD/MM/YYYY").format("YYYY-MM-DD"):'') */
    this.declarationForm.patchValue({
      bill_date: item.billing_Date
        ? Moment(item.billing_Date, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "",
      cargo_value: item.cargo_Value,
      expected_date_shipment: Moment(
        item.date_Of_Shipment,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD"),
      duty_si: item.duty_Sum_Insured,
      from_city: item.from_City,
      from_country: item.from_Country,
      //from_city_country: item.from_City + "," + item.from_Country,
      invoice_currency: item.invoice_Currency_Type,
      invoice_date: Moment(item.invoice_Date, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      ),
      invoice_no: item.invoice_No,
      mode_of_shipment: item.mode_of_shipment,
      //roe: item.roe,
      subject_matter_insured: item.subject_Matter_Insured,
      to_city: item.to_City,
      to_country: item.to_Country,
      //to_city_country: item.to_City + "," + item.to_Country,
      bill_no: item.billng_No,
      consignee_address: item.consignee_Address,
      consignee_name: item.consignee_Name,
      lc_details: item.credit_Description,
      lc_no: item.credit_Number,
      financier_name: item.financier_Name,
      marks_numbers: item.marks_Numbers,
      vessel_name: item.vessel_Name,
    });
    this.declarationForm.get("to_country").updateValueAndValidity();
    this.claimsPay();
    if (
      !!item.insured_Name &&
      subVoyageAry.client_in_certificate.toLowerCase() == "yes"
    ) {
      if (this.isNewClientApplicable) {
        let brokerCount = 0;
        for (let i = 0; i < this.totalBrokerDetails.length; i++) {
          if (
            this.totalBrokerDetails[i].insured_name == item.insured_Name ||
            this.totalBrokerDetails[i].broker_name == item.insured_Name
          )
            brokerCount++;
        }
        this.declarationForm.patchValue({
          add_new_client: "yes",
          client_name: item.insured_Name,
          client_address_1: item.address1,
          client_address_2: item.address2,
          client_address_3: item.address3,
          client_pincode: item.pincode,
        });
        if (brokerCount == 0) {
          await this.addNewClient();
          await this.newClientPincode("", item.pincode + "");
          this.declarationForm.patchValue({
            new_insured_pincode: item.pincode,
          });
          if ((await this.getLocation(true)) == false) {
            return "Invalid pincode";
          }
        }
      }
    }
    let roe = await this.checkRoe(item);
    if (roe != true) {
      return "Invalid ROE";
    }
    /**PSL HERE */
    let psl_res = await this.calculateCertificatePremium();
    if (psl_res != true) {
      return psl_res;
    }
    /* Get Insured Clause */
    const insureClauseUrl = `${this.commonVariablesService.baseURL}api/v1/marine_master/fetchall/insuring_clause_and_condition`;
    const params = {
      mode_of_conveyance: this.declarationForm.controls.mode_of_shipment.value,
      sub_voyage_name: this.declarationForm.controls.sub_voyage_type.value,
      voyage_name: await this.commonService.removeVoyageDesc(
        this.declarationForm.controls.voyage_name.value
      ),
      policy_type: this.selectedDeclarationDetail.quote.data.policy_type,
      coverage_type: this.declarationForm.controls.coverage_type.value,
    };
    let insuring_clause_and_condition = "";
    const insureResponse = await this.commonService.httpGetMethod(
      insureClauseUrl,
      "application/x-www-form-urlencoded; charset=UTF-8",
      true,
      params,
      "Declaration",
      this.impersonateFlag
    );
    if (insureResponse.status == 0) {
      insuring_clause_and_condition = insureResponse.data.length
        ? insureResponse.data[0].insuring_clause_and_condition || ""
        : "";
    } else if (insureResponse.status != -114) {
      this.commonService.errorsmsg(
        insureResponse.txt || "Unable to get insuring clause",
        ""
      );
    }

    /* Get common insuring clause */
    await this.getCommonInsuringClause();
    insuring_clause_and_condition += `\n${this.commonInsuringClause}`;
    if (!!item.place_Of_Issuance) {
      this.declarationForm.patchValue({
        issuance_place: item.place_Of_Issuance,
      });
    }
    if (!!item.roe) {
      this.declarationForm.patchValue({
        roe: item.roe,
      });
    }
    paramData = {
      ...additionFields,
      ...this.declarationForm.getRawValue(),
      ...extrakeys,
      ...{ insuring_clause_and_condition: insuring_clause_and_condition },
      expected_date_shipment: this.datePipe.transform(
        this.f.expected_date_shipment.value,
        "yyyy-MM-dd"
      ),
      bill_date: this.datePipe.transform(this.f.bill_date.value, "yyyy-MM-dd"),
      invoice_date: this.datePipe.transform(
        this.f.invoice_date.value,
        "yyyy-MM-dd"
      ),
      issue_date: this.datePipe.transform(
        this.f.issue_date.value,
        "yyyy-MM-dd"
      ),
    };

    /* Need to remove 'extraKeys' after insillion issue fixed */
    const isCountry =
      this.uwRefferralReasons.indexOf(this.countryRefMsg) > -1 ? 1 : undefined;
    const isShipment =
      this.uwRefferralReasons.indexOf(this.backDationMsg) > -1 ? 1 : undefined;
    const isPsl =
      this.uwRefferralReasons.indexOf(this.pslMsg) > -1 ? 1 : undefined;
    let extraKeys = {
      is_country_referral: isCountry,
      is_shipmentdate_below_backdate: isShipment,
      is_psl_exceeds: isPsl,
    };

    extraKeys = JSON.parse(JSON.stringify(extraKeys));
    paramData = { ...paramData, ...extraKeys };
    let count = 0;
    for (let i = 0; i < this.totalBrokerDetails.length; i++) {
      if (
        this.totalBrokerDetails[i].insured_name == item.insured_Name ||
        this.totalBrokerDetails[i].broker_name == item.insured_Name
      )
        count++;
    }
    /* if(){ */
    let defaultNewClientCalled = false,
      defaultNewClientParam;

    if (
      !!item.insured_Name &&
      subVoyageAry.client_in_certificate.toLowerCase() == "yes" &&
      count == 0
    ) {
      let id = "";
      for (const data of this.totalBrokerDetails) {
        if (
          data.producer_name ==
          this.declarationForm.get("new_insured_name").value
        )
          id = data.producer_code;
      }
      const defaultNewClientUrl = `${this.commonVariablesService.baseURL}api/v1/marine_mp_gc_data/insured`;
      defaultNewClientParam = {
        policy_number: this.policyNumber,
        policy_ref_num: this.selectedDeclarationDetail.cust_fld_3,
        insured_id: id,
        insured_name: item.insured_Name,
        insured_add1: item.address1,
        insured_add2: item.address2,
        insured_add3: item.address3,
        insured_city: this.declarationForm.get("new_insured_city").value,
        insured_state: this.declarationForm.get("new_insured_state").value,
        insured_country: this.declarationForm.get("new_insured_country").value,
        insured_zipcode: this.declarationForm.get("new_insured_pincode").value,
        insured_gstin: this.declarationForm.get("new_insured_gstin").value,
        insured_district: this.declarationForm.get("new_insured_district")
          .value,
        certificate_number: "",
      };
      if (
        (defaultNewClientParam.insured_city || "") == "" ||
        (defaultNewClientParam.insured_state || "") == "" ||
        (defaultNewClientParam.insured_country || "") == "" ||
        (defaultNewClientParam.insured_district || "") == ""
      ) {
        return "invalid pincode";
      }
      defaultNewClientCalled = true;
      /* let defaultNewClientResponse = await this.commonService.httpPostMethod(defaultNewClientUrl, defaultNewClientParam, 'application/json', true, 'Declaration', this.impersonateFlag)
      if (defaultNewClientResponse.body.status != 0) {
        return (defaultNewClientResponse.body.txt);
      } */
    }

    await this.spinner.show();
    let tmpParam = await this.insuringClauseParam();
    let paramMany = {
      insureClauseParam: tmpParam,
      defaultNewClientCalled: defaultNewClientCalled,
      defaultNewClientParam: defaultNewClientParam ? defaultNewClientParam : "",
      quoteParam: paramData,
    };
    let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/client_user_for_certificate/convertExcelToCertificate?productname=emarine`;
    let quoteResponse = await this.commonService.httpPostMethod(
      url,
      paramMany,
      "application/json",
      true,
      "Declaration"
    );
    // const quoteResponse = await this.commonService.httpPostMethod(this.quoteUrl, paramData, 'application/json', true, 'Declaration', this.impersonateFlag);

    if (quoteResponse.body.status == -114) {
      // await this.closeModal();
      await this.spinner.hide();
      return "Token Expired";
    }
    if (quoteResponse.body.status == 0) {
      await this.spinner.hide();

      if (quoteResponse.body.data.isNstpEnabledFromRes) {
        this.isShowGenerateCertificate = false;
        return "Policy is assigned to Underwriter (NSTP CASE)";
      } else {
        this.isShowGenerateCertificate = true;
        this.selectedDeclarationDetail = quoteResponse.body.data.quoteRes;
        /* let header = JSON.parse(sessionStorage.getItem('declaration-header') || '{}'); */
        let header = JSON.parse(
          window.localStorage.getItem("declaration-header") || "{}"
        );
        header.tp_policy_no =
          this.selectedDeclarationDetail.quote.cust_fld_1 || "";
        header.insured_name = !!item.insured_Name
          ? item.insured_Name
          : this.selectedDeclarationDetail.quote.data.client_name || "";
        header.insured_city = !!item.insured_Name
          ? this.declarationForm.get("new_insured_city").value
          : this.selectedDeclarationDetail.quote.data.insured_branch || "";
        header.policy_id = this.selectedDeclarationDetail.policy_id || "";
        header.quote_id = this.selectedDeclarationDetail.quote_id || "";
        header.policy_no =
          this.selectedDeclarationDetail.quote.cust_fld_3 || "";
        header.header_policy =
          this.selectedDeclarationDetail.quote.cust_fld_1 || "";
        header.nav_to = "acc_del_draft";
        header.certificate_status = "";
        /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
        window.localStorage.setItem(
          "declaration-header",
          JSON.stringify(header)
        );
        //await this.closeModal();
        //this.gotoPageContent(3);

        return await this.payment(this.selectedDeclarationDetail);
      }
    } else {
      await this.spinner.hide();
      let tmpError = (quoteResponse.body.txt || "").split("~");
      this.commonService.errorsmsg(tmpError[1] || quoteResponse.body.txt, "");
      return tmpError[1] || quoteResponse.body.txt;
      //await this.closeModal();
    }
  }
  /*
   * Created By : Vishnuraj
   * Description : Save. new Client
   *********************************************/
  async excelToSaveNewClient(item) {
    const newClientUrl = `${this.commonVariablesService.baseURL}api/v1/transact/brokerClientInsert`;
    const paramData = {
      role: "client",
      producer_code: this.selectedDeclarationDetail.quote.data.insured_id || "",
      producer_name: this.declarationForm.controls.new_insured_name.value || "",
      address_1:
        this.declarationForm.controls.new_insured_address_1.value || "",
      address_2:
        this.declarationForm.controls.new_insured_address_2.value || "",
      address_3:
        this.declarationForm.controls.new_insured_address_3.value || "",
      city: this.declarationForm.controls.new_insured_city.value || "",
      country: this.declarationForm.controls.new_insured_country.value || "",
      state: this.declarationForm.controls.new_insured_state.value || "",
      zipcode: this.declarationForm.controls.new_insured_pincode.value || "",
      gstin: this.declarationForm.controls.new_insured_gstin.value || "",
      active: "true",
      client: this.commonVariablesService.user_management_product,
      status: "true",
      lob: "marinecargo",
    };
    const response = await this.commonService.httpPostMethod(
      newClientUrl,
      paramData,
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );
    if (response.body.status == 0) {
      // this.commonService.successmsg(response.txt, '');
    } else if (response.body.status != -114) {
      this.commonService.errorsmsg(response.body.txt || this.errorMsg, "");
    }
  }

  /*
   * Created By : Vishnuraj
   * Description : Load Table data.
   *********************************************/
  async completedTableContent(file) {
    let resp = await this.loadDraftCertificateList(this.policyNumber);
    for (let item = 0; item < this.certificateCompletedResult.length; item++) {
      this.certificateCompletedResult[item].data = resp.find((i) => {
        return (
          i.certificate_no == this.certificateCompletedResult[item].cert_no
        );
      });
    }
    if (file == "pdf") this.dtTrigger.next();
  }
  /*
   * Created By : Vishnuraj
   * Description : Load Draft Details.
   *********************************************/
  async loadDraftCertificateList(selectedPolicyNo) {
    let declarationData = { contentData: [] };
    this.spinner.show();
    const url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/list`;
    let policyRefNum = [];
    if ((this.header.policy_ref_num || "") != "") {
      policyRefNum.push(this.header.policy_ref_num);
    }

    let ref = window.localStorage.getItem("allPolicyrefNum");
    if (ref) {
      ref.split(",").forEach((value) => {
        policyRefNum.push(value);
      });
    }

    this.gcEndorsementDetails.forEach(function (value) {
      if (policyRefNum.indexOf(value.policy_ref_num) == -1)
        policyRefNum.push(value.policy_ref_num);
    });

    policyRefNum = policyRefNum.filter(function (item, pos) {
      return policyRefNum.indexOf(item) == pos;
    });

    const params = {
      gc_policy_no: selectedPolicyNo,
      declaration_type: "certificate",
      policy_ref_num: policyRefNum.toString(),
    };
    const response = await this.commonService.httpGetMethod(
      url,
      "application/json",
      true,
      params,
      "Declaration"
    );
    if (response.status != 0 && response.status != -114) {
      this.commonService.errorsmsg(
        "Unable to load generated draft and certificate list ",
        ""
      );
      return;
    }
    const responseData = [...response.data].reverse();
    this.spinner.show();
    for (const detailedPolicyData of responseData) {
      let statusData = await this.commonService.findCertificateStatus(
        detailedPolicyData
      );

      let validDate = new Date(detailedPolicyData.c_ts);
      validDate.setDate(validDate.getDate() + 7);
      const validUpto =
        statusData == "Draft"
          ? this.datePipe.transform(validDate, "dd-MM-yyyy")
          : "-";
      const endrosementData =
        (detailedPolicyData.endrosement || [])[
          detailedPolicyData.endrosement.length - 1
        ] || {};
      let sampledate = detailedPolicyData.quote.data.invoice_date;
      let myMoment: moment.Moment = moment(sampledate, "DD/MM/YYYY", true);
      let convertDate =
        myMoment["_d"] != "Invalid Date"
          ? this.datePipe.transform(myMoment["_d"], "dd-MM-yyyy")
          : "";
      declarationData.contentData.push({
        policy_no: `${selectedPolicyNo}`,
        certificate_date: this.datePipe.transform(
          detailedPolicyData.c_ts,
          "dd-MM-yyyy"
        ),
        certificate_no: detailedPolicyData.policy_no
          ? detailedPolicyData.quote.cust_fld_6
            ? detailedPolicyData.quote.cust_fld_6
            : detailedPolicyData.policy_no
          : detailedPolicyData.quote.cust_fld_5
          ? detailedPolicyData.quote.cust_fld_5
          : detailedPolicyData.quote_id,
        insured_name:
          (
            detailedPolicyData.quote.data.default_new_client || ""
          ).toLowerCase() == "yes"
            ? detailedPolicyData.quote.data.new_insured_name || "-"
            : detailedPolicyData.quote.data.insured_name ||
              detailedPolicyData.quote.data.broker_name ||
              "-",
        invoice_no: detailedPolicyData.quote.data.invoice_no,
        premium_amount: detailedPolicyData.quote.data.net_premium_final,
        sum_insured: detailedPolicyData.quote.data.total_si,
        status: statusData,
        quote_id: detailedPolicyData.quote_id,
        policy_id: detailedPolicyData.policy_id,
        master_policy_no: detailedPolicyData.master_policy_no,
        sub_voyage_id: detailedPolicyData.quote.data.sub_voyage_id,
        invoice_date: convertDate,
        issue_date: this.datePipe.transform(
          detailedPolicyData.quote.data.issue_date,
          "dd-MM-yyyy"
        ),
        valid_upto: validUpto,
        voyage_name: detailedPolicyData.quote.data.voyage_name,
        //is_original_downloaded: (JSON.stringify(endrosementData) == '{}') ? (((detailedPolicyData.data || {}).is_original_downloaded || '').toLowerCase() == 'yes') ? true : false : (((detailedPolicyData.data || {})[`is_${(endrosementData.endorsement_id || '')}_original_downloaded`] || '').toLowerCase() == 'yes') ? true : false,
        is_original_downloaded:
          (
            (detailedPolicyData.data || {}).is_original_downloaded || ""
          ).toLowerCase() == "yes"
            ? true
            : false,
        eproposal_id:
          JSON.stringify(endrosementData) == "{}"
            ? ""
            : endrosementData.eproposal_id || "",
        endorsement_id:
          JSON.stringify(endrosementData) == "{}"
            ? ""
            : endrosementData.endorsement_id || "",
        is_endorsement:
          (endrosementData.endorsement_id || "") == "" ? false : true,
      });
    }
    this.spinner.hide();
    return declarationData.contentData;
  }
  /*
   * Created By : Priyadharshini
   * Description : Download sample excel format.
   *********************************************/
  downloadSampleFormat() {
    const fileName = "certificate-generate-template.xlsx";
    const dwldSampleUrl = `./assets/excel/${fileName}`;
    window.open(dwldSampleUrl, "_blank"); //To download the Document in new Tab
  }

  /*
   * Created By : Sharann N
   * Description : to download the pdf.
   *********************************************/
  async showPDF(type, data) {
    this.spinner.show();
    let ret: any = await this.commonService.downloadPdf(type, data);
    if (ret.status == 0) {
      $("#certificateData").DataTable().destroy();
      await this.completedTableContent("pdf");
      this.spinner.hide();
    } else {
      this.commonService.errorsmsg(ret.data, "");
    }
  }
  /*
   * Created By : Sharann N
   * Description : form the settling agent field value.
   *********************************************/
  async formSettlingAgentName(agent_name) {
    const settling_agent = (agent_name || "").split(" - ");
    const settlingAgentDetails = this.totalCountryDetails.filter((value) => {
      return (
        (value.country_name || "").toLowerCase() ==
          settling_agent[0].toLowerCase() &&
        (value.city_name || "").toLowerCase() ==
          (settling_agent[2] || "").toLowerCase()
      );
    });
    const ret =
      settlingAgentDetails.length &&
      (settlingAgentDetails[0].city_name || "") != ""
        ? `${settling_agent[0] || "-"} (${
            settlingAgentDetails[0].city_name || "-"
          })`
        : `${settling_agent[0] || "-"}`;
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : check master policy is active or not.
   *********************************************/
  async checkMasterPolicy() {
    if (this.isMasterPolicyInactived) {
      this.commonService.errorsmsg("Master policy is deleted", "");
      this.spinner.hide();
      await this.closeModal();
      return true;
    }
    return false;
  }

  /*
   * Created By : Sharann N
   * Description : check master policy is active or not.
   *********************************************/
  async setMinMaxDate() {
    this.minIssueDate = await this.commonService.excelDateToJSDate(
      this.selectedDeclarationDetail.quote.data.pol_start_date
    );
    if (this.minIssueDate == "Invalid Date") {
      this.minIssueDate = new Date(
        this.selectedDeclarationDetail.quote.data.pol_start_date
      );
    }
    this.minIssueDate = new Date(
      this.datePipe.transform(this.minIssueDate, "yyyy-MM-dd") + "T00:00:00Z"
    );
    this.maxIssueDate = await this.commonService.excelDateToJSDate(
      this.selectedDeclarationDetail.quote.data.pol_end_date
    );
    if (this.maxIssueDate == "Invalid Date") {
      this.maxIssueDate = new Date(
        this.selectedDeclarationDetail.quote.data.pol_end_date
      );
    }
    this.maxIssueDate = new Date(
      this.datePipe.transform(this.maxIssueDate, "yyyy-MM-dd") + "T00:00:00Z"
    );
  }
  /*
   * Created By : Sharann N
   * Description : to close the modal without await.
   *********************************************/
  closeTempModal() {
    if (this.modalRef) {
      this.isShowSubmitButton = false;
      this.modalRef.hide();
    }
  }

  /*
   * Created By : Keerthana T
   * Description : to view the country master.
   *********************************************/
  viewCountryMaster() {
    var tmpCountryMasterArray = [];
    var tmpAllCountryMasterArray = [];
    var tmpCountryMasterObject = {};
    if (this.totalCountryDetails.length > 0) {
      for (let i = 0; i < this.totalCountryDetails.length; i++) {
        let count = 0;
        if (tmpAllCountryMasterArray.length == 0)
          tmpAllCountryMasterArray.push({
            Country: this.totalCountryDetails[i].country_name,
          });
        else {
          for (let j = 0; j < tmpAllCountryMasterArray.length; j++) {
            if (
              tmpAllCountryMasterArray[j].Country ==
              this.totalCountryDetails[i].country_name
            ) {
              count++;
            }
          }
          if (count == 0)
            tmpAllCountryMasterArray.push({
              Country: this.totalCountryDetails[i].country_name,
            });
        }
      }
      this.excelService.exportExcel(
        tmpAllCountryMasterArray,
        "Country_Master.xlsx"
      );
    }
    /* if (this.fromCountryDetails.length > 0 && this.toCountryDetails.length > 0) 
    {
      for (var i = 0; i < this.toCountryDetails.length; i++) 
      {
        tmpCountryMasterObject = {};
        tmpCountryMasterObject['From Country'] = this.fromCountryDetails[i]?this.fromCountryDetails[i]:"";
        tmpCountryMasterObject['To Country'] = this.toCountryDetails[i];
        
        tmpCountryMasterArray.push(tmpCountryMasterObject);
      }
      this.excelService.exportExcel(tmpCountryMasterArray, 'Country_Master.xlsx');
    } */
  }
  /*
   * Created By :Keerthana T
   * Description : to view the roe master.
   *********************************************/
  viewRoeMaster() {
    if (
      this.totalInvoiceCurrency.length > 0 &&
      this.totalRoeDetails.length > 0
    ) {
      let tmpArray = this.totalRoeDetails.filter((el) => {
        return this.totalInvoiceCurrency.some((f) => {
          return (
            f === el.from_currency && this.policyCurrencyType === el.to_currency
          );
        });
      });

      tmpArray = tmpArray.map((elm) => ({
        "Currency Type": elm.from_currency,
        "ROE Value": elm.roe_value,
      }));

      tmpArray.sort((a, b) =>
        a["Currency Type"] > b["Currency Type"]
          ? 1
          : b["Currency Type"] > a["Currency Type"]
          ? -1
          : 0
      );

      this.excelService.exportExcel(tmpArray, "Roe_Master.xlsx");
    }
  }
}
